import { TranslationMessages } from "ra-core";

const logisticsOrderReportFields = {
  orderId: "Auftrags-ID",
  orderNumber: "Auftragsnummer",
  orderDetails: "Auftrag öffnen",
  orderItemId: "Auftragspositions-ID",
  orderItemName: "Auftragsposition",
  status: "Status",
  recordType: "Datensatztyp",
  recordTypeName: "Datensatztyp (Formel)",
  activatedAt: "Aktiviert am",
  activatedDay: "Aktivierungsdatum",
  effectiveDate: "Auftragsdatum",
  plannedExecutionDate: "Geplantes Ausführungsdatum",
  shippingDate: "Versanddatum",
  expectedReturnDate: "Erwartete Rücksendung",
  completedDate: "Abschlussdatum",
  fulfilmentPartner: "Fulfilment-Partner",
  migrationBlock: "Migrationssperre",
  productName: "Produktname",
  productFamily: "Produktfamilie",
  shippingRecipient: "Versandempfänger",
  shippingStreet: "Versandstraße",
  shippingPostalCode: "Versand-PLZ",
  shippingCity: "Versandort",
  shippingCountryCode: "Versand-Ländercode",
  shippingAddress: "Versandadresse",
  accountName: "Accountname",
  accountShippingStreet: "Account: Versandstraße",
  accountShippingPostalCode: "Account: Versand-PLZ",
  accountShippingCity: "Account: Versandort",
  accountShippingCountryCode: "Account: Versand-Ländercode",
  opportunityName: "Opportunity",
  krankenkasse: "Krankenkasse",
  contactEmail: "E-Mail der Kontaktperson",
  assetProductSimTariff: "Asset: SIM-Tarif",
  trackingNumber: "Sendungsnummer",
  trackingNumberReturn: "Rücksende-Sendungsnummer",
  trackingFinal: "Sendungsverfolgung abgeschlossen",
  trackingCheckedOn: "Sendungsverfolgung geprüft am",
  exchangeReason: "Austauschgrund",
  additionalInformation: "Zusätzliche Informationen",
  tabletInventoryName: "Tablet-Inventar",
  hardwareSerialNumber: "Hardware-Seriennummer",
  imei: "IMEI",
  serialNumber: "Seriennummer",
  simInventoryName: "SIM-Inventar",
  assetTabletName: "Asset: Tablet-Inventar",
  assetTabletHardwareSerialNumber: "Asset: Tablet-Hardware-Seriennummer",
  assetTabletImei: "Asset: Tablet-IMEI",
  epPortalLink: "EP-Portal-Marker",
  manufacturer: "Hersteller",
};

const contractItemReportFields = {
  startDate: "Startdatum",
  endDate: "Enddatum",
  billingStartDate: "Abrechnungsbeginn",
  subscriptionWonDate: "Abo gewonnen am",
  cancellationDate: "Kündigungsdatum",
  createdDate: "Erstelldatum",
  testCreatedDate: "Test erstellt am",
  grossNetStatus: "Brutto-Netto-Status",
  productFamily: "Produktfamilie",
  productName: "Produktname",
  productGroup: "Produktgruppe",
  testStatus: "Teststatus",
  status: "Status",
  lostReason: "Verlustgrund",
  cancellationType: "Kündigungsart",
  cancellationStage: "Kündigungsphase",
  recordType: "Datensatztyp",
  contractRecordType: "Vertragsdatensatztyp",
  opportunityRecordType: "Opportunity-Datensatztyp",
  accountRecordType: "Account-Datensatztyp",
  accountName: "Accountname",
  contractAccountRecordType: "Account-Datensatztyp (Vertrag)",
  contractAccountName: "Accountname (Vertrag)",
  assetType: "Asset-Typ",
  price: "Preis",
  licenseActivated: "Lizenz aktiviert",
  inTrial: "In Testphase",
  createdByName: "Erstellt von",
  changedInto: "Geändert in",
  priceBookName: "Preisbuch",
  accountEmailCopy: "Account: E-Mail (Kopie)",
  accountTraegerIsKeyAccount: "Account: Träger ist Key Account",
  assetEmail: "Asset: E-Mail",
  assetName: "Asset",
  billingStarted: "Abrechnung gestartet",
  changedFromName: "Geändert von",
  changedIntoName: "Geändert in",
  contactPersonEmail: "E-Mail der Kontaktperson",
  contractBillingEmail: "Vertrag: Rechnungs-E-Mail",
  contractContactEmail: "Vertrag: E-Mail der Kontaktperson",
  contractId: "Vertrags-ID",
  contractLostReason: "Vertrag: Verlustgrund",
  contractName: "Vertragsname",
  contractNumber: "Vertragsnummer",
  contractRecordTypeName: "Vertrag: Datensatztyp",
  contractStartDate: "Vertragsbeginn",
  contractStatus: "Vertragsstatus",
  id: "Vertragspositions-ID",
  leadCreatedDate: "Lead erstellt am",
  licenseActivatedAt: "Lizenz aktiviert am",
  licenseManagerEmail: "E-Mail des Lizenzmanagers",
  lostDetails: "Verlustdetails",
  migratedFromName: "Opportunity: Migriert von",
  name: "Vertragspositionsname",
  opportunityContactLeadSource: "Opportunity: Lead-Quelle der Kontaktperson",
  opportunityKrankenkasse: "Opportunity: Krankenkasse",
  opportunityLeadSource: "Opportunity: Lead-Quelle",
  opportunityOwnerName: "Opportunity-Inhaber",
  opportunityPurchase: "Opportunity: Kauf",
  personAccountEmail: "Account: E-Mail des Personenaccounts",
  productId: "Produkt-ID",
  testEndDate: "Testende",
  testStartDate: "Testbeginn",
  trialPeriodDays: "Testphase (Tage)",
  winBackCallDone: "Winback-Anruf erledigt",
  withdrawalEndDate: "Widerrufsfrist endet",
  withdrawalPeriodDays: "Widerrufsfrist (Tage)",
};

export const germanMessages: TranslationMessages = {
  ra: {
    action: {
      add_filter: "Filter hinzufügen",
      add: "Neu",
      back: "Zurück",
      bulk_actions: "Ein Element ausgewählt |||| %{smart_count} Elemente ausgewählt",
      cancel: "Abbrechen",
      clear_array_input: "Liste löschen",
      clear_input_value: "Eingabe löschen",
      clone: "Klonen",
      confirm: "Bestätigen",
      create: "Erstellen",
      create_item: "%{item} erstellen",
      delete: "Löschen",
      edit: "Bearbeiten",
      export: "Exportieren",
      list: "Liste",
      refresh: "Neu laden",
      remove_filter: "Filter entfernen",
      remove_all_filters: "Alle Filter entfernen",
      remove: "Entfernen",
      save: "Speichern",
      search: "Suchen",
      select_all: "Alles auswählen",
      select_row: "Reihe auswählen",
      show: "Anzeigen",
      sort: "Sortieren",
      undo: "Rückgängig machen",
      unselect: "Abwählen",
      expand: "Erweitern",
      close: "Schließen",
      open_menu: "Menü öffnen",
      close_menu: "Menü schließen",
      update: "Aktualisieren",
      move_up: "Nach oben",
      move_down: "Nach unten",
      open: "Öffnen",
      toggle_theme: "Theme wechseln",
      select_columns: "Spalten",
      update_application: "Anwendung aktualisieren",
    },
    boolean: {
      true: "Ja",
      false: "Nein",
      null: " ",
    },
    page: {
      create: "%{name} erstellen",
      dashboard: "Dashboard",
      edit: "%{name} %{recordRepresentation}",
      error: "Etwas ist schiefgelaufen",
      list: "%{name}",
      loading: "Laden",
      not_found: "Nicht gefunden",
      show: "%{name} %{recordRepresentation}",
      empty: "Noch kein %{name}.",
      invite: "Neu erstellen?",
      access_denied: "Zugriff verweigert",
      authentication_error: "Authentifizierungsfehler",
    },
    input: {
      file: {
        upload_several: "Dateien hier ablegen, oder zum Auswählen klicken.",
        upload_single: "Dateien hier ablegen, oder zum Auswählen klicken.",
      },
      image: {
        upload_several: "Bilder hier ablegen, oder zum Auswählen klicken.",
        upload_single: "Bild hier ablegen, oder zum Auswählen klicken.",
      },
      references: {
        all_missing: "Die Daten der Referenz können nicht gefunden werden.",
        many_missing: "Mindestens eine Referenz scheint nicht mehr verfügbar zu sein.",
        single_missing: "Die Referenz scheint nicht mehr verfügbar zu sein.",
      },
      password: {
        toggle_visible: "Passwort verbergen",
        toggle_hidden: "Passwort einblenden",
      },
    },
    message: {
      about: "Über",
      are_you_sure: "Sind Sie sicher?",
      auth_error: "Bei der Validierung des Authentifizierungstokens ist ein Fehler aufgetreten.",
      bulk_delete_content:
        "Sicher, dass Sie %{name} löschen wollen? |||| Sicher, dass Sie diese %{smart_count} Elemente löschen wollen?",
      bulk_delete_title: "%{name} löschen |||| %{smart_count} %{name} löschen",
      bulk_update_content:
        "Sicher, dass Sie %{name} aktualisieren wollen? |||| Sicher, dass Sie %{smart_count} Elemente aktualisieren wollen?",
      bulk_update_title: "%{name} aktualisieren |||| %{smart_count} %{name} aktualisieren",
      clear_array_input: "Sicher, dass Sie die ganze Liste löschen wollen?",
      delete_content: "Sicher, dass Sie dieses Element löschen wollen?",
      delete_title: "%{name} #%{id} löschen",
      details: "Details",
      error: "Ein Fehler trat auf, Ihre Anfrage konnte nicht verarbeitet werden.",
      invalid_form: "Das Formular ist ungültig. Bitte überprüfen Sie Ihre Eingaben.",
      loading: "Die Seite wird geladen, noch einen Moment.",
      no: "Nein",
      not_found: "Sie eine falsche URL aufgerufen oder eingegeben.",
      yes: "Ja",
      unsaved_changes: "Einige Änderungen wurden nicht gespeichert. Sicher, dass Sie diese nicht übernehmen wollen?",
      access_denied: "Zugriff verweigert",
      authentication_error: "Authentifizierungsfehler",
    },
    navigation: {
      no_results: "Keine Ergebnisse gefunden.",
      no_more_results: "Es gibt keine Seite %{page}. Versuche eine vorherige.",
      page_out_of_boundaries: "Es gibt keine Seite %{page}.",
      page_out_from_end: "Es gibt keine Seite mehr nach dieser.",
      page_out_from_begin: "Es gibt keine Seite vor Seite 1.",
      page_range_info: "%{offsetBegin}-%{offsetEnd} von %{total}",
      partial_page_range_info: "%{offsetBegin}-%{offsetEnd} von mehr als %{offsetEnd}",
      current_page: "Seite %{page}",
      page: "Gehe zu Seite %{page}",
      first: "Gehe zur ersten Seite",
      last: "Gehe zur letzten Seite",
      next: "Gehe zur nächsten Seite",
      previous: "Gehe zur vorherigen Seite",
      page_rows_per_page: "Reihen pro Seite:",
      skip_nav: "Zum Inhalt springen",
      no_filtered_results: "Keine gefilterten Ergebnisse gefunden.",
      clear_filters: "Filter löschen",
    },
    sort: {
      sort_by: "Nach %{field} %{order} sortieren",
      ASC: "Aufsteigend",
      DESC: "Absteigend",
    },
    auth: {
      auth_check_error: "Bitte anmelden um fortzufahren",
      user_menu: "Profil",
      username: "Nutzername",
      password: "Passwort",
      sign_in: "Anmelden",
      sign_in_error: "Anmeldung fehlgeschlagen, bitte erneut versuchen.",
      logout: "Abmelden",
    },
    notification: {
      updated: "Element aktualisiert |||| %{smart_count} Elemente aktualisiert",
      created: "Element erstellt",
      deleted: "Element gelöscht |||| %{smart_count} Elemente gelöscht",
      bad_item: "Fehlerhaftes Element",
      item_doesnt_exist: "Element existiert nicht",
      http_error: "Kommunikation mit Server fehlgeschlagen",
      data_provider_error: "DataProvider-Fehler. Mehr Details in der Konsole.",
      i18n_error: "Die Übersetzungen für die ausgewählte Sprache können nicht geladen werden",
      canceled: "Aktion abgebrochen",
      logged_out: "Ihre Sitzung ist abgelaufen, bitte erneut verbinden.",
      not_authorized: "Sie sind nicht berechtigt, auf diese Ressource zuzugreifen.",
      application_update_available: "Eine neue Version der Anwendung ist verfügbar.",
    },
    validation: {
      required: "Erforderlich",
      minLength: "Muss mindestens %{min} Zeichen betragen",
      maxLength: "Darf %{max} Zeichen oder weniger betragen",
      minValue: "Muss mindestens %{min} betragen",
      maxValue: "Darf %{max} oder weniger betragen",
      number: "Muss eine Nummer sein",
      email: "Muss eine gültige E-Mail sein",
      oneOf: "Muss eine der folgenden Optionen sein: %{options}",
      regex: "Muss einem gewissen Format entsprechen (regexp): %{pattern}",
    },
    saved_queries: {
      label: "Gespeicherte Anfragen",
      query_name: "Name der Anfrage",
      new_label: "Speichere aktuelle Anfrage...",
      new_dialog_title: "Speichere aktuelle Anfrage als",
      remove_label: "Gespeicherte Anfrage löschen",
      remove_label_with_name: 'Anfrage "%{name}" löschen',
      remove_dialog_title: "Gespeicherte Anfrage löschen?",
      remove_message: "Sicher, dass Sie diese Anfrage aus der Liste der gespeicherten löschen wollen?",
      help: "Liste filtern und diese Anfrage für später speichern",
    },
    configurable: {
      customize: "Anpassen",
      configureMode: "Diese Seite anpassen",
      inspector: {
        title: "Inspektor",
        content: "Bewegen Sie den Mauszeigen über die UI-Elemente, um sie zu konfigurieren",
        reset: "Einstellungen zurücksetzen",
        hideAll: "Alles verbergen",
        showAll: "Alles anzeigen",
      },
      Datagrid: {
        title: "Datagrid",
        unlabeled: "Unbekannte Spalte #%{column}",
      },
      SimpleForm: {
        title: "Formular",
        unlabeled: "Unbenannter Input #%{input}",
      },
      SimpleList: {
        title: "Liste",
        primaryText: "Primärtext",
        secondaryText: "Sekundärtext",
        tertiaryText: "Tertiärtext",
      },
    },
  },
  deviceEnrollment: {
    section: {
      title: "Registrierungscodes",
      description:
        "Ein Code registriert Tablets nur innerhalb seines Gültigkeitsbereichs. Aktive Codes lassen sich jederzeit widerrufen.",
      empty: "Es wurden noch keine Registrierungscodes erstellt.",
      createButton: "Gerät registrieren",
      noOrganization: "Bitte wählen Sie zuerst eine Einrichtung aus.",
    },
    column: {
      code: "Code",
      scope: "Gültig für",
      createdBy: "Erstellt von",
      expiresAt: "Gültig bis",
      uses: "Verwendungen",
      status: "Status",
    },
    action: {
      show: "Anzeigen",
      revoke: "Widerrufen",
      openDevice: "Gerät öffnen",
      copyCode: "Code kopieren",
      print: "Drucken",
      done: "Fertig",
      create: "Code erstellen",
      send: "Senden",
    },
    status: {
      ACTIVE: "Aktiv",
      EXHAUSTED: "Verwendet",
      EXPIRED: "Abgelaufen",
      REVOKED: "Widerrufen",
      SCOPE_INVALID: "Ungültiger Bereich",
    },
    scope: {
      ORGANIZATION: "Gesamte Einrichtung",
      SITE: "Standort",
      DEPARTMENT: "Bereich",
      WARD: "Wohnbereich",
      hint: {
        ORGANIZATION: "Zugriff auf die gesamte Einrichtung",
        SITE: "Zugriff auf diesen Standort und seine Unterbereiche",
        DEPARTMENT: "Zugriff auf diesen Bereich und seine Unterbereiche",
        WARD: "Zugriff auf diesen Wohnbereich",
      },
    },
    duration: {
      label: "Gültig für die Dauer von",
      h1: "1 Stunde",
      h4: "4 Stunden",
      h24: "24 Stunden",
      h48: "48 Stunden",
      d7: "7 Tage",
      d30: "30 Tage",
    },
    usage: {
      label: "Verwendung",
      maxUsesLabel: "Höchstzahl an Tablets (optional)",
      unlimited: "Leer lassen für unbegrenzt viele Tablets bis zum Ablauf",
    },
    create: {
      title: "Gerät registrieren",
      description:
        "Der Code wird auf dem Tablet eingegeben oder als QR-Code gescannt. Wer den Code hat, kann Geräte nur innerhalb des gewählten Bereichs registrieren.",
      scopeLabel: "Gültig für",
      locationLabel: "Standort, Bereich oder Wohnbereich",
      locationRequired: "Bitte wählen Sie einen Ort für diesen Gültigkeitsbereich.",
      maxUsesInvalid: "Bitte geben Sie eine positive ganze Zahl ein.",
      success: "Registrierungscode erstellt.",
      error: "Der Registrierungscode konnte nicht erstellt werden",
    },
    detail: {
      createdTitle: "Code erstellt",
      title: "Registrierungscode",
      codeLabel: "Registrierungscode",
      codeHidden: "Der Code ist nicht mehr abrufbar.",
      qrAlt: "QR-Code für die Registrierung",
      instructions:
        "Auf dem Tablet „Gerät registrieren“ öffnen, Code eingeben oder QR-Code scannen, Gerätenamen vergeben. Der Code bleibt unter Registrierungscodes sichtbar, bis er verwendet, abgelaufen oder widerrufen ist.",
      revealError: "Der Registrierungscode konnte nicht geladen werden",
      copySuccess: "Code in die Zwischenablage kopiert.",
      copyError: "Der Code konnte nicht kopiert werden",
      emailTitle: "Per E-Mail senden",
      emailDescription:
        "An die Person, die das Tablet vor Ort einrichtet. Die E-Mail enthält Code, QR-Code und die Schritte am Tablet.",
      emailLabel: "E-Mail-Adresse",
      emailSuccess: "E-Mail zum Versand vorgemerkt.",
      emailError: "Die E-Mail konnte nicht gesendet werden",
      deliveriesTitle: "Gesendet an",
      redemptionsTitle: "Registrierte Geräte",
      redemptionDeleted: "Gerät gelöscht",
      noRedemptions: "Noch kein Gerät registriert.",
      printTitle: "Registrierungscode für Ihr Tablet",
    },
    revoke: {
      title: "Registrierungscode widerrufen",
      content:
        "Der Code kann danach nicht mehr für die Registrierung verwendet werden. Bereits registrierte Geräte bleiben aktiv.",
      success: "Registrierungscode widerrufen.",
      error: "Der Registrierungscode konnte nicht widerrufen werden",
    },
    unenroll: {
      action: "Registrierung aufheben",
      title: "App-Registrierung aufheben?",
      content:
        "Die Registrierung der App %{device} am Standort %{location} wird dauerhaft aufgehoben. Die App bleibt mit dem Status „Registrierung aufgehoben“ in der App-Liste sichtbar. Für die weitere Nutzung ist eine neue Registrierung erforderlich. Profile und Verlauf bleiben erhalten. Die Änderung wird in der App nach einem Neustart oder bei der nächsten Sitzungsprüfung angezeigt.",
      success: "App-Registrierung aufgehoben.",
      error: "Die App-Registrierung konnte nicht aufgehoben werden.",
      status: "Registrierung aufgehoben",
      unenrolledAt: "Aufgehoben am",
    },
    deliveryStatus: {
      QUEUED: "Zum Versand vorgemerkt",
      SENT: "An E-Mail-Anbieter übergeben",
      FAILED: "Versandversuch fehlgeschlagen",
    },
  },
  feedback: {
    action: "Feedback senden",
    title: "Feedback senden",
    description: "Teilen Sie uns mit, was gut funktioniert oder was wir verbessern können.",
    privacyGuidance: "Bitte geben Sie keine personenbezogenen oder medizinischen Daten von Bewohnern ein.",
    category: {
      label: "Kategorie",
      bug: "Fehler",
      idea: "Idee",
      question: "Frage",
      other: "Sonstiges",
    },
    message: {
      label: "Ihre Nachricht",
      placeholder: "Beschreiben Sie Ihr Feedback so genau wie möglich.",
      counter: "%{count} von %{max} Zeichen",
    },
    submit: "Feedback senden",
    submitting: "Wird gesendet...",
    success: "Vielen Dank. Ihr Feedback wurde gesendet.",
    error: "Ihr Feedback konnte nicht gesendet werden",
  },
  home: {
    welcome: "Willkommen zurück, %{name}",
    welcomeGeneric: "Willkommen zurück",
    currentState: "Aktueller Stand",
    noOrganization: "Für dieses Konto ist keine Einrichtung verfügbar.",
    loadError: "Die Übersicht konnte nicht vollständig geladen werden.",
    showAll: "Alle %{resource} anzeigen",
    openOnboarding: "Einrichtungsassistent öffnen",
    scope: {
      all: "Übersicht für alle Standorte",
      selected: "Übersicht für den ausgewählten Standort",
    },
    tabs: {
      overview: "Alles",
      practitioners: "Mitarbeiter",
      patients: "Klienten",
      devices: "Apps",
    },
    stats: {
      locations: "Standorte",
      areas: "Bereiche",
      practitioners: "Mitarbeiter",
      patients: "Klienten",
      devices: "Apps im Einsatz",
    },
    listTitles: {
      overview: "Standorte und Bereiche",
      practitioners: "Mitarbeiter in der Auswahl",
      patients: "Klienten in der Auswahl",
      devices: "Apps in der Auswahl",
    },
    empty: {
      overview: "In dieser Auswahl sind noch keine Standorte oder Bereiche vorhanden.",
      practitioners: "In dieser Auswahl sind noch keine Mitarbeiter vorhanden.",
      patients: "In dieser Auswahl sind noch keine Klienten vorhanden.",
      devices: "In dieser Auswahl sind noch keine Apps vorhanden.",
    },
    rows: {
      location: "Standort",
      locationCounts: "%{patients} Klienten · %{practitioners} Mitarbeiter · %{devices} Apps",
      allLocations: "Alle Standorte",
      noAssignment: "Keine Zuordnung hinterlegt",
      patientNumber: "ID %{number}",
      noPatientNumber: "Keine ID hinterlegt",
      unnamedDevice: "Unbenannte App",
      appVersion: "Version %{version}",
      unknownVersion: "Version unbekannt",
    },
  },
  onboarding: {
    title: "Einrichtungsassistent",
    subtitle: "Prüfen Sie den echten Einrichtungsstand und öffnen Sie den geführten Assistenten jederzeit erneut.",
    loading: "Einrichtungsstand wird geladen",
    noOrganization: "Für dieses Konto ist keine Einrichtung verfügbar.",
    loadError: "Der aktuelle Einrichtungsstand konnte nicht vollständig geladen werden.",
    openWizard: "Assistent öffnen",
    openDeviceGuide: "Geräte-Anleitung öffnen",
    progress: {
      title: "Einrichtungsstand",
      steps: "%{completed} von %{total} Grundlagen eingerichtet",
    },
    status: {
      complete: "Eingerichtet",
      missing: "Noch offen",
      configured: "Konfiguriert",
      optional: "Optional",
      unavailable: "Status nicht verfügbar",
      registered: "Registriert",
      notRegistered: "Noch nicht registriert",
      ready: "Bereit",
      inProgress: "In Einrichtung",
    },
    readiness: {
      locations: "Standorte",
      practitioners: "Mitarbeiter",
      patients: "Klienten",
      integration: "Schnittstelle",
      devices: "Geräte",
    },
    demo: {
      label: "Demo",
      description:
        "CSV-Import und Geräte-Anleitung sind interaktive Hilfen und speichern keine Datensätze oder Geräte. Die manuelle Einrichtung speichert alle geprüften Zeilen gemeinsam beim Abschluss.",
    },
    navigation: {
      back: "Zurück",
      next: "Weiter",
      close: "Schließen",
    },
    wizard: {
      title: "Einrichtungsassistent",
      progress: "Fortschritt der Einrichtung",
      start: "Einrichtung starten",
      chooseMethod: "Methode auswählen",
      step: "Schritt %{current} von %{total}",
      steps: {
        integration: "Schnittstelle",
        file: "CSV-Datei",
        mapping: "Spalten zuordnen",
        location: "Standorte",
        practitioner: "Mitarbeiter",
        patient: "Klienten",
        preview: "Vorschau",
      },
    },
    welcome: {
      title: "Willkommen bei Media4Care",
      description: "Der Assistent führt Sie mit klaren Schritten durch die Ersteinrichtung Ihres Portals.",
      choose: {
        title: "Methode wählen",
        description: "Wählen Sie Schnittstelle, CSV-Datei oder die schnelle manuelle Tabelleneingabe.",
      },
      review: {
        title: "Daten prüfen",
        description: "Ordnen Sie Felder zu und prüfen Sie vor dem simulierten Import jeden erkannten Datensatz.",
      },
      start: {
        title: "Geräte vorbereiten",
        description: "Folgen Sie anschließend der bebilderten Anleitung zur Geräteanmeldung in der Senior App.",
      },
    },
    method: {
      title: "Wie möchten Sie einrichten?",
      description:
        "Übernehmen Sie vorhandene Daten per Schnittstelle oder CSV-Simulation – oder bereiten Sie Grunddaten direkt im Assistenten vor.",
      integration: {
        title: "Automatisch per Schnittstelle",
        description:
          "Verwenden Sie die vorhandene Schnittstellenkonfiguration und starten Sie eine echte Synchronisierung.",
        point1: "Bestehende Anbieter verwenden",
        point2: "Zugangsdaten sicher speichern",
        point3: "Synchronisierungsverlauf prüfen",
        action: "Schnittstelle einrichten",
      },
      file: {
        title: "Daten aus CSV-Datei",
        description: "Spielen Sie den Import einer erkannten CSV-Datei mit eigener Feldzuordnung und Vorschau durch.",
        point1: "CSV-Datei mit 14 Demo-Datensätzen",
        point2: "Acht Felder selbst zuordnen",
        point3: "Datensätze vorab auswählen",
        action: "CSV-Import simulieren",
      },
      manual: {
        title: "Manuell einrichten",
        description: "Erfassen Sie mehrere Standorte, Mitarbeiter und Klienten direkt im Assistenten.",
        point1: "Mehrere Zeilen schnell hinzufügen",
        point2: "Einträge duplizieren und bearbeiten",
        point3: "Erst nach der Vorschau gemeinsam speichern",
        action: "Manuelle Einrichtung starten",
      },
    },
    integration: {
      title: "Schnittstelle einrichten",
      description:
        "Die vorhandene Schnittstellenverwaltung speichert Zugangsdaten und startet die echte Datensynchronisierung.",
      realDataNotice:
        "Dies ist kein Demo-Schritt. Gespeicherte Änderungen und gestartete Synchronisierungen wirken sich auf Ihre Einrichtung aus.",
    },
    file: {
      title: "Daten aus CSV-Datei importieren",
      description: "Verwenden Sie die Demo-Datei, um Erkennung, Feldzuordnung und Vorschau vollständig durchzuspielen.",
      simulationNotice: "Demo-Modus: Es wird keine lokale Datei gelesen oder an den Server übertragen.",
      dropTitle: "CSV-Datei hierher ziehen oder auswählen",
      formats: "CSV · bis zu 20 MB",
      selectDemo: "Demo-Datei auswählen",
      detected: "8 Spalten · 14 Datenzeilen erkannt",
    },
    mapping: {
      title: "Spalten zuordnen",
      fileDescription: "Ordnen Sie jede Portalangabe einer Spalte aus der simulierten CSV-Datei zu.",
      simulationNotice: "Die Zuordnung gilt nur für diese Demo und wird nicht als Importkonfiguration gespeichert.",
      status: "Zuordnungsstatus",
      mappedCount: "%{count} von %{total} Feldern zugeordnet",
      portalField: "Feld im Portal",
      sample: "Beispielwert",
      sourceColumn: "Spalte in der Quelle",
      skip: "Nicht importieren",
      required: "Ordnen Sie alle mit * markierten Pflichtfelder zu, um fortzufahren.",
      fields: {
        firstName: "Vorname",
        lastName: "Nachname",
        birthDate: "Geburtsdatum",
        role: "Rolle",
        email: "E-Mail",
        careLevel: "Pflegegrad",
        location: "Zuordnung · Standort",
        unit: "Zuordnung · Wohnbereich",
      },
    },
    manual: {
      savedCount: "%{count} aktuell im Portal gespeichert",
      rowsInWizard: "%{count} im Assistenten",
      site: "Standort",
      sitePlaceholder: "Standort auswählen",
      ward: "Wohnbereich",
      wards: "Wohnbereiche",
      wardPlaceholder: {
        selectSite: "Erst Standort wählen",
        none: "Keine Wohnbereiche vorhanden",
        selectOne: "Wohnbereich auswählen",
        selectMany: "Wohnbereiche auswählen",
      },
      moreWards: "+%{count}",
      actions: "Aktionen",
      existing: {
        title: "%{smart_count} Eintrag bereits im Portal |||| %{smart_count} Einträge bereits im Portal",
        description: "Gespeicherte Einträge bleiben erhalten und werden nicht erneut angelegt.",
      },
      copyName: "%{name} (Kopie)",
      next: "Weiter · %{summary}",
      saveError:
        "Die Einrichtung konnte nicht gespeichert werden. Es wurden keine Daten aus diesem Vorgang übernommen. Prüfen Sie die Eingaben und versuchen Sie es erneut.",
      location: {
        title: "Standorte erfassen",
        description:
          "Erfassen Sie Standorte und die zugehörigen Wohnbereiche nacheinander. Alle mit * markierten Felder sind erforderlich.",
        count: "%{smart_count} Standort |||| %{smart_count} Standorte",
        wardCount: "%{smart_count} Wohnbereich |||| %{smart_count} Wohnbereiche",
        statusTitle: "Standorte",
        row: "Standort %{number}",
        name: "Standortname",
        namePlaceholder: "Standortname eingeben",
        wards: "Wohnbereiche",
        wardName: "Wohnbereich %{number}",
        wardPlaceholder: "Wohnbereichname eingeben",
        addWard: "Weiteren Wohnbereich hinzufügen",
        add: "Weiteren Standort hinzufügen",
        duplicate: "Standort %{number} duplizieren",
        remove: "Standort %{number} löschen",
        duplicateWard: "Wohnbereich %{number} duplizieren",
        removeWard: "Wohnbereich %{number} löschen",
      },
      practitioner: {
        title: "Mitarbeiter erfassen",
        description: "Erfassen Sie Mitarbeiter nacheinander. Alle mit * markierten Felder sind erforderlich.",
        count: "%{smart_count} Mitarbeiter",
        workerNumber: "Mitarbeiter-Nr.",
        email: "E-Mail",
        statusTitle: "Mitarbeiter",
        add: "Weiteren Mitarbeiter hinzufügen",
        duplicate: "Mitarbeiter %{number} duplizieren",
        remove: "Mitarbeiter %{number} löschen",
      },
      patient: {
        title: "Klienten erfassen",
        description: "Erfassen Sie Klienten nacheinander. Alle mit * markierten Felder sind erforderlich.",
        count: "%{smart_count} Klient |||| %{smart_count} Klienten",
        statusTitle: "Klienten",
        add: "Weiteren Klienten hinzufügen",
        duplicate: "Klient %{number} duplizieren",
        remove: "Klient %{number} löschen",
      },
    },
    preview: {
      title: "Importvorschau",
      description: "Wählen Sie aus, welche der 14 erkannten Demo-Datensätze in die Simulation einbezogen werden.",
      simulationNotice: "Der nächste Schritt berechnet nur ein Ergebnis. Es werden keine Datensätze angelegt.",
      manualTitle: "Vorschau",
      manualDescription:
        "Prüfen Sie die vorbereiteten Grunddaten. Bis Sie unten speichern, wurde noch nichts im Portal angelegt.",
      existingCount: "%{count} bereits im Portal",
      noneStaged: "Keine neuen Einträge",
      edit: "Ändern",
      editResource: "%{resource} ändern",
      manualReady:
        "Mit „Einrichtung speichern“ werden alle neuen Standorte, Mitarbeiter und Klienten in einem Vorgang angelegt.",
      startSimulation: "Simulation starten",
      finishManual: "Einrichtung speichern",
      selectedCount: "%{count} Datensätze ausgewählt",
      locationCount: "%{count} Standorte und Wohnbereiche",
      practitionerCount: "%{count} Mitarbeiter",
      patientCount: "%{count} Klienten",
      toggleRecord: "%{name} importieren",
      groups: {
        locations: "Standorte und Wohnbereiche",
        practitioners: "Mitarbeiter",
        patients: "Klienten",
      },
    },
    result: {
      manualTitle: "Einrichtung abgeschlossen",
      manualDescription:
        "Alle vorbereiteten Grunddaten wurden gemeinsam gespeichert. Weitere Einträge können Sie später ergänzen.",
      simulationTitle: "Simulation abgeschlossen",
      simulationDescription: "Auswahl, Feldzuordnung und Importvorschau wurden vollständig durchgespielt.",
      notPersisted: "Es wurden keine Standorte, Mitarbeiter oder Klienten gespeichert.",
      stats: {
        sites: "Standort |||| Standorte",
        wards: "Wohnbereich |||| Wohnbereiche",
        locations: "Standorte und Wohnbereiche",
        practitioners: "Mitarbeiter",
        patients: "Klient |||| Klienten",
      },
      nextStep: "Nächster Schritt",
      connectDevices: "Geräte verbinden",
      connectDevicesHint: "Geräte registrieren und den Standorten zuordnen.",
    },
    device: {
      title: "Geräte verbinden",
      progress: "Fortschritt der Geräte-Anleitung",
      step: "Schritt %{current} von %{total}",
      doneStep: "Fertig",
      imageCounter: "Bild %{current} von %{total}",
      nextImage: "Weiter",
      nextPhase: "Nächster Abschnitt",
      finish: "Anleitung abschließen",
      close: "Schließen",
      doneTitle: "Anleitung abgeschlossen",
      doneDescription:
        "Sie haben alle Schritte zur Geräteanmeldung gesehen. Führen Sie diese Schritte jetzt auf dem echten Senior-Gerät aus.",
      simulationResult:
        "Diese Anleitung hat kein Gerät registriert. Der echte Portalstatus zeigt weiterhin %{count} registrierte Geräte.",
      showDevices: "Echten Gerätestatus anzeigen",
      phases: {
        activation: {
          label: "Anmeldung aktivieren",
          intro:
            "Alles passiert direkt in der App. Aktivieren Sie dort zuerst die Mitarbeiter-Anmeldung – danach lässt sich das Gerät bei Ihrer Einrichtung registrieren.",
        },
        enrollment: {
          label: "Gerät anmelden",
          intro: "Melden Sie das Gerät mit Ihren Zugangsdaten an und ordnen Sie es einem Standort und Wohnbereich zu.",
        },
        start: {
          label: "Loslegen",
          intro:
            "Fertig: Die App zeigt jetzt die Anmeldung. Mitarbeiter wählen ihren Namen und arbeiten mit ihrem eigenen Zugang.",
        },
      },
      shots: {
        openSettings: {
          title: "Einstellungen öffnen",
          description: "Auf dem Startbildschirm oben rechts auf das Zahnrad tippen.",
        },
        deviceSettings: {
          title: "Geräteeinstellung wählen",
          description: "In den Einstellungen die Kachel „Geräteeinstellung“ öffnen.",
        },
        caregiverLogin: {
          title: "Mitarbeiter-Anmeldung öffnen",
          description: "In der Liste nach unten scrollen und den Eintrag antippen.",
        },
        activate: {
          title: "Aktivieren",
          description: "Der Status steht auf „Inaktiv“ – auf „Aktivieren“ tippen.",
        },
        serviceCode: {
          title: "Servicecode 585 eingeben",
          description: "Code über die Zifferntasten eingeben und mit „Bestätigen“ abschließen.",
        },
        confirm: {
          title: "Mit „Ja“ bestätigen",
          description: "Das Gerät meldet sich ab und bei Ihrer Einrichtung wieder an.",
        },
        credentials: {
          title: "Zugangsdaten eingeben",
          description: "Benutzernamen und Passwort eingeben, dann auf „Registrieren“ tippen.",
        },
        selectSite: {
          title: "Standort auswählen",
          description: "Standort markieren und mit „Weiter“ bestätigen.",
        },
        selectUnit: {
          title: "Wohnbereich auswählen",
          description: "Wohnbereich markieren und mit „Weiter“ bestätigen.",
        },
        deviceName: {
          title: "Gerätenamen festlegen",
          description: "Am besten den Namen des Wohnbereichs verwenden und mit „Weiter“ bestätigen.",
        },
        registrationConfirmed: {
          title: "Registrierung bestätigt",
          description: "Das Gerät ist jetzt mit Ihrer Organisation und dem Wohnbereich verknüpft.",
        },
        caregiverSelection: {
          title: "Fachkraft auswählen",
          description:
            "Jeder Mitarbeiter tippt auf seine Kachel und meldet sich an. Über „Schnellzugang“ starten Angebote ohne Anmeldung.",
        },
      },
    },
  },
  analytics: {
    title: "Analytics",
    trends: "Trends",
    features: "Features",
    from: "Von",
    to: "Bis",
    groupBy: "Gruppieren nach",
    allApps: "Alle Apps",
    allFlavours: "Alle Varianten",
    latest: "Aktuellste Daten: %{date}",
    loadError: "Daten konnten nicht geladen werden.",
    dailyTrend: "Täglicher Trend (%{from} – %{to})",
    distributions: "Verteilungen",
    contentUsage: {
      menu: "Inhalte",
      pageTitle: "Inhaltsnutzung",
      kindTitle: "Nutzung nach Inhaltstyp",
      independentFilters: "Jede Karte hat eigene Filter. Änderungen gelten nur für die jeweilige Auswertung.",
      filters: "Filter für diese Auswertung",
      periodLabel: "Zeitraum",
      reset: "Filter dieser Karte zurücksetzen",
      retry: "Erneut versuchen",
      periodDates: "Zeitraum (UTC): %{from} – %{to}",
      latestUsage: "Letzte erfasste Nutzung im Filterzeitraum (UTC): %{date}",
      noRecordedUsage: "Keine erfasste Nutzung im Filterzeitraum.",
      overviewScope:
        "Erfasste Sitzungen der für Analytics berücksichtigten Apps für Inhalte mit Titel im Backendkatalog, einschließlich entfernter und unveröffentlichter Einträge. Nach Inhaltstyp aufgeteilt in abgeschlossen und nicht abgeschlossen.",
      rankingScope:
        "Erfasste Sitzungen der für Analytics berücksichtigten Apps im gewählten Zeitraum für Inhalte mit Titel im Backendkatalog, einschließlich entfernter und unveröffentlichter Einträge. Gesamt = abgeschlossen + nicht abgeschlossen.",
      catalogueScope:
        "Gefilterte Inhalte mit Titel im Backendkatalog, einschließlich entfernter und unveröffentlichter Einträge. Aufsteigend nach erfassten Sitzungen der für Analytics berücksichtigten Apps, einschließlich Inhalten ohne erfasste Nutzung im gewählten Zeitraum.",
      unusedSummary:
        "Für %{unused} von %{total} Inhalten wurde im gewählten Zeitraum und Filterumfang keine Nutzung in den für Analytics berücksichtigten Apps erfasst.",
      mostUsedTitle: "Meist genutzte Inhalte",
      mostUsedByType: "Meist genutzte Inhalte: %{type}",
      leastUsedTitle: "Am wenigsten genutzte Inhalte",
      leastUsedByType: "Am wenigsten genutzte Inhalte: %{type}",
      typeAndSubtype: "%{type} – %{subtype}",
      allSubtypes: "Alle Spieltypen",
      total: "Gesamt",
      usageBar: "%{title}: %{completed} abgeschlossen, %{unfinished} nicht abgeschlossen",
      kinds: {
        game: "Spiele",
        video: "Videos",
        youtube: "YouTube-Videos",
        website: "Webseiten",
        audio: "Audio",
        image: "Bilder",
        text: "Texte",
        story: "Geschichten",
        song: "Lieder",
        audioButtonGroup: "Audiogruppen",
        contentDocument: "Dokumente",
        externalApp: "Externe Apps",
        gallery: "Bildergalerien",
        richText: "Texte",
        moderationCard: "Moderationskarten",
        navigation: "Navigation",
        unknown: "Unbekannter Inhaltstyp",
      },
      periods: {
        days7: "Letzte 7 vollständige Tage",
        previousWeek: "Vorherige Kalenderwoche",
        months1: "Letzter Monat",
        months3: "Letzte 3 Monate",
        months6: "Letzte 6 Monate",
        months12: "Letzte 12 Monate",
      },
      videosTitle: "Meist angesehene Videos",
      youtubeTitle: "Meist genutzte YouTube-Videos",
      gamesTitle: "Meist gespielte Spiele",
      gameSubtypesTitle: "Nutzung nach Spieltyp",
      colSubtype: "Spieltyp",
      unknownSubtype: "Unbekannt",
      leastUsed: {
        title: "Am wenigsten genutzte Inhalte – letzte 4 Monate",
        scope:
          "Alle Apps · Erfasste Sitzungen aller Status · Datenbankinhalte mit Titel, einschließlich ungenutzter Inhalte. Dieser Zeitraum ist unabhängig von den Datumsfiltern oben.",
        period: "Zeitraum (UTC): %{from} – %{to}",
        filter: "Inhaltstyp",
        allTypes: "Alle Inhaltstypen",
        sessions: "Erfasste Sitzungen",
        lastUsed: "Letzte Nutzung im Zeitraum (UTC)",
        noUse: "Keine Nutzung im Zeitraum",
        notApplicable: "—",
        empty: "Keine Datenbankinhalte für diesen Inhaltstyp.",
        page: "%{from}–%{to} von %{count} Inhalten",
        previousPage: "Vorherige Seite",
        nextPage: "Nächste Seite",
        kinds: { game: "Spiel", video: "Video", website: "Webseite", unknown: "Unbekannt" },
      },
      gameModels: {
        simple: "Einfaches Quiz",
        text: "Textquiz",
        imageText: "Bild-Text-Quiz",
        dalli: "Dalli-Klick",
        enoughMoney: "Reicht das Geld?",
        backMoney: "Wechselgeld",
        shoppingList: "Einkaufsliste",
        image: "Bilderquiz",
        audio: "Audioquiz",
        color: "Farben",
        rememberSequence: "Reihenfolge merken",
        rememberPattern: "Muster merken",
        rememberPreviousSymbol: "Vorheriges Symbol merken",
        rememberImage: "Bild merken",
        whackAMole: "Maulwurfspiel",
        rememberWord: "Wort merken",
        rememberNumber: "Zahl merken",
        piano: "Klavier",
        solitaire: "Solitär",
        whoAmI: "Wer bin ich?",
        paint: "Malen",
        compareImages: "Bilder vergleichen",
        ordering: "Sortieren",
        memory: "Memory",
        sudoku: "Sudoku",
        backgammon: "Backgammon",
        checkers: "Dame",
        chess: "Schach",
        ticTacToe: "Tic-Tac-Toe",
        domino: "Domino",
      },
      completed: "Abgeschlossen",
      unfinished: "Nicht abgeschlossen",
      colKind: "Typ",
      colTitle: "Titel",
      colCompleted: "Abgeschlossen",
      colUnfinished: "Nicht abgeschlossen",
      colAvgDuration: "Ø Dauer (abgeschlossen)",
      avgFootnote:
        "Durchschnitt nur bei abgeschlossenen Sitzungen mit dokumentiertem Ende (ended_at). YouTube zählt als „website“.",
      empty: "Keine Inhaltsdaten im gewählten Zeitraum.",
    },
    interval: {
      custom: "Eigener",
    },
    groupByOption: {
      appId: "App ID",
      flavour: "Variante",
    },
    columns: {
      date: "Datum",
      flavour: "Variante",
      label: "Bezeichnung",
      average: "Durchschnitt",
    },
    comparedTo: "ggü. %{date}",
    fromPrevDay: "ggü. Vortag",
    fromPrevMonth: "ggü. Vormonat",
    fromPrevYear: "ggü. Vorjahr",
    kpi: {
      dau: "DAU",
      mau: "MAU",
      stickiness: "Stickiness (DAU/MAU)",
      messagesSent: "Gesendete Nachrichten",
      picturesSent: "Gesendete Bilder",
      notesCreated: "Erstellte Notizen",
      b2BSeniorsCreated: "B2B Klienten erstellt",
      b2BSeniorsTotal: "Klientenprofile (B2B, kumulativ)",
    },
    dimension: {
      app_version: "App-Version",
      os_version: "OS-Version",
      platform: "Plattform",
    },
    granularity: {
      day: "Tag",
      month: "Monat",
      year: "Jahr",
    },
    chartType: {
      pie: "Torte",
      line: "Linie",
    },
  },
  menu: {
    dashboards: "Dashboards",
    customerServiceDashboard: "Customer Service",
    subscriptionDashboard: "Abonnements & Umsatz",
    salesforceReports: "Salesforce-Berichte",
    dataView: "Datenansicht",
    gettingStarted: "Erste Schritte",
  },
  common: {
    notEditable: "Nicht bearbeitbar",
    editOnlyInSourceSystem: "Dieser Datensatz kann nur in %{source} bearbeitet werden.",
  },
  gender: {
    MALE: "Männlich",
    FEMALE: "Weiblich",
    OTHER: "Divers",
  },
  locationType: {
    SITE: "Standort",
    DEPARTMENT: "Bereich",
    WARD: "Wohnbereich",
    ROOM: "Zimmer",
    BED: "Bett",
  },
  locationMode: {
    INSTANCE: "Instanz",
    KIND: "Kategorie",
  },
  invitationStatus: {
    sending: "Wird gesendet",
    sent: "Gesendet",
    failed: "Fehlgeschlagen",
    completed: "Abgeschlossen",
  },
  login: {
    title: "Admin Portal",
    subtitle: "Melden Sie sich in Ihrem Konto an",
    welcomeTitle: "Willkommen bei dem Admin Portal",
    welcomeSubtitle: "Geben Sie Ihre Anmeldedaten ein, um sich einzuloggen.",
    email: "E-Mail",
    password: "Passwort",
    signIn: "Anmelden",
    signingIn: "Anmeldung läuft...",
    emailRequired: "E-Mail ist erforderlich",
    emailInvalid: "Ungültige E-Mail-Adresse",
    passwordRequired: "Passwort ist erforderlich",
    forgotPassword: "Passwort vergessen?",
    continue: "Weiter",
    changeEmail: "Andere E-Mail-Adresse",
    companySignInRequired: "Bitte melden Sie sich mit Ihrem Firmenkonto an.",
    companySignInFailed: "Die Anmeldung mit dem Firmenkonto ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
    companySignInNoAccess: "Ihr Firmenkonto hat keinen Zugriff auf das Admin Portal.",
    companySignInCancelled: "Die Anmeldung mit dem Firmenkonto wurde abgebrochen.",
    companySignInUnavailable: "Die Anmeldung mit dem Firmenkonto ist derzeit nicht verfügbar.",
  },
  learning: {
    home: "Lernportal",
    title: "Meine Lerninhalte",
    placeholder: "Ihre Lerninhalte werden hier angezeigt.",
    logout: "Abmelden",
    permissionCheck: "Berechtigung wird geprüft",
    retry: "Erneut versuchen",
    duration: "%{minutes} Min.",
    locked: "Noch gesperrt",
    completed: "Abgeschlossen",
    backToCatalog: "Zurück zu meinen Lerninhalten",
    catalog: {
      loading: "Lerninhalte werden geladen",
      error: "Die Lerninhalte konnten nicht geladen werden.",
      empty: "Ihnen wurden noch keine Lerninhalte zugewiesen.",
      intro: "Hier finden Sie Ihre zugewiesenen Kurse und Lernpfade.",
      myCourses: "Meine Kurse",
    },
    course: {
      notFound: "Dieser Kurs ist nicht verfügbar.",
      contentError: "Der Kursinhalt ist ungültig oder konnte nicht geladen werden.",
      lessons: "Lektionen",
      lessonCount: "%{count} Lektionen",
      lockedHelp: "Schließen Sie zuerst die vorherigen Kurse im Lernpfad ab.",
      start: "Kurs starten",
      continue: "Kurs fortsetzen",
      repeat: "Kurs wiederholen",
      notAssigned: "Dieser Kurs ist Ihnen noch nicht zugewiesen. Wenden Sie sich an Ihre Leitung.",
    },
    player: {
      unsupportedBlock: "Dieser Inhaltstyp kann nicht angezeigt werden.",
      loading: "Kurs wird geladen",
      starting: "Kurs wird gestartet",
      notAvailable: "Diese Lektion ist noch nicht verfügbar.",
      startError: "Der Kurs konnte nicht gestartet werden.",
      completeError: "Die Lektion konnte nicht abgeschlossen werden.",
      backToCourse: "Zurück zum Kurs",
      blockProgress: "Seite %{current} von %{total}",
      previous: "Zurück",
      next: "Weiter",
      completeLesson: "Lektion abschließen",
    },
    flipCards: {
      showBack: "Rückseite von %{title} anzeigen",
      showFront: "Vorderseite von %{title} anzeigen",
    },
    dialogue: {
      progress: "Schritt %{current} von %{total}",
      response: "Antwort",
      next: "Weiter",
      replay: "Dialog wiederholen",
      transcript: "Gesamten Dialog anzeigen",
    },
    matching: {
      instructions: "Wählen Sie zuerst einen Begriff und danach die passende Erklärung.",
      terms: "Begriffe",
      definitions: "Erklärungen",
      chooseTerm: "Wählen Sie zuerst einen Begriff aus.",
      correct: "Das passt zusammen.",
      incorrect: "Das passt noch nicht. Versuchen Sie es erneut.",
      complete: "Alle Paare gefunden. Versuche: %{attempts}",
      reset: "Neu starten",
    },
    quiz: {
      loading: "Abschlusstest wird geladen",
      title: "Abschlusstest",
      passingScore: "Zum Bestehen benötigen Sie %{score} %.",
      question: "Frage %{current} von %{total}",
      answerAll: "Beantworten Sie alle Fragen.",
      submit: "Antworten abgeben",
      submitError: "Der Abschlusstest konnte nicht gespeichert werden.",
      lessonsRequired: "Schließen Sie zuerst alle Lektionen ab.",
      continueLessons: "Lektionen fortsetzen",
      passed: "Bestanden",
      failed: "Noch nicht bestanden",
      score: "Ergebnis: %{score} %",
      correctCount: "%{correct} von %{total} Antworten sind richtig.",
      retryHelp: "Sie können den Test erneut versuchen. Alle Versuche bleiben in Ihrem Lernverlauf erhalten.",
      retry: "Test wiederholen",
    },
  },
  learningGrants: {
    section: "E-Learning",
    organizationContext: {
      label: "Freigaben für",
      description: "Alle Änderungen auf dieser Seite gelten ausschließlich für diese Einrichtung.",
    },
    loading: "Lerninhalte werden geladen",
    loadError: "Die Lerninhalte konnten nicht geladen werden.",
    emptyTitle: "Noch keine Lerninhalte veröffentlicht",
    emptyDescription: "Veröffentlichte Kurse und Lernpfade erscheinen automatisch in dieser Übersicht.",
    noResults: "Keine passenden Lerninhalte gefunden.",
    noCoursesInCatalog: "Es sind noch keine Kurse veröffentlicht.",
    noPathsInCatalog: "Es sind noch keine Lernpfade veröffentlicht.",
    enforceOrder: "Feste Reihenfolge",
    searchLabel: "Lerninhalte durchsuchen",
    searchPlaceholder: "Nach Titel oder Thema suchen",
    pathCourses: "Enthaltene Kurse",
    tabs: {
      label: "Art des Lerninhalts",
      courses: "Kurse",
      paths: "Lernpfade",
    },
    summary: {
      grantedOfTotal: "%{granted} von %{total} freigeschaltet",
    },
    values: {
      lessons: "%{smart_count} Lektion |||| %{smart_count} Lektionen",
      courses: "%{smart_count} Kurs |||| %{smart_count} Kurse",
      duration: "%{minutes} Min.",
    },
    status: {
      granted: "Freigeschaltet",
    },
    actions: {
      grant: "Freischalten",
      grantLabel: "%{title} freischalten",
      revokeLabel: "Freigabe für %{title} entziehen",
      retry: "Erneut versuchen",
      expand: "%{title} aufklappen",
      collapse: "%{title} zuklappen",
    },
    revoke: {
      title: "Freigabe entziehen?",
      content:
        "Möchten Sie die Freigabe für „%{title}“ wirklich entziehen? Bereits begonnene Lernfortschritte bleiben erhalten.",
    },
    notifications: {
      granted: "„%{title}“ wurde freigeschaltet.",
      revoked: "Die Freigabe für „%{title}“ wurde entzogen.",
      conflict: "Diese Freigabe wird bereits aktualisiert.",
      error: "Die Freigabe konnte nicht aktualisiert werden.",
    },
  },
  customerServiceOrganizations: {
    title: "Einrichtungen",
    searchPlaceholder: "Nach Einrichtung oder Account suchen",
    fields: {
      name: "Einrichtung",
      account: "Salesforce-Account",
    },
    filters: {
      unlinked: "Nur ohne Account",
    },
    account: {
      label: "Salesforce-Account",
      none: "Kein Account verknüpft",
      notInCrm: "Nicht im CRM (%{id})",
    },
    loading: "Einrichtung wird geladen",
    loadError: "Einrichtungen konnten nicht geladen werden",
    notFound: "Diese Einrichtung wurde nicht gefunden.",
    backToList: "Zur Einrichtungsliste",
    tabs: {
      label: "Bereiche der Einrichtung",
      billing: "Abrechnung",
    },
  },
  salesforceDashboard: {
    title: "Salesforce-Dashboard",
    overline: "Dashboard",
    refresh: "Daten neu laden",
    loading: "Salesforce-Daten werden geladen",
    loadError: "Die Salesforce-Daten konnten nicht geladen werden.",
    noImportTitle: "Noch keine Salesforce-Daten importiert",
    noImportDescription: "Nach dem ersten Import werden die Kennzahlen hier angezeigt.",
    asOf: "Stand: %{date}",
    contracts: "Verträge",
    subscriptions: "Abonnements",
    unavailable: "Nicht verfügbar",
    noChartData: "Keine Diagrammdaten.",
    other: "Andere",
    recordCount: "Datensatzanzahl",
    total: "Gesamt",
    components: {
      activeSubscriptions: {
        title: "Aktive %{segment}-Abonnements",
        definition: "Abonnement-Positionen mit Status „Active“, Kontoart %{segment}",
        b2cDefinition:
          "Produktfamilie Senioren Tablet · nicht in Testphase · Abrechnungsbeginn bis heute · Enddatum ab heute oder leer · Testergebnis „Test Won“ oder leer · Vertragsart ungleich Sample",
      },
      activeLicences: {
        title: "Aktive Lizenzen-Abonnements",
        definition:
          "Status „Active“, Produktfamilie Lizenzen · erste %{count} Produkte alphabetisch, „Andere“ = kleine Anteile davon",
      },
      contractBasis: "Verträge mit aktiven Positionen: %{b2b} B2B · %{b2c} B2C",
      totalMrr: "Summe aktiver MRR",
      averageMrr: "Durchschnittlicher aktiver MRR",
      averageActiveSubscriptionItems: "Durchschnittlich aktive Abonnement-Positionen",
      createdMonthly: {
        title: "Neue %{segment}-Abonnements pro Monat",
        definition: "Nach Erstellungsdatum, ab Januar 2020",
      },
      createdWeekly: {
        title: "Neue %{segment}-Abonnements pro Woche (letzte 90 Tage)",
        definition: "Nach Erstellungsdatum, Wochen ab Montag",
      },
      createdDaily: {
        title: "Neue %{segment}-Abonnements pro Tag (letzte 30 Tage)",
        definition: "Nach Erstellungsdatum",
      },
      cancelledMonthly: {
        title: "Gekündigte %{segment}-Abonnements pro Monat",
        definition: "Nach Kündigungsdatum, ohne ersetzte Positionen",
      },
      endedMonthly: {
        title: "Beendete %{segment}-Abonnements pro Monat",
        definition: "Nach Enddatum ab 2020, inkl. geplanter Enden",
      },
    },
    axes: {
      productName: "Produktname",
      status: "Status",
      cancellationType: "Kündigungsart",
      recordType: "Vertragsdatensatztyp",
      totalMrr: "Summe MRR (%{currency})",
      averageMrr: "Durchschnitt MRR (%{currency})",
      averageActiveSubscriptionItems: "Durchschnitt aktive Abonnement-Positionen",
      createdAt: "Erstellt am",
      cancelledAt: "Kündigungsdatum",
      endedAt: "Enddatum",
    },
    tooltip: {
      share: "(%{percent} von %{total})",
      shareOfPeriod: "(%{percent} von %{total} für %{period})",
    },
    records: {
      overline: "Datensätze",
      back: "Zurück zum Dashboard",
      invalid: "Diese Datensatzliste ist ungültig. Bitte öffnen Sie sie über das Dashboard.",
      loadError: "Die Datensätze konnten nicht geladen werden.",
      empty: "Keine Datensätze.",
      count: "%{total} Datensätze",
      truncated: "Die ersten %{shown} von %{total} Datensätzen",
      horizontalScroll: "Horizontal scrollen",
      licenceColumns: {
        product: "Product Name",
        createdAt: "Created Date",
        segment: "AccountId: Account Record Type",
        contractNumber: "Contract: Contract Number",
        contractRecordType: "Contract Record Type Name",
        contractName: "Contract Name",
        name: "Contract Item Name",
        recordType: "Record Type",
        startDate: "Start Date",
        trialPeriodDays: "Trial Period (Days)",
        billingStartDate: "Billing Start Date",
        endDate: "End Date",
        price: "Price",
        status: "Status",
        assetType: "Asset Type",
        changedFrom: "Changed From: Contract Item Name",
        changedInto: "Changed Into: Contract Item Name",
        inTrial: "In Trial",
        cancellationType: "Kündigungsart",
        lostReason: "Lost Reason",
        billingStarted: "Billing Start",
        productId: "Product Id",
        contractId: "Contract: Contract ID",
        id: "Contract Item ID",
      },
      columns: {
        id: "Salesforce-ID",
        product: "Produkt",
        family: "Produktfamilie",
        status: "Status",
        segment: "Kontoart",
        createdAt: "Erstellt am",
        startDate: "Startdatum",
        cancellationDate: "Kündigungsdatum",
        endDate: "Enddatum",
        cancellationType: "Kündigungsart",
        sponsor: "Krankenkasse",
        contract: "Vertrag",
        contractStatus: "Vertragsstatus",
        mrr: "MRR",
        activeItems: "Aktive Positionen",
      },
    },
    cancellationTypes: {
      testAbort: "Testabbruch",
      withdrawalWithinPeriod: "Widerruf innerhalb ges. Frist",
      ordinaryCancellation: "Ordentliche Kündigung",
      extraordinaryCancellationCustomer: "Sonderkündigung durch KD",
      cancellationByM4C: "Kündigung durch M4C",
      cancellationAfterFundingExpired: "Kündigung nach ausgelaufener KK-Förderung",
      reductionOrder: "Reduction Order",
      contractChangeNeutral: "Bestandsneutrale Vertragsänderung",
      testEndAfterFundingExpired: "Testende nach ausgelaufener KK-Förderung",
      productChange: "Produktwechsel",
    },
    history: {
      missingDates: {
        created: "Positionen ohne Erstellungsdatum: %{count}. Sie fehlen in der Zeitreihe neuer Abonnements.",
        cancellation: "Positionen ohne Kündigungsdatum: %{count}. Sie fehlen in der Kündigungszeitreihe.",
        end: "Positionen ohne Enddatum: %{count}. Sie fehlen in der Zeitreihe der Abonnement-Enden.",
      },
    },
    notices: {
      unclassifiedSubscriptions:
        "Abonnement-Positionen ohne B2B-/B2C-Zuordnung: %{count}. Sie fehlen in den aktiven B2B-Abonnements. Die aktiven B2C-Abonnements richten sich nach den Salesforce-Berichtsfiltern.",
      missingSubscriptionCountContracts:
        "%{recordType}-Verträge ohne Anzahl aktiver Abonnements: %{count}. Diese Verträge sind von den MRR- und Durchschnittswerten ausgeschlossen.",
      missingMrrContracts:
        "%{recordType}-Verträge ohne MRR: %{count}. MRR-Werte für %{recordType} sind deshalb nicht verfügbar.",
    },
  },
  salesforceReports: {
    overline: "Salesforce-Bericht",
    tabsLabel: "Salesforce-Berichte",
    measureLegend: "Kennzahl",
    scrollRegion: "%{title}: scrollbares Diagramm",
    sideBySideChart: "Säulendiagramm: %{value} nach %{category}",
    missingFields: "Importabdeckung unbekannt oder unvollständig: %{fields}",
    pendingObjects: "Aktualisierung ausstehend: %{objects}",
    objects: {
      Order: "Aufträge",
      Order_Asset_Item__c: "Auftragspositionen",
      Asset: "Assets",
      Inventory__c: "Inventar",
      Contract_Item__c: "Vertragspositionen",
      Account: "Accounts",
      Product2: "Produkte",
      Case: "Fälle",
      Contract: "Verträge",
      Opportunity: "Opportunities",
      Contact: "Kontakte",
      RecordType: "Datensatztypen",
    },
    blocks: { B0: "Austausch", B1: "Kundenrücksendungen" },
    unreadableFields: "Ohne Lesezugriff in Salesforce: %{fields}",
    unavailable: {
      REQUIRED_FIELDS_UNAVAILABLE:
        "Erforderliche Salesforce-Felder sind nicht lesbar. Dieser Bericht ist nicht verfügbar.",
      REFRESH_PENDING: "Die erforderlichen Daten wurden noch nicht vollständig aktualisiert.",
      COPY_UNCONFIRMED: "Die Vollständigkeit der lokalen Salesforce-Kopie ist noch nicht bestätigt.",
      SOURCE_INCOMPLETE: "Die lokale Salesforce-Kopie ist für diesen Bericht unvollständig.",
      TASKS_NOT_COPIED:
        "Nicht übernommen: Dieser Bericht zählt Salesforce-Aufgaben, die die Integration nicht lesen darf.",
      REPORT_NOT_SHARED: "Nicht übernommen: Der Quellbericht ist in Salesforce nicht freigegeben.",
    },
    dashboards: {
      LOGISTICS_OPERATIONS: "Logistik – Auftragsabwicklung",
      CUSTOMER_SUCCESS_2026: "Customer Success 2026",
      SALES_DASHBOARD_RY: "Sales Dashboard RY",
      WEEKLY_SALES_SF2020: "Weekly Sales SF2020",
      CARE_DOCUMENTATION_SYSTEMS: "Dashboard Pflegedokumentationssysteme",
      SUPPORT_METRICS_MONTHLY: "Support Metrics - Monthly",
      CHURN_SUPPORT: "Churn Support",
    },
    reports: {
      "00OVi000006Wl0LMAS": { title: "Versandbereite Aufträge" },
      "00OVi00000FLoHJMA1": { title: "Offene Aufträge – wöchentlich" },
      "00O67000006tey5EAA": { title: "Offene Aufträge – täglich" },
      "00OVi000006Wq4rMAC": { title: "Erwartete Rücksendungen" },
      "00OVi000007LiBhMAK": { title: "Offene Logistikfälle" },
      "00OVi000006wPx3MAE": { title: "Zurückgesendete Geräte" },
      "00O6700000724lNEAQ": { title: "Versendete Aufträge" },
      "00OVi000006eyEvMAI": { title: "Beendete Vertragspositionen ohne Rücksendung" },

      "00O670000064x4rEAA": { title: "Lizenzen Active Subscriptions" },
      "00O67000006YMRbEAO": { title: "Eingehende Kündigungen SUB Prof." },
      "00O67000006YMRlEAO": { title: "Geschlossene Cases B2B/B2C-Monthly" },
      "00O67000006jB9lEAE": { title: "Senioren Tablet Active Subscriptions" },
      "00O67000006jEbhEAE": { title: "Tests created weekly" },
      "00O67000006jEcbEAE": { title: "Senioren Subs monthly" },
      "00O67000006jEd9EAE": { title: "Senioren Subs weekly" },
      "00O67000006jEdEEAU": { title: "Senioren Tests weekly" },
      "00O67000006jEdTEAU": { title: "Betreuer Tests weekly" },
      "00O67000006jEdUEAU": { title: "Subs Total monthly" },
      "00O67000006jEddEAE": { title: "Betreuer Subs weekly" },
      "00O67000006jEdeEAE": { title: "Betreuer Subs monthly" },
      "00O67000006jEdfEAE": { title: "Subs Total weekly" },
      "00O67000006jEjMEAU": { title: "Tests created monthly" },
      "00O67000006jEk0EAE": { title: "Churn Senioren Subs weekly" },
      "00O67000006jEk5EAE": { title: "Churn Betreuer Subs weekly" },
      "00O67000006jEnnEAE": { title: "Sold Tablets weekly" },
      "00O67000006jEnxEAE": { title: "Sold Tablets monthly" },
      "00O67000006jFDbEAM": { title: "Betreuer Tablet Active Subscriptions" },
      "00O67000006jFQfEAM": { title: "Churn Betreuer Subs monthly" },
      "00O67000006jFQkEAM": { title: "Churn Senioren Subs monthly" },
      "00O67000006u3NoEAI": { title: "Hotline Erreichbarkeit Service Quartal" },
      "00O6700000724l8EAA": { title: "Subs monthly by Rep" },
      "00O6700000769YjEAI": { title: "Time talking per Wrap up lable / Month" },
      "00O670000076A2UEAU": {
        title: "Time to be closed (Cases) Month/per Day",
        description: "Zeigt den durchschn. Wert für alle C.Support Cases in Tagen bis zum Status geschlossen an.",
      },
      "00O670000076A2eEAE": {
        title: "New Cases per Month and status",
        description: "Zeigt die Datensatzzahl und den Status der eingehenden Cases pro Monat.",
      },
      "00O670000076A2oEAE": {
        title: "New Cases per Month (Channel)",
        description: "Zeigt die Datensatzzahl der eingehenden Cases per Monat und Kundenvorgangsursprung)",
      },
      "00O670000076A2tEAE": {
        title: "First Reaction Time Cases per Day",
        description: "Zeigt die erste Reaktionszeit auf schriftliche Kundenanfragen.",
      },
      "00O670000076A2yEAE": {
        title: "HL Wartezeit und time talking (Monat)",
        description: "Zeigt den durchschnittlichen Wert der Warte- sowie Gesprächszeit in Sekunden.",
      },
      "00O670000076A3NEAU": {
        title: "Hotline Volumen total ohne Servicezeiten",
        description: "Zeigt die Datensatzzahl pro Uhrzeit über die gesamte Zeit auch außerhalb der Servicezeiten.",
      },
      "00O670000076ABqEAM": { title: "Hotline Erreichbarkeit Today/hour" },
      "00O670000076ABrEAM": { title: "Hotline Calls Today Call Queue" },
      "00O670000076AGWEA2": { title: "Calls per Rep CS" },
      "00O670000076AGgEAM": { title: "Betreuer Subs monthly by Rep" },
      "00O670000076AGqEAM": { title: "Open Opportunities per close date" },
      "00O670000076AGrEAM": { title: "Open Opportunities per Rep overall" },
      "00O670000076AZ9EAM": { title: "Betreuer Subs Starting monthly" },
      "00O670000076AZJEA2": { title: "Betreuer Subs Ending monthly" },
      "00O670000076BbVEAU": { title: "Hotline Calls gestern Call Queue" },
      "00O670000076BbkEAE": { title: "Erreichbarkeit Service letztes Quartal" },
      "00O670000076Bc4EAE": { title: "Calls done per Month Inbound" },
      "00O670000076BjPEAU": {
        title: "Nicht bearbeitete/offene Cases",
        description: "Zeigt die Datensatzzahl und den Status der eingehenden Cases pro Monat.",
      },
      "00OVi00000089PVMAY": { title: "Opps per Rep" },
      "00OVi0000008VWTMA2": { title: "Opps per Rep 7d" },
      "00OVi000000JAGbMAO": { title: "win back" },
      "00OVi000000JIinMAG": { title: "WIN Back Opportuniy Future Sales" },
      "00OVi000000KCufMAG": { title: "Calls per Rep monthly" },
      "00OVi000000KEoQMAW": { title: "Opps monthly" },
      "00OVi000000KFVxMAO": { title: "Calls monthly" },
      "00OVi000000KFkTMAW": { title: "Betreuer Subs monthly" },
      "00OVi000000KZsyMAG": { title: "Incoming Churn per month B2B" },
      "00OVi000000KeW3MAK": { title: "Calls per Rep CS daily" },
      "00OVi000000KhX3MAK": { title: "Opps per Rep daily" },
      "00OVi000000Khf7MAC": { title: "Betreuer Subs by Rep daily" },
      "00OVi000000Kkd0MAC": { title: "Offene Kündigungen Prof." },
      "00OVi000000LTi9MAG": { title: "Open Opps per Close Date weekly" },
      "00OVi000000N6eDMAS": { title: "Churn (Account Lost) B2B akt. Jahr" },
      "00OVi000000N7NNMA0": { title: "B2B WIN Back Quartal nach Case Eingang" },
      "00OVi000000NIlpMAG": { title: "Churn Lost ITEMs B2B" },
      "00OVi000000OH2vMAG": { title: "B2B Churn Gründe Gesamt" },
      "00OVi000000PFK1MAO": { title: "B2B ITEM Churn ohne Lizenz" },
      "00OVi0000011DfNMAU": { title: "Eingehende Kündigungen SUB B2C" },
      "00OVi000002WhWvMAK": {
        title: "First Reaction Time Kündigung Cases",
        description: "Zeigt die erste Reaktionszeit auf schriftliche Kündigung.",
      },
      "00OVi000002YCQbMAO": { title: "Anzahl TV Boxen" },
      "00OVi000003tztxMAA": { title: "Win back vorheriges Quartal" },
      "00OVi000003zjePMAQ": { title: "Erreichbarkeit Dayli Support" },
      "00OVi000004MawzMAC": {
        title: "BK Support to Sales Status",
        description: "Bestandskunden Bedarfsabfrage (Kontakte für Sales)",
      },
      "00OVi000009lg1pMAA": { title: "PFB One time monthly" },
      "00OVi000009qRi5MAE": { title: "Pflichtfortbildung Subs monthly" },
      "00OVi00000A3lXlMAJ": { title: "Pflegedokumentationssyste Date" },
      "00OVi00000A3qXNMAZ": { title: "Pflegedokumentationssysteme" },
      "00OVi00000A3rGXMAZ": { title: "Pflegedokumentationssystem Anzahl Acc" },
      "00OVi00000A3rgLMAR": { title: "Pflegedokumentationssyste Anzahl MA" },
      "00OVi00000AMpxNMAT": { title: "Support to Sales Month Agent" },
      "00OVi00000BS1kUMAT": { title: "Erfolgreiche Calls per Rep CS weekly" },
      "00OVi00000BS8NhMAL": { title: "Erfolgreiche Calls per Rep CS daily" },
      "00OVi00000BS8cDMAT": { title: "Erfolgreiche Calls per Rep monthly" },
      "00OVi00000BTp5dMAD": { title: "Erf. Calls per Unique Customer CS daily" },
      "00OVi00000BVnZBMA1": { title: "Avg Time Talking per Rep CS daily" },
      "00OVi00000BVnpJMAT": { title: "Avg Time Talking per Rep CS weekly" },
      "00OVi00000BVnsXMAT": { title: "Avg Time Talking per Rep monthly" },
      "00OVi00000BYP7JMAX": { title: "Erf. Calls per Unique Customer weekly" },
      "00OVi00000BYQ6bMAH": { title: "Erf. Calls per Unique Customer monthly" },
      "00OVi00000CPCezMAH": { title: "Endende Verträge SUB B2C" },
      "00OVi00000D0s8zMAB": { title: "Erf. Zweite Calls per Unique C. daily" },
      "00OVi00000DMaF3MAL": { title: "Erf. Zweite Calls per Unique C. weekly" },
      "00OVi00000DMai5MAD": { title: "Erf. Zweite Calls per Unique C. monthly" },
      "00OVi00000FlISHMA3": { title: "Pflegedok. interessierte Kunden" },
    },
    reportTypes: {
      ORDERS_WITH_ITEMS: "Aufträge mit Auftragspositionen",
      ORDER_ASSET_ITEMS: "Auftragspositionen",
      CONTRACT_ITEM_ORDER_ITEMS: "Vertragspositionen mit Auftragspositionen",

      CONTRACT_ITEMS: "Vertragsposition",
      CONTRACTS_WITH_ITEMS: "Verträge mit Vertragspositionen",
      CALL_REPORTING: "Anrufberichte",
      CASES: "Fälle",
      OPPORTUNITIES: "Opportunities",
      ACCOUNTS: "Accounts",
      ACCOUNTS_WITH_CONTRACTS: "Accounts mit Verträgen",
      CAMPAIGNS_WITH_CONTACTS: "Kampagnen mit Kontakten",
      CAMPAIGNS_WITH_MEMBERS: "Kampagnen mit Mitgliedern",
    },
    formulas: {
      ARPU: "ARPU",
      HANDLING_HOURS: "Bearbeitungszeit (Std.)",
      AVERAGE_HANDLING_MINUTES: "AHT (Min.)",
    },
    operators: {
      EQUALS: "gleich",
      NOT_EQUAL: "ungleich",
      CONTAINS: "enthält",
      NOT_CONTAIN: "enthält nicht",
      GREATER_THAN: "größer als",
      GREATER_OR_EQUAL: "größer oder gleich",
      LESS_THAN: "kleiner als",
      LESS_OR_EQUAL: "kleiner oder gleich",
    },
    ranges: {
      THIS_AND_LAST_TWO_YEARS: "Aktuelles und letzte zwei Kalenderjahre",
      TODAY: "Heute",
      YESTERDAY: "Gestern",
      THIS_MONTH: "Aktueller Monat",
      LAST_AND_THIS_MONTH: "Letzter und aktueller Monat",
      THIS_QUARTER: "Aktuelles Quartal",
      LAST_QUARTER: "Letztes Quartal",
      LAST_AND_THIS_QUARTER: "Letztes und aktuelles Quartal",
      THIS_YEAR: "Aktuelles Jahr",
      THIS_AND_LAST_YEAR: "Aktuelles und letztes Jahr",
      THIS_AND_NEXT_YEAR: "Aktuelles und nächstes Jahr",
      lastDays: "Letzte %{days} Tage",
    },
    report: {
      overline: "Bericht: %{type}",
      back: "Zurück zum Dashboard",
      clearFilters: "Auswahlfilter zurücksetzen",
      viewReport: "Bericht anzeigen",
      totalRecords: "Datensätze gesamt",
      subtotal: "Zwischensumme",
      grandTotal: "Gesamt (%{count})",
      grandTotalWithoutCount: "Gesamt",
      filters: "Filter",
      filterLogic: "Filterlogik: %{logic}",
      linkedFilters: "Verknüpfte Filter",
      noFilters: "Keine Filter",
      rowLimit: "Es werden die ersten %{limit} Datensätze angezeigt. Der Bericht enthält mehr.",
      notFound: "Dieser Bericht ist nicht verfügbar.",
      empty: "Keine Datensätze",
      toggles: {
        rowCounts: "Zeilenanzahl",
        detailRows: "Detailzeilen",
        subtotals: "Zwischensummen",
        grandTotal: "Gesamtsumme",
      },
      yes: "Ja",
      no: "Nein",
      sum: "Summe",
      average: "Ø",
      unique: "Eindeutig",
      chartLabel: "%{title}: Diagramm",
    },
    measures: {
      COUNT: "Datensatzanzahl",
      SUM: "Summe von %{field}",
      AVERAGE: "Durchschnitt von %{field}",
      UNIQUE: "Eindeutige Werte von %{field}",
      FORMULA: "Formel",
    },
    fields: {
      ORDERS_WITH_ITEMS: logisticsOrderReportFields,
      ORDER_ASSET_ITEMS: logisticsOrderReportFields,
      CONTRACT_ITEM_ORDER_ITEMS: {
        ...contractItemReportFields,
        assetHasInventory: "Asset mit Inventar",
        tabletName: "Tablet-Inventar",
        tabletIdentifier: "Tablet-IMEI oder Hardware-Seriennummer",
        simIccid: "SIM-ICCID",
        contractAccountShippingStreet: "Vertragsaccount: Versandstraße",
        contractAccountShippingPostalCode: "Vertragsaccount: Versand-PLZ",
        contractAccountShippingCity: "Vertragsaccount: Versandort",
        contractAccountShippingCountryCode: "Vertragsaccount: Versand-Ländercode",
        hasCompletedReturnOrder: "Abgeschlossene Rücksendung vorhanden",
      },

      CALLS: {
        createdDate: "Erstelldatum",
        startTime: "Gesprächsbeginn",
        ownerName: "Inhaber",
        toUserName: "Angerufener Benutzer",
        direction: "Anrufrichtung",
        callType: "Anruftyp",
        lastQueue: "Letzte Warteschlange",
        wrapUpLabel: "Wrap-up-Label",
        wrapUpString: "Wrap-up-Text",
        account: "Account",
        talkSeconds: "Gesprächszeit (Sekunden)",
        huntingSeconds: "Suchzeit (Sekunden)",
        wrapUpSeconds: "Nachbearbeitungszeit (Sekunden)",
        queueWaitSeconds: "Wartezeit in der Warteschlange (Sekunden)",
        hour: "Stunde",
        dayOfWeek: "Wochentag",
        contact: "Kontakt",
        createdByName: "Erstellt von",
        endTime: "Gesprächsende",
        lead: "Lead",
        name: "Anrufbericht",
        phoneMinutes: "Zeit am Telefon (Min.)",
        ringSeconds: "Klingelzeit (Sekunden)",
        wrapUpString1: "Wrap-up-Text 1",
        fromNatterboxUserName: "Natterbox-Benutzer (von)",
        toNatterboxUserName: "Natterbox-Benutzer (an)",
      },
      OPPORTUNITIES: {
        createdDate: "Erstelldatum",
        closeDate: "Schlusstermin",
        stage: "Phase",
        ownerName: "Opportunity-Inhaber",
        recordType: "Datensatztyp",
        accountName: "Accountname",
        age: "Alter (Tage)",
        amount: "Betrag",
        endDate: "Enddatum",
        expectedRevenue: "Erwarteter Umsatz",
        fiscalQuarter: "Geschäftsquartal",
        individualOfferSent: "Individuelles Angebot geschickt",
        leadSource: "Lead-Quelle",
        name: "Opportunity-Name",
        nextStep: "Nächster Schritt",
        ownerRole: "Rolle des Inhabers",
        probability: "Wahrscheinlichkeit (%)",
        quantity: "Menge",
        remainingTestDays: "Verbleibende Testtage",
        testEndDate: "Testende (spätestes)",
        testStartDate: "Testbeginn (frühestes)",
        type: "Typ",
      },
      CONTRACT_ITEMS: contractItemReportFields,
      CONTRACTS: {
        endDate: "Vertragsende",
        status: "Status",
        recordType: "Datensatztyp",
        accountRecordType: "Account-Datensatztyp",
        opportunityStage: "Opportunity-Phase",
        accountName: "Accountname",
        contractNumber: "Vertragsnummer",
        opportunityAccountRecordType: "Opportunity: Account-Datensatztyp",
        priceBookName: "Preisbuch",
        recordTypeName: "Datensatztyp",
      },
      CASES: {
        ageDays: "Alter (Tage)",
        ownerId: "Inhaber-ID",
        createdDate: "Datum geöffnet",
        closedDate: "Datum geschlossen",
        status: "Status",
        type: "Typ",
        origin: "Fallursprung",
        ownerName: "Fallinhaber",
        lastModifiedByName: "Zuletzt geändert von",
        accountType: "Account-Typ",
        cancellationProcess: "Kündigungsprozess",
        firstReactionTime: "Erste Reaktionszeit",
        resolutionDays: "Zeit bis zur Lösung (Tage)",
        accountContractType: "Account: Vertragstyp",
        accountName: "Accountname",
        accountStandardType: "Account: Typ",
        accountTypePicklist: "Account: Account-Typ",
        ageHours: "Alter (Stunden)",
        caseNumber: "Fallnummer",
        contractItemCount: "Anzahl Vertragspositionen",
        createdDay: "Eröffnungsdatum",
        firstCallLoggedAt: "Erster Anruf protokolliert",
        firstEmailAnswerAt: "Erste E-Mail-Antwort",
        isClosed: "Geschlossen",
        isOpen: "Offen",
        recordType: "Fall-Datensatztyp",
        subject: "Betreff",
        subtype: "Untertyp",
      },
      ACCOUNTS: {
        name: "Accountname",
        documentationSystem: "Dokumentationssystem",
        documentationSystemUser: "Dokumentationssystem-Benutzer",
        documentationSystemDate: "Dokumentationssystem-Datum",
        interestedIn: "Interesse an",
        billingState: "Bundesland (Rechnung)",
        comment: "Account-Kommentar",
        documentationSystemInterest: "Interesse an Dokumentationssystem",
        lastModifiedByName: "Zuletzt geändert von",
        lastModifiedDay: "Zuletzt geändert am",
        traegerName: "Träger",
        type: "Typ",
      },
      CAMPAIGN_MEMBERS: {
        createdDate: "Mitglied seit",
        createdByName: "Erstellt von",
        campaignName: "Kampagnenname",
        status: "Mitgliedsstatus",
        isContact: "Kontakt",
        campaignCreatedByName: "Kampagne erstellt von",
        campaignCreatedDate: "Kampagne erstellt am",
        campaignLastModifiedByAlias: "Zuletzt geändert von (Alias)",
        campaignStatus: "Kampagnenstatus",
        firstName: "Vorname",
        lastName: "Nachname",
      },
    },
    components: {
      LOGISTICS_SHIPPING: { title: "Versandbereite Aufträge" },
      LOGISTICS_OPEN_WEEKLY: { title: "Offene Aufträge – wöchentlich" },
      LOGISTICS_EXPECTED_RETURNS: { title: "Erwartete Rücksendungen" },
      LOGISTICS_RETURNED_TABLE: { title: "Zurückgesendete Geräte" },
      LOGISTICS_SHIPPED: { title: "Versendete Aufträge" },
      LOGISTICS_OPEN_DAILY: { title: "Offene Aufträge – täglich" },
      LOGISTICS_RETURNED_CHART: { title: "Zurückgesendete Geräte" },
      LOGISTICS_ENDED_CONTRACT_ITEMS: { title: "Beendete Vertragspositionen ohne Rücksendung" },
      LOGISTICS_OPEN_CASES: { title: "Offene Logistikfälle" },

      CS_CALLS_PER_REP_DAILY: { title: "Tägliche Anrufe nach Rep" },
      CS_SUCCESSFUL_CALLS_DAILY: { title: "Erfolgreiche Calls nach Rep täglich" },
      CS_UNIQUE_CUSTOMERS_DAILY: { title: "Erf. Calls per Unique Customer daily" },
      CS_AVERAGE_TALK_TIME_DAILY: { title: "Avg Time Talking per Rep CS daily" },
      CS_AVERAGE_WRAP_UP_DAILY: { title: "Avg Wrap Up per Rep CS daily" },
      CS_SECOND_CALLS_DAILY: { title: "Erf. Zweite Calls per Unique C. daily" },
      CS_DCALL_FOLLOW_UP: { title: "DCall Follow Up" },
      CS_CALLS_PER_REP_WEEKLY: { title: "Wöchentliche Anrufe nach Rep" },
      CS_SUCCESSFUL_CALLS_WEEKLY: { title: "Erfolgreiche Calls per Rep CS weekly" },
      CS_UNIQUE_CUSTOMERS_WEEKLY: { title: "Erf. Calls per Unique Customer weekly" },
      CS_AVERAGE_TALK_TIME_WEEKLY: { title: "Avg Time Talking per Rep CS weekly" },
      CS_AVERAGE_WRAP_UP_WEEKLY: { title: "Avg Wrap per Rep CS weekly" },
      CS_SECOND_CALLS_WEEKLY: { title: "Erf. Zweite Calls per Unique C. weekly" },
      CS_CALLS_PER_REP_MONTHLY: { title: "Monatliche Anrufe nach Rep" },
      CS_SUCCESSFUL_CALLS_MONTHLY: { title: "Erfolgreiche Calls per Rep monthly" },
      CS_UNIQUE_CUSTOMERS_MONTHLY: { title: "Erf. Calls per Unique Customer monthly" },
      CS_AVERAGE_TALK_TIME_MONTHLY: { title: "Avg Time Talking per Rep monthly" },
      CS_AVERAGE_WRAP_UP_MONTHLY: { title: "Avg Wrap Up per Rep monthly" },
      CS_SECOND_CALLS_MONTHLY: { title: "Erf. Zweite Calls per Unique C. monthly" },
      SALES_CALLS_PER_REP_DAILY: { title: "Calls per Rep CS daily" },
      SALES_CALLS_PER_REP_WEEKLY: { title: "Calls per Rep weekly" },
      SALES_CALLS_PER_REP_MONTHLY: { title: "Calls per Rep monthly" },
      SALES_CALLS_MONTHLY: { title: "Calls monthly" },
      SALES_OPEN_OPPORTUNITIES_BY_CLOSE_WEEK: { title: "Open Opps per Close Date weekly" },
      SALES_OPEN_OPPORTUNITIES_BY_OWNER: { title: "Open Opportunities per Rep overall" },
      SALES_SUBSCRIPTIONS_STARTING: { title: "Betreuer Subs Starting monthly" },
      SALES_TRAINING_SUBSCRIPTIONS: { title: "Pflichtfortbildung Subs monthly" },
      SALES_OPPORTUNITIES_PER_REP_DAILY: { title: "Opps per Rep daily" },
      SALES_OPPORTUNITIES_PER_REP_WEEKLY: { title: "Opps created per Rep weekly" },
      SALES_OPPORTUNITIES_PER_REP_MONTHLY: { title: "Opps per Rep monthly" },
      SALES_OPPORTUNITIES_MONTHLY: { title: "Opps monthly" },
      SALES_OPEN_OPPORTUNITIES_BY_CLOSE_MONTH: { title: "Open Opportunities per Rep" },
      SALES_SUBSCRIPTIONS_ENDING: { title: "Betreuer Subs Ending monthly" },
      SALES_TV_BOXES: { title: "Anzahl TV Boxen" },
      SALES_ONE_TIME_UPSELLS: { title: "Upsells One time monthly" },
      SALES_SUBSCRIPTIONS_PER_REP_DAILY: { title: "Betreuer Subs by Rep daily" },
      SALES_SUBSCRIPTIONS_PER_REP_WEEKLY: { title: "Betreuer Subs per Rep weekly" },
      SALES_ALL_SUBSCRIPTIONS_PER_REP_MONTHLY: { title: "Subs per Rep monthly" },
      SALES_SUBSCRIPTIONS_MONTHLY: { title: "Betreuer Subs monthly" },
      WEEKLY_CAREGIVER_TABLETS_ACTIVE: { title: "Betreuer Tablet Active Subscriptions" },
      WEEKLY_TESTS_CREATED_MONTHLY: { title: "Tests created monthly" },
      WEEKLY_TESTS_CREATED_WEEKLY: { title: "Tests created weekly" },
      WEEKLY_SENIOR_TESTS: { title: "Senioren Tests weekly" },
      WEEKLY_CAREGIVER_TESTS: { title: "Betreuer Tests weekly" },
      WEEKLY_SENIOR_CHURN_WEEKLY: { title: "Churn Senioren Subs weekly" },
      WEEKLY_CAREGIVER_CHURN_WEEKLY: { title: "Churn Betreuer Subs weekly" },
      WEEKLY_SENIOR_TABLETS_ACTIVE: { title: "Senioren Tablet Active Subscriptions" },
      WEEKLY_SUBSCRIPTIONS_MONTHLY: { title: "Subs Total monthly" },
      WEEKLY_SUBSCRIPTIONS_WEEKLY: { title: "Subs Total weekly" },
      WEEKLY_SENIOR_SUBSCRIPTIONS_WEEKLY: { title: "Senioren Subs weekly" },
      WEEKLY_CAREGIVER_SUBSCRIPTIONS_WEEKLY: { title: "Betreuer Subs weekly" },
      WEEKLY_SENIOR_CHURN_MONTHLY: { title: "Churn Senioren Subs monthly" },
      WEEKLY_CAREGIVER_CHURN_MONTHLY: { title: "Churn Betreuer Subs monthly" },
      WEEKLY_LICENCES_ACTIVE: { title: "Lizenzen Active Subscriptions" },
      WEEKLY_SOLD_TABLETS_MONTHLY: { title: "Sold Tablets monthly" },
      WEEKLY_SOLD_TABLETS_WEEKLY: { title: "Sold Tablets weekly" },
      WEEKLY_SENIOR_SUBSCRIPTIONS_MONTHLY: { title: "Senioren Subs monthly" },
      WEEKLY_CAREGIVER_SUBSCRIPTIONS_MONTHLY: { title: "Betreuer Subs monthly" },
      WEEKLY_ONE_TIME_UPSELLS: { title: "Upsells One time monthly" },
      DOCUMENTATION_SYSTEMS: { title: "Pflegedokumentationssysteme" },
      DOCUMENTATION_SYSTEM_DATES: { title: "Pflegedokumentationssyste Date" },
      DOCUMENTATION_INTERESTED_ACCOUNTS: { title: "Pflegedok. interessierte Kunden" },
      DOCUMENTATION_SYSTEM_USERS: { title: "Pflegedokumentationssyste Anzahl MA" },
      DOCUMENTATION_SYSTEM_ACCOUNTS: { title: "Pflegedokumentationssyste Anzahl Acc." },
      SUPPORT_OPEN_CASES: { title: "Nicht bearbeitete/offene Cases" },
      SUPPORT_INCOMING_CASES: {
        title: "Incoming Case Volumen Support / month",
        footer:
          "Zeigt die Datensatzzahl und den Status der eingehenden Cases pro Monat. (Bericht anzeigen um den Status pro Typ zu sehen)",
      },
      SUPPORT_TIME_TO_CLOSE: {
        title: "Time to be closed (Cases) Month/per Day",
        footer:
          "Zeigt den durchschn. Wert für alle C.Support Cases in Tagen bis zum Status geschlossen. (Bericht anzeigen um den Durchschnitt pro Typ zu sehen)",
      },
      SUPPORT_NEW_CASES_BY_CHANNEL: {
        title: "New Cases per Month (Channel)",
        footer:
          "Zeigt die Datensatzzahl an eingehenden Cases pro Monat und Channel (Bericht anzeigen um den Eingang pro Tag zusehen) Filter kann auch auf Segment gesetzt werden.",
      },
      SUPPORT_REACHABILITY_LAST_QUARTER: { title: "Erreichbarkeit Service letztes Quartal" },
      SUPPORT_REACHABILITY_DAILY: { title: "Erreichbarkeit Dayli Support" },
      SUPPORT_HOTLINE_TODAY_BY_HOUR: { title: "Hotline Erreichbarkeit Today/hour" },
      SUPPORT_TALK_TIME_BY_WRAP_UP: { title: "Time talking per Wrap up lable / Month" },
      SUPPORT_TO_SALES_BY_AGENT: { title: "Support to Sales Month Agent" },
      SUPPORT_INBOUND_CALLS_MONTHLY: { title: "Calls done per Month Inbound" },
      SUPPORT_FIRST_REACTION_TIME: {
        title: "First Reaction Time Cases per Day",
        footer: "Zeigt den durchschn. Wert der Reaktionszeit auf einen eingehenden Case in Tagen",
      },
      SUPPORT_CLOSED_CASES_BY_SEGMENT: {
        title: "Geschlossene Cases B2B/B2C-Monthly",
        footer: "Bericht anzeigen, zeigt die geschlossenen Cases per Typ",
      },
      SUPPORT_REACHABILITY_THIS_QUARTER: {
        title: "Hotline Erreichbarkeit Service aktuelles Quartal",
        footer:
          "Zeigt die HL Erreichbarkeit in Prozent pro Quartal (Bericht anzeigen um die Erreichbarkeit in % pro Monat zu sehen).",
      },
      SUPPORT_HOTLINE_TODAY_BY_QUEUE: { title: "Hotline Calls Today per Call Queue" },
      SUPPORT_HOTLINE_YESTERDAY_BY_QUEUE: { title: "Hotline Calls gestern Call Queue" },
      SUPPORT_HOTLINE_VOLUME: { title: "Hotline Volumen total ohne Servicezeiten" },
      SUPPORT_TO_SALES_STATUS: { title: "BK Support to Sales Status" },
      SUPPORT_TOTAL_CALLS_MONTHLY: { title: "Total Calls Month" },
      SUPPORT_WAIT_AND_TALK_TIME: {
        title: "HL Wartezeit und time talking (Monat)",
        footer: "Zeigt die durchschn. Warte- und Gesprächszeit pro Monat in Sekunden.",
      },
      SUPPORT_TO_SALES_BY_CAMPAIGN: { title: "BK Support to Sales Status" },
      CHURN_OPEN_CANCELLATION_CASES: {
        title: "Offene Kündigungs-Cases Prof.",
        subtitle: "Kündigungen im Bearbeitungsstatus",
        footer: "Zeigt an wie viele Kündigungen sich noch in Bearbeitung befinden",
      },
      CHURN_INCOMING_CASES: { title: "Eingehende Kündigungs-Cases Prof.", subtitle: "Pro Monat" },
      CHURN_LOST_ACCOUNTS: {
        title: "Gekündigte Accounts Prof. pro Monat",
        subtitle: "Zeigt an wie viele Acc. pro Monat enden",
        footer: "Zeigt an wie viele Accounts pro Monat enden",
      },
      CHURN_REASONS: {
        title: "Kündigungsgründe Prof. ab 2024",
        footer: "Zeigt die Kündigungsgründe im aktuellen Jahr",
      },
      CHURN_WIN_BACK_BY_INTAKE: {
        title: "Win Back Quote Prof.",
        subtitle: "Nach Eingang des Cases",
        footer: "Zeigt den Durchschnitt nach Eingang des Cases zu Verloren/Gewonnen",
      },
      CHURN_B2C_INCOMING_SUBSCRIPTIONS: { title: "Eingehende Kündigungen SUB B2C" },
      CHURN_WIN_BACK_LAST_QUARTER: { title: "Win back vorheriges Quartal" },
      CHURN_INCOMING_SUBSCRIPTIONS: { title: "Eingehende Kündigungen SUB Prof." },
      CHURN_INCOMING_CASES_BY_STATUS: {
        title: "Eingehende Kündigungs-Cases Prof.",
        subtitle: "Pro Monat und deren Status",
        footer: "Zeigt den Eingang an Kündigungen per Monat und Status",
      },
      CHURN_LOST_SUBSCRIPTIONS: {
        title: "Gekündigte SUBs Prof. pro Monat",
        subtitle: "Zeigt an wie viele SUBs pro Monat enden",
        footer: "Zeigt den Wert wie viele Items verloren wurden",
      },
      CHURN_WIN_BACK_OPPORTUNITIES: {
        title: "Win Back Opportunity Prof.",
        subtitle: "Für erneute Kontaktaufnahme über Sales",
        footer: "Zeigt die WIN Back-Subs, welche für zukünftige Sales verwendet werden können",
      },
      CHURN_UNLICENSED_LOST_SUBSCRIPTIONS: {
        title: "Gekündigte SUBS Prof. ohne aktivierte Lizenz",
        subtitle: "Zeigt an wie viele SUBs pro Monat enden",
        footer:
          "Zeigt an wie viele der gekündigten Items nicht lizenziert wurden und somit keine aktuelle Version nutzten.",
      },
      CHURN_B2C_ENDING_SUBSCRIPTIONS: { title: "Endende Verträge SUB B2C" },
      CHURN_WIN_BACK_THIS_QUARTER: {
        title: "Win Back Quote im Quartal Prof.",
        subtitle: "Nach Abschluss des Cases",
        footer: "Zeigt den Durchschnitt NACH Abschluss des Cases zu Verloren / gewonnen",
      },
      CHURN_FIRST_REACTION_TIME: { title: "First Reaction Time Kündigung Cases" },
    },
  },
  salesforceIntegration: {
    title: "Integrationen",
    heading: "Salesforce",
    description:
      "Kopiert Produkte, Accounts, Verträge, Kontakte, Fälle und ihre Kommunikation aus Salesforce in die CRM-Ansicht. Nach Salesforce wird nichts geschrieben.",
    loading: "Salesforce-Integration wird geladen",
    loadError: "Die Salesforce-Integration konnte nicht geladen werden.",
    save: "Speichern",
    saved: "Salesforce-Integration gespeichert",
    saveError: "Die Einstellungen konnten nicht gespeichert werden.",
    connection: {
      title: "Verbindung",
      loginUrl: "Login-URL",
      loginUrlHint: "https://<name>.my.salesforce.com oder https://<name>.sandbox.my.salesforce.com",
      clientId: "Client-ID (Consumer Key)",
      clientSecret: "Client Secret (Consumer Secret)",
      clientSecretStored:
        "Gespeichert. Leer lassen, um es zu behalten. Nach einer Änderung von Login-URL oder Client-ID neu eingeben.",
      check: "Verbindung testen",
      ok: "Verbindung erfolgreich. Heute sind noch %{remaining} von %{max} Salesforce-API-Anfragen frei.",
      failed: "Verbindung fehlgeschlagen (Fehlercode: %{code}).",
      checkError: "Die Verbindung konnte nicht geprüft werden.",
    },
    anonymization: {
      title: "Anonymisierung",
      label: "Kopierte Daten anonymisieren",
      required: "Außerhalb der Produktion werden die Daten immer anonymisiert.",
      realDataWarning: "Es werden echte Kundendaten kopiert. Nur nach Freigabe durch den Datenschutz ausschalten.",
    },
    schedule: {
      title: "Zeitplan",
      off: "Aus",
      daily: "Täglich",
      interval: "Regelmäßig",
      workdayWindow: "Werktags häufiger",
      dailyTime: "Uhrzeit (Europe/Berlin)",
      intervalHours: "Intervall",
      hours: "Alle %{smart_count} Stunde |||| Alle %{smart_count} Stunden",
      minutes: "Alle %{smart_count} Minute |||| Alle %{smart_count} Minuten",
      windowStart: "Montag bis Freitag ab (Europe/Berlin)",
      windowEnd: "Montag bis Freitag bis (Europe/Berlin)",
      windowIntervalMinutes: "Intervall in dieser Zeit",
      outsideIntervalHours: "Intervall sonst und am Wochenende",
      workdayWindowHint:
        "Feiertage zählen als Werktage. Außerhalb der Zeit läuft die Synchronisation ab Mitternacht im gewählten Abstand.",
      anonymizedWarning:
        "Solange die Daten anonymisiert werden, liest jeder Lauf alle Datensätze statt nur der Änderungen. So häufige Läufe verbrauchen dann schnell das Tageskontingent der Salesforce-API.",
      nextRun: "Nächster Lauf: %{time}",
      nextRunDue: "Der nächste Lauf startet in den nächsten 5 Minuten.",
    },
    runs: {
      title: "Letzte Läufe",
      loading: "Läufe werden geladen",
      loadError: "Die Läufe konnten nicht geladen werden.",
      empty: "Noch keine Läufe.",
      start: "Jetzt synchronisieren",
      started: "Synchronisation angefordert. Sie erscheint hier, sobald sie startet.",
      startError: "Die Synchronisation konnte nicht gestartet werden.",
      startUnavailable: "Erst möglich, wenn die Verbindung gespeichert ist.",
      startFull: "Vollständig synchronisieren",
      startFullTitle: "Vollständig synchronisieren?",
      startFullConfirm:
        "Der Lauf liest jeden Datensatz aus Salesforce, wie der erste Lauf, und markiert, was Salesforce nicht mehr hat. Er braucht etwa 1.700 Salesforce-API-Aufrufe, etwa 1,5 % des Tageskontingents.",
      fullStarted: "Vollständige Synchronisation angefordert. Sie erscheint hier, sobald sie startet.",
      startedAt: "Start",
      finishedAt: "Ende",
      trigger: "Auslöser",
      mode: "Gelesen",
      status: "Status",
      anonymized: "Anonymisiert",
      records: "Datensätze",
      apiCalls: "API-Aufrufe",
      errorCode: "Fehlercode",
      yes: "Ja",
      no: "Nein",
      unavailable: "Nicht verfügbar (fehlende Berechtigung oder nicht im Salesforce-Schema vorhanden): %{objects}",
      allowance: "%{remaining} von %{max} frei",
      triggers: { SCHEDULE: "Zeitplan", MANUAL: "Manuell" },
      modes: {
        INITIAL: "Alles (erster Lauf)",
        ANONYMISED: "Alles, anonymisiert",
        INCREMENTAL: "Nur Änderungen",
        FULL: "Vollständig",
      },
      statuses: { RUNNING: "Läuft", SUCCEEDED: "Erfolgreich", FAILED: "Fehlgeschlagen", SKIPPED: "Übersprungen" },
      progress: "Schritt %{step}/%{total}: %{phase}",
      phaseRecords: "%{count} Datensätze verarbeitet",
      progressAt: "Letzter Fortschritt: %{time}",
      phases: {
        READING: "Salesforce-Daten lesen",
        ACCOUNTS: "Accounts und CRM importieren",
        INVENTORY: "Inventar importieren",
        COMMUNICATION: "Kommunikation importieren",
        EMAIL_BODIES: "Aktuelle E-Mail-Inhalte importieren",
        FINALIZING: "Import abschließen",
      },
      counts: {
        products: "Produkte",
        accounts: "Accounts",
        contracts: "Verträge",
        items: "Vertragspositionen",
        users: "Benutzer",
        contacts: "Kontakte",
        leads: "Leads",
        orders: "Bestellungen",
        cases: "Fälle",
        emails: "E-Mails",
        caseComments: "Fallkommentare",
        caseHistories: "Fallverläufe",
        calls: "Anrufe",
      },
      errors: {
        "quota-low": "Weniger als 25 % des Tageskontingents frei",
        "anonymization-leak": "Die anonymisierte Kopie enthielt noch echte Daten; nichts wurde geschrieben.",
        interrupted:
          "Der Lauf wurde unterbrochen, zum Beispiel durch einen Neustart. Als Ende gilt der Zeitpunkt, an dem der nächste Lauf das bemerkt hat.",
        "query-record-limit": "Eine Salesforce-Abfrage lieferte mehr Datensätze, als ein Lauf auf einmal lesen kann.",
        "query-incomplete-page": "Salesforce lieferte eine unvollständige Ergebnisseite.",
        "paging-stalled": "Das seitenweise Lesen aus Salesforce kam nicht voran.",
        "fake-id-collision": "Zwei Salesforce-IDs ergaben dieselbe anonymisierte ID; nichts wurde geschrieben.",
        "oauth-response-incomplete": "Salesforce lieferte bei der Anmeldung kein Zugriffstoken oder keine Instanz-URL.",
        "database-timeout": "Eine Datenbankabfrage dauerte zu lange; nichts wurde geschrieben.",
      },
    },
    errors: {
      "salesforce-login-url-invalid":
        "Die Login-URL muss https://<name>.my.salesforce.com oder https://<name>.sandbox.my.salesforce.com sein.",
      "salesforce-client-id-invalid": "Die Client-ID ist ungültig.",
      "salesforce-client-secret-invalid": "Das Client Secret ist zu lang.",
      "salesforce-client-secret-required":
        "Bitte das Client Secret eingeben. Nach einer Änderung von Login-URL oder Client-ID muss es neu eingegeben werden.",
      "salesforce-anonymization-required": "Außerhalb der Produktion lässt sich die Anonymisierung nicht ausschalten.",
      "salesforce-schedule-invalid": "Der Zeitplan ist ungültig.",
      "salesforce-integration-not-configured": "Bitte zuerst die Verbindung speichern.",
    },
  },
  marketingDelivery: {
    title: "Integrationen",
    heading: "Marketing-Versand",
    description:
      "Der Versanddienst stellt die Marketing-E-Mails zu. Schlüssel und Secrets werden verschlüsselt gespeichert und nie wieder angezeigt.",
    loading: "Marketing-Versand wird geladen",
    loadError: "Der Marketing-Versand konnte nicht geladen werden.",
    save: "Speichern",
    saved: "Marketing-Versand gespeichert",
    saveError: "Die Einstellungen konnten nicht gespeichert werden.",
    provider: {
      title: "Versanddienst",
      type: "Anbieter",
      types: { FAKE: "Testanbieter (verschickt nichts)" },
      apiKey: "API-Schlüssel",
      apiSecret: "API-Secret",
      webhookSecret: "Webhook-Secret",
      stored: "Gespeichert. Leer lassen, um den gespeicherten Wert zu behalten.",
      webhookSecretHint: "16 bis 512 Zeichen. Denselben Wert beim Anbieter für die Webhooks eintragen.",
    },
    sender: {
      title: "Absender",
      sendingDomain: "Versanddomain",
      sendingDomainHint: "Eine eigene Subdomain nur für Marketing, z. B. news.media4care.de.",
      fromAddress: "Absenderadresse",
      fromAddressHint: "Muss auf der Versanddomain liegen.",
      fromName: "Absendername",
      replyToAddress: "Antwortadresse (optional)",
    },
    dns: {
      title: "DNS-Einträge der Versanddomain",
      description:
        "Diese Einträge setzen Sie bei Ihrem DNS-Anbieter. Nach einer Änderung kann es einige Stunden dauern, bis sie sichtbar sind.",
      fakeNote:
        "Der Testanbieter hat keine eigenen DNS-Einträge: SPF und DKIM sind Beispielwerte. DMARC gilt für jeden Anbieter.",
      recheck: "Erneut prüfen",
      loading: "DNS-Einträge werden geprüft",
      loadError: "Die DNS-Einträge konnten nicht geprüft werden.",
      checkedAt: "Geprüft: %{time}",
      found: "Gefunden: %{values}",
      columns: { purpose: "Zweck", type: "Typ", name: "Name", value: "Wert", status: "Status" },
      purposes: { SPF: "SPF", DKIM: "DKIM", DMARC: "DMARC" },
      statuses: {
        VERIFIED: "Gesetzt",
        INHERITED: "Von der Hauptdomain",
        MISSING: "Fehlt",
        MISMATCH: "Abweichend",
        UNKNOWN: "Nicht prüfbar",
      },
    },
    testSend: {
      title: "Test-E-Mail",
      to: "Empfänger",
      send: "Test-E-Mail senden",
      accepted: "Vom Versanddienst angenommen. Nachrichten-ID: %{id}",
      failed: "Die Test-E-Mail wurde nicht angenommen (Fehlercode: %{code}).",
      sendError: "Die Test-E-Mail konnte nicht gesendet werden.",
      restricted:
        "Außerhalb der Produktion erhalten nur diese Adressen echte E-Mails: %{recipients}. Der Testanbieter verschickt nichts.",
      restrictedNone:
        "Außerhalb der Produktion ist keine Adresse freigegeben. Nur der Testanbieter sendet, und er verschickt nichts.",
      errors: {
        "marketing-recipient-not-allowed": "Diese Adresse ist außerhalb der Produktion nicht freigegeben.",
        "marketing-provider-not-allowed":
          "In der Produktion sendet der Testanbieter nicht. Bitte einen echten Versanddienst einrichten.",
        "marketing-provider-error": "Der Versanddienst hat nicht geantwortet. Bitte später erneut versuchen.",
        "fake-recipient-rejected": "Der Testanbieter hat diese Adresse abgelehnt.",
      },
    },
    errors: {
      "marketing-provider-invalid": "Unbekannter Anbieter.",
      "marketing-credentials-required": "Dieser Anbieter braucht einen API-Schlüssel und ein API-Secret.",
      "marketing-secret-invalid":
        "API-Schlüssel oder API-Secret ist ungültig: höchstens 512 Zeichen, keine Steuerzeichen.",
      "marketing-webhook-secret-invalid": "Das Webhook-Secret braucht 16 bis 512 Zeichen ohne Steuerzeichen.",
      "marketing-sending-domain-invalid":
        "Die Versanddomain muss eine gültige Subdomain sein, z. B. news.media4care.de.",
      "marketing-from-address-invalid": "Die Absenderadresse muss eine gültige Adresse auf der Versanddomain sein.",
      "marketing-from-name-invalid": "Der Absendername braucht 1 bis 100 Zeichen ohne Zeilenumbruch.",
      "marketing-reply-to-invalid": "Die Antwortadresse ist ungültig.",
      "marketing-delivery-not-configured": "Bitte zuerst die Einstellungen speichern.",
      "marketing-test-recipient-invalid": "Bitte eine gültige E-Mail-Adresse eingeben.",
      "marketing-provider-not-allowed":
        "In der Produktion ist der Testanbieter nicht erlaubt. Bitte einen echten Versanddienst wählen.",
    },
  },
  crm: {
    duplicates: {
      title: "Mögliche Duplikate",
      explanation:
        "Die Punktzahl von 0 bis 100 beschreibt die Stärke der Hinweise, keine Wahrscheinlichkeit. Gleiche Anschriften oder Telefonnummern allein reichen nicht aus.",
      object: "Datensatztyp",
      allObjects: "Accounts und Leads",
      minScore: "Mindestpunktzahl",
      status: "Prüfstatus",
      statuses: {
        PENDING: "Offen",
        CONFIRMED: "Duplikat bestätigt",
        DISMISSED: "Kein Duplikat",
        DEFERRED: "Zurückgestellt",
        ALL: "Alle",
      },
      score: "Punktzahl",
      records: "Datensätze",
      reasonsTitle: "Hinweise und Konflikte",
      compare: "Vergleichen",
      comparison: "Datensätze vergleichen",
      scoreLabel: "Punktzahl %{score} von 100",
      field: "Feld",
      matchColumn: "Vergleich",
      normalizedValue: "Normalisierter Vergleichswert",
      bestAddressPair: "Verglichen wird das ähnlichste Anschriftenpaar.",
      matchStates: {
        match: "Stimmt überein",
        similar: "Ähnlich",
        similarPercent: "Ähnlich (%{percent} %)",
        conflict: "Unterschiedlich",
        missing: "Nicht vergleichbar",
      },
      summary: {
        match: "%{count} gleich",
        similar: "%{count} ähnlich",
        conflict: "%{count} unterschiedlich",
      },
      name: "Name",
      createdBy: "Erstellt von",
      createdAt: "Erstellt am",
      company: "Unternehmen",
      email: "E-Mail",
      phone: "Telefon",
      extension: "Durchwahl",
      addresses: "Anschriften",
      street: "Straße",
      house: "Hausnummer",
      unit: "Wohnung / Einheit",
      city: "Ort",
      state: "Bundesland",
      postalCode: "Postleitzahl",
      country: "Land",
      confirm: "Duplikat bestätigen",
      dismiss: "Kein Duplikat",
      defer: "Später prüfen",
      close: "Schließen",
      saving: "Entscheidung wird gespeichert …",
      saveError:
        "Die Entscheidung konnte nicht gespeichert werden. Die Liste wird aktualisiert. Bitte vergleichen Sie die aktuellen Daten erneut.",
      reviewRefreshWarning:
        "Die Entscheidung wurde gespeichert. Die Liste konnte nicht aktualisiert werden. Bitte erneut laden.",
      refresh: "Aktualisieren",
      loadError: "Die Duplikate konnten nicht geladen werden.",
      empty: "Keine möglichen Duplikate für diese Filter.",
      notScanned: "Nach dem nächsten CRM-Import werden mögliche Duplikate geprüft.",
      suppressed: "Für anonymisierte CRM-Daten ist die Duplikatprüfung ausgesetzt.",
      scannedAt: "Zuletzt geprüft: %{time}",
      page: "%{from}–%{to} von %{count}",
      rowsPerPage: "Paare pro Seite",
      nextPage: "Nächste Seite",
      previousPage: "Vorherige Seite",
      reasons: {
        name_exact: "Name stimmt überein",
        name_fuzzy: "Name ist ähnlich",
        name_weak: "Name ist teilweise ähnlich",
        email_exact: "E-Mail stimmt überein",
        phone_exact: "Telefonnummer stimmt überein",
        address_exact: "Anschrift stimmt überein",
        address_fuzzy: "Anschrift ist ähnlich",
        company_exact: "Unternehmen stimmt überein",
        email_conflict: "E-Mail unterscheidet sich",
        phone_conflict: "Telefonnummer unterscheidet sich",
        extension_conflict: "Durchwahl unterscheidet sich",
        house_conflict: "Hausnummer unterscheidet sich",
        unit_conflict: "Wohnung / Einheit unterscheidet sich",
        country_conflict: "Land unterscheidet sich",
        unknown: "Weiterer Hinweis",
      },
    },
    title: "CRM",
    loading: "CRM-Daten werden geladen",
    loadError: "Die CRM-Daten konnten nicht geladen werden.",
    syncedAt: "Stand: %{time}",
    deletedInSalesforce: "In Salesforce gelöscht",
    deletedInSalesforceAt: "Am %{time} in Salesforce gelöscht",
    accountDeleted: "Konto gelöscht",
    objects: {
      ACCOUNT: { one: "Account", many: "Accounts" },
      OPPORTUNITY: { one: "Opportunity", many: "Opportunities" },
      CONTACT: { one: "Kontakt", many: "Kontakte" },
      LEAD: { one: "Lead", many: "Leads" },
      CASE: { one: "Case", many: "Cases" },
      CONTRACT: { one: "Vertrag", many: "Verträge" },
      CONTRACT_ITEM: { one: "Vertragsposition", many: "Vertragspositionen" },
      ORDER: { one: "Auftrag", many: "Aufträge" },
      LEAD_PRODUCT: { one: "Lead-Produkt", many: "Lead-Produkte" },
      CAMPAIGN: { one: "Kampagne", many: "Kampagnen" },
      CAMPAIGN_MEMBER: { one: "Kampagnenmitglied", many: "Kampagnenmitglieder" },
    },
    list: {
      count: "%{total} Einträge",
      countTruncated: "%{shown} von %{total} Einträgen",
      sortedBy: "Sortiert nach %{column}",
      searchPlaceholder: "Diese Liste durchsuchen …",
      searchLabel: "%{list} durchsuchen",
      listViewLabel: "Listenansicht",
      empty: "Keine Einträge.",
      loadMore: "Weitere %{count} laden",
      relatedTitle: "%{list} · %{record}",
      backToRecord: "Zurück zum Datensatz",
      filters: "Filter",
      noValue: "(leer)",
    },
    listViews: {
      ACCOUNT: { all: "Alle Accounts", b2b: "B2B-Accounts", b2c: "B2C-Accounts", groups: "Träger & Gruppen" },
      OPPORTUNITY: { all: "Alle Opportunities" },
      CONTACT: {
        all: "Alle Kontakte",
        personAccounts: "Personenaccounts",
        doNotEmail: "Keine E-Mails",
        doNotCall: "Keine Anrufe",
        emailBounced: "E-Mail unzustellbar",
      },
      LEAD: {
        open: "Offene Leads",
        toContact: "Zu kontaktieren",
        keyAccount: "Key-Account-Prüfung",
        nurturing: "Nurturing",
        needsAction: "Handlungsbedarf",
        followUp: "Wiedervorlagen",
        closed: "Geschlossen & Opt-out",
        converted: "Konvertierte Leads",
        all: "Alle Leads",
        doNotEmail: "Keine E-Mails",
        doNotCall: "Keine Anrufe",
        emailBounced: "E-Mail unzustellbar",
      },
      CASE: {
        open: "Alle offenen Cases",
        waiting: "Warten auf Rückmeldung",
        escalated: "Eskalierte Cases",
        outsideSla: "Außerhalb SLA",
        closedToday: "Heute geschlossen",
        all: "Alle Cases",
      },
      CONTRACT: { all: "Alle Verträge", active: "Aktive Verträge", b2b: "B2B-Verträge", b2c: "B2C-Verträge" },
      CONTRACT_ITEM: {
        all: "Alle Vertragspositionen",
        active: "Aktive Vertragspositionen",
        pending: "In Vorbereitung",
        cancelled: "Gekündigt",
        ended: "Beendet",
      },
      ORDER: {
        all: "Alle Aufträge",
        open: "Offene Aufträge",
        readyForShipping: "Versandbereite Aufträge",
        returnLookup: "Rücksendung suchen",
      },
      LEAD_PRODUCT: { all: "Alle Lead-Produkte" },
      CAMPAIGN: { active: "Aktive Kampagnen", newsletters: "Newsletter-Verteiler", all: "Alle Kampagnen" },
      CAMPAIGN_MEMBER: { all: "Alle Kampagnenmitglieder" },
    },
    fields: {
      OPPORTUNITY: {
        name: "Name",
        account: "Account",
        stage: "Phase",
        closeDate: "Abschlussdatum",
        recordType: "Datensatztyp",
        owner: "Opportunity-Inhaber",
      },
      ACCOUNT: {
        name: "Accountname",
        recordType: "Datensatztyp",
        customerStatus: "Kundenstatus",
        activeProducts: "Aktive M4C-Produkte",
        parent: "Übergeordneter Account",
        isGroup: "Träger oder Gruppe",
        isPersonAccount: "Personenaccount",
        owner: "Accountinhaber",
        phone: "Telefon",
        website: "Website",
        billingAddress: "Rechnungsanschrift",
        shippingAddress: "Lieferanschrift",
        createdAt: "Erstellt am",
        lastModifiedAt: "Zuletzt geändert",
        activeItems: "Aktive Vertragspositionen",
        openCases: "Offene Cases",
        lastOnline: "Zuletzt online",
        lastContact: "Letzter Kontakt",
      },
      CONTACT: {
        name: "Name",
        salutation: "Anrede",
        title: "Position",
        account: "Account",
        email: "E-Mail",
        phone: "Telefon",
        mobilePhone: "Mobil",
        recordType: "Datensatztyp",
        customerStatus: "Kundenstatus",
        isPersonAccount: "Personenaccount",
        owner: "Kontaktinhaber",
        createdAt: "Erstellt am",
        openCases: "Offene Cases",
        lastContact: "Letzter Kontakt",
        consent: "Kontaktsperren",
        emailOptOut: "E-Mail-Opt-out",
        phoneOptOut: "Telefon-Opt-out",
        doNotCall: "Nicht anrufen",
        emailBouncedAt: "E-Mail unzustellbar seit",
        emailBouncedReason: "Grund der Unzustellbarkeit",
        newsletterOptOut: "Newsletter-Opt-out (GetResponse)",
        pardotScore: "Pardot-Score",
        pardotGrade: "Pardot-Grade",
        pardotCampaign: "Pardot-Kampagne",
        pardotCreatedAt: "In Pardot seit",
        pardotFirstActivityAt: "Erste Aktivität",
        pardotLastActivityAt: "Letzte Aktivität",
        pardotConvertedAt: "In Pardot konvertiert am",
        pardotConversionObjectType: "Konvertiert über (Typ)",
        pardotConversionObjectName: "Konvertiert über",
        pardotHardBounced: "Hard Bounce in Pardot",
        pardotUrl: "Pardot-Profil",
        pardotComments: "Pardot-Kommentare",
        pardotNotes: "Pardot-Notizen",
        utmSource: "UTM Source",
        utmMedium: "UTM Medium",
        utmCampaign: "UTM Campaign",
        utmContent: "UTM Content",
        utmTerm: "UTM Term",
        firstTouchUrl: "Erster Seitenaufruf",
        firstSearchTerm: "Erster Suchbegriff",
        firstSearchType: "Erste Suchart",
      },
      LEAD: {
        name: "Name",
        company: "Unternehmen",
        status: "Leadstatus",
        email: "E-Mail",
        phone: "Telefon",
        leadSource: "Leadquelle",
        recordType: "Datensatztyp",
        owner: "Leadinhaber",
        isConverted: "Konvertiert",
        convertedDate: "Konvertiert am",
        convertedAccount: "Konvertierter Account",
        convertedContact: "Konvertierter Kontakt",
        createdAt: "Erstellt am",
        leadSourceDetail: "Leadquelle Detail",
        convertTo: "Konvertieren zu",
        primarySector: "Sektor",
        krankenkasse: "Krankenkasse",
        campaignMemberCount: "Kampagnen",
        b2bAccount: "B2B-Account",
        traeger: "Träger",
        isKeyAccount: "Key Account",
        startDate: "Gewünschter Start",
        statusChangedAt: "Status geändert am",
        // Zeitstempel_Wiedervorlage__c: the day the lead went into follow-up.
        followUpDate: "In Wiedervorlage seit",
        lostReason: "Verlustgrund",
        convertedAt: "Konvertiert um",
        convertedOpportunity: "Opportunity",
        consent: "Kontaktsperren",
        emailOptOut: "E-Mail-Opt-out",
        phoneOptOut: "Telefon-Opt-out",
        doNotCall: "Nicht anrufen",
        emailBouncedAt: "E-Mail unzustellbar seit",
        emailBouncedReason: "Grund der Unzustellbarkeit",
        pardotScore: "Pardot-Score",
        pardotGrade: "Pardot-Grade",
        pardotCampaign: "Pardot-Kampagne",
        pardotCreatedAt: "In Pardot seit",
        pardotFirstActivityAt: "Erste Aktivität",
        pardotLastActivityAt: "Letzte Aktivität",
        pardotConvertedAt: "In Pardot konvertiert am",
        pardotConversionObjectType: "Konvertiert über (Typ)",
        pardotConversionObjectName: "Konvertiert über",
        pardotHardBounced: "Hard Bounce in Pardot",
        pardotUrl: "Pardot-Profil",
        pardotComments: "Pardot-Kommentare",
        pardotNotes: "Pardot-Notizen",
        utmSource: "UTM Source",
        utmMedium: "UTM Medium",
        utmCampaign: "UTM Campaign",
        utmContent: "UTM Content",
        utmTerm: "UTM Term",
        firstTouchUrl: "Erster Seitenaufruf",
        firstSearchTerm: "Erster Suchbegriff",
        firstSearchType: "Erste Suchart",
      },
      CASE: {
        caseNumber: "Case-Nr.",
        subject: "Betreff",
        status: "Status",
        priority: "Priorität",
        type: "Typ",
        subtype: "Subtyp",
        issueCategory: "Problemkategorie",
        origin: "Ursprung",
        reason: "Grund",
        recordType: "Datensatztyp",
        account: "Account",
        contact: "Kontakt",
        parentCase: "Übergeordneter Case",
        owner: "Case-Inhaber",
        contactEmail: "Kontakt-E-Mail",
        contactPhone: "Kontakt-Telefon",
        suppliedName: "Web-Name",
        suppliedEmail: "Web-E-Mail",
        suppliedPhone: "Web-Telefon",
        isClosed: "Geschlossen",
        isEscalated: "Eskaliert",
        withinSla: "Innerhalb SLA",
        description: "Beschreibung",
        internalComments: "Interne Kommentare",
        createdAt: "Geöffnet am",
        closedAt: "Geschlossen am",
        lastInboundEmailAt: "Letzte eingehende E-Mail",
        ageDays: "Alter (Tage)",
      },
      CONTRACT: {
        contractNumber: "Vertragsnummer",
        name: "Vertragsname",
        status: "Status",
        recordType: "Datensatztyp",
        account: "Account",
        startDate: "Beginn",
        endDate: "Ende",
        mrr: "MRR",
        activeSubscriptionItems: "Aktive Abo-Positionen",
        licenseManager: "Lizenzmanager",
        owner: "Vertragsinhaber",
        createdAt: "Erstellt am",
      },
      CONTRACT_ITEM: {
        name: "Vertragsposition",
        productName: "Produkt",
        productFamily: "Produktfamilie",
        status: "Status",
        recordType: "Datensatztyp",
        account: "Account",
        contract: "Vertrag",
        startDate: "Beginn",
        endDate: "Ende",
        cancellationDate: "Kündigungsdatum",
        cancellationType: "Kündigungsart",
        sponsoringKrankenkasse: "Fördernde Krankenkasse",
        initialItem: "Ursprüngliche Position",
        changedInto: "Ersetzt durch",
        createdAt: "Erstellt am",
        lastOnline: "Zuletzt online",
        appVersion: "App-Version",
        os: "Betriebssystem",
        licenseActivatedAt: "Lizenz aktiviert am",
        tabletName: "Tablet",
        contractName: "Vertragsname",
        price: "Preis",
        cancellationStage: "Kündigungsphase",
        contactPersonEmail: "E-Mail der Kontaktperson",
        licenseActivated: "Lizenz aktiviert",
        licenseActivationCode: "Lizenz-Aktivierungscode",
        licenseQrCode: "Lizenz-QR-Code",
        billingTool: "Abrechnungssystem",
        billingStartDate: "Abrechnungsbeginn",
        billingStarted: "Abrechnung gestartet",
        billingStopped: "Abrechnung gestoppt",
        trialPeriodDays: "Testzeitraum (Tage)",
        testStatus: "Teststatus",
        assetHasInventory: "Asset hat Inventar",
        inTrial: "Im Testzeitraum",
      },
      ORDER: {
        orderNumber: "Auftragsnummer",
        status: "Status",
        recordType: "Datensatztyp",
        recordTypeName: "Auftragsart",
        plannedExecutionDate: "Geplantes Ausführungsdatum",
        shippingRecipient: "Versandempfänger",
        expectedReturnDate: "Erwartetes Rücksendedatum",
        trackingNumberReturn: "Rücksendungsnummer",
        trackingNumber: "Sendungsnummer",
        shippingStreet: "Lieferstraße",
        shippingCity: "Lieferort",
        shippingPostalCode: "Lieferpostleitzahl",
        shippingState: "Lieferbundesland",
        shippingCountry: "Lieferland",
        fulfilmentPartner: "Versandpartner",
        additionalInformation: "Zusätzliche Informationen",
        account: "Account",
        contract: "Vertrag",
        effectiveDate: "Gültig ab",
        endDate: "Ende",
        owner: "Auftragsinhaber",
        createdAt: "Erstellt am",
      },
      LEAD_PRODUCT: {
        name: "Nummer",
        lead: "Lead",
        product: "Produkt",
        quantity: "Menge",
        unitPrice: "Stückpreis",
        totalPrice: "Gesamtpreis",
        createdAt: "Erstellt am",
      },
      CAMPAIGN: {
        name: "Kampagnenname",
        type: "Typ",
        status: "Status",
        isActive: "Aktiv",
        startDate: "Beginn",
        endDate: "Ende",
        parent: "Übergeordnete Kampagne",
        owner: "Kampagneninhaber",
        members: "Mitglieder",
        respondedMembers: "Mit Antwort",
        membersByStatus: "Mitglieder nach Status",
        leadCount: "Leads laut Salesforce",
        contactCount: "Kontakte laut Salesforce",
        responseCount: "Antworten laut Salesforce",
        pardotCampaignId: "Pardot-Kampagnen-ID",
        createdAt: "Erstellt am",
      },
      CAMPAIGN_MEMBER: {
        person: "Name",
        personType: "Lead oder Kontakt",
        campaign: "Kampagne",
        lead: "Lead",
        contact: "Kontakt",
        status: "Mitgliedsstatus",
        hasResponded: "Geantwortet",
        firstRespondedDate: "Erste Antwort am",
        since: "Seit",
        startDate: "Start",
        emailOptOut: "E-Mail-Opt-out",
        phoneOptOut: "Telefon-Opt-out",
        createdAt: "Hinzugefügt am",
      },
    },
    sections: {
      shipping: "Versandinformationen",
      returns: "Rücksendung",
      contractItemDetails: "Vertragspositionsdetails",
      adminFields: "Admin-Felder",
      license: "Lizenz",
      information: "Informationen",
      address: "Adresse & Telefon",
      contact: "Kontaktdaten",
      conversion: "Konvertierung",
      source: "Herkunft",
      routing: "Zuordnung",
      followUp: "Wiedervorlage",
      pardot: "Pardot",
      consent: "Einwilligung & Erreichbarkeit",
      campaignMembers: "Mitglieder",
      tracking: "Herkunft im Web",
      customer: "Kunde",
      description: "Beschreibung",
      dates: "Termine",
      terms: "Laufzeit & Umsatz",
      term: "Laufzeit",
      cancellation: "Kündigung",
      device: "Gerät",
    },
    related: {
      opportunities: "Opportunities",
      contacts: "Kontakte",
      contractItems: "Vertragspositionen",
      contracts: "Verträge",
      cases: "Cases",
      orders: "Aufträge",
      childAccounts: "Einrichtungen",
      convertedLeads: "Konvertierte Leads",
      leadProducts: "Produkte",
      campaigns: "Kampagnen",
      campaignMembers: "Kampagnenmitglieder",
      childCampaigns: "Untergeordnete Kampagnen",
      contactCases: "Weitere Cases des Kontakts",
      childCases: "Untergeordnete Cases",
      viewAll: "Alle anzeigen",
      empty: "Keine Einträge",
    },
    consent: {
      NO_EMAIL: "Keine E-Mails",
      NO_CALLS: "Keine Anrufe",
      NO_NEWSLETTER: "Kein Newsletter",
      EMAIL_BOUNCED: "E-Mail unzustellbar seit %{date}",
    },
    contractItem: {
      imei: "IMEI",
      serialNumber: "Inventar-Seriennummer",
      hardwareSerialNumber: "Hardware-Seriennummer",
      simIccid: "SIM-ID (ICCID)",
      orderNumber: "Auftrag",
      recordType: "Auftragstyp",
      status: "Auftragsstatus",
      exchangeStatus: "Austauschstatus",
      orderRejected: "Auftrag abgelehnt",
      createdBy: "Erstellt von",
      createdAt: "Erstellt am",
      orders: "Auftragspositionen",
      inventoryHistory: "Inventarhistorie",
      atClientDate: "Beim Kunden seit",
      removedFromClientDate: "Beim Kunden entfernt am",
      inStockDate: "Im Lager seit",
      assetReference: "Verknüpftes Asset: %{name}",
      assetPlacementNote: "Die Verknüpfung zeigt nicht den aktuellen Standort des Inventars.",
    },
    accountBilling: {
      loading: "Abrechnungsdaten werden geladen",
      invoices: "Rechnungen und Gutschriften",
      profile: "Rechnungsdetails",
      subscriptions: "Abonnements",
      ledger: "Zahlungshistorie",
      noData: "Keine Daten verfügbar.",
      deleted: "Für in Salesforce gelöschte Accounts werden keine Abrechnungsdaten abgerufen.",
      mappingChanged: "Die Zuordnung zum Abrechnungskonto hat sich geändert. Bitte laden Sie die Daten erneut.",
      retry: "Erneut versuchen",
      refresh: "Aktualisieren",
      dateFrom: "Von Datum",
      dateTo: "Bis Datum",
      invalidDates: "Das Anfangsdatum darf nicht nach dem Enddatum liegen.",
      billedThrough: "Abrechnung über",
      customer: "Kunde in Billwerk öffnen",
      externalCustomerId: "Kundennummer",
      debtorAccount: "Debitorenkonto",
      number: "Belegnummer",
      date: "Datum",
      dueDate: "Fällig am",
      amount: "Betrag",
      document: "Dokument",
      displayName: "Rechnungsempfänger",
      email: "E-Mail",
      phone: "Telefon",
      vatId: "Umsatzsteuer-ID",
      buyerReference: "Käuferreferenz",
      deliveryMethod: "Versandart",
      address: "Rechnungsadresse",
      contractId: "Vertrags-ID",
      planName: "Tarif",
      planVariantId: "Tarifvarianten-ID",
      lifecycleStatus: "Status",
      billingPeriod: "Abrechnungsintervall",
      startDate: "Beginn",
      endDate: "Ende",
      lastBillingDate: "Letzte Abrechnung",
      nextBillingDate: "Nächste Abrechnung",
      billedUntil: "Abgerechnet bis",
      balance: "Saldo",
      paymentMethod: "Zahlungsmethode",
      billingSuspended: "Abrechnung ausgesetzt",
      recurringPaymentsPaused: "Wiederkehrende Zahlungen pausiert",
      dunningLevel: "Aktuelle Mahnstufe",
      dunningRemaining: "Offener Mahnbetrag",
      dunningSince: "Mahnung seit",
      type: "Typ",
      description: "Beschreibung",
      paymentStatus: "Zahlungsstatus",
      paymentTransactionStatus: "Transaktionsstatus",
      invoiceId: "Beleg-ID",
      values: {
        lifecycleStatus: {
          Undefined: "Unbestimmt",
          Draft: "Entwurf",
          InOrderProcess: "Im Bestellprozess",
          InTrial: "In Testphase",
          TrialExpired: "Testphase abgelaufen",
          Active: "Aktiv",
          Ended: "Beendet",
          TemporarilyInactive: "Vorübergehend inaktiv",
          Annulled: "Annulliert",
          Locked: "Gesperrt",
          Paused: "Pausiert",
          Cancelled: "Gekündigt",
          WrittenOff: "Abgeschrieben",
        },
        deliveryMethod: {
          Email: "E-Mail",
          SnailMail: "Post",
          ArchiveOnly: "Nur Archiv",
          EInvoicing: "Elektronische Rechnung",
          EmailAndSnailMail: "E-Mail und Post",
        },
        ledgerType: {
          Receivable: "Forderung",
          Payment: "Zahlung",
          Refund: "Erstattung",
          Adjustment: "Korrektur",
          Chargeback: "Rückbuchung",
          Cancelation: "Stornierung",
          PrepaidCard: "Prepaid-Karte",
          WriteOff: "Abschreibung",
          DebtCollection: "Inkasso",
        },
        paymentStatus: { Confirmed: "Bestätigt", Unconfirmed: "Unbestätigt" },
        paymentTransactionStatus: {
          Created: "Erstellt",
          InProgress: "In Bearbeitung",
          Prepared: "Vorbereitet",
          PreliminarySucceeded: "Vorläufig erfolgreich",
          Succeeded: "Erfolgreich",
          Undefined: "Unbestimmt",
          Canceled: "Storniert",
          Chargeback: "Rückbuchung",
          Pending: "Ausstehend",
          Failed: "Fehlgeschlagen",
          Unmapped: "Nicht zugeordnet",
          Refunded: "Erstattet",
          ThreeDSecurePending: "3-D-Secure ausstehend",
          PartiallyRefunded: "Teilweise erstattet",
          PartialChargeback: "Teilweise zurückgebucht",
          InDispute: "In Klärung",
          Finalizing: "Wird abgeschlossen",
          Scheduled: "Geplant",
          PartiallyPaid: "Teilweise bezahlt",
          SuccessfullyImported: "Erfolgreich importiert",
          OverPaid: "Überzahlt",
          RedirectUrlPrepared: "Weiterleitung vorbereitet",
          InCollection: "Im Inkasso",
          DebtCollectionFailed: "Inkasso fehlgeschlagen",
          InCollectionPartialPaid: "Im Inkasso teilweise bezahlt",
        },
        billingPeriodUnit: {
          Day: "Tag |||| Tage",
          Week: "Woche |||| Wochen",
          Month: "Monat |||| Monate",
          Year: "Jahr |||| Jahre",
          Hour: "Stunde |||| Stunden",
          Minute: "Minute |||| Minuten",
          Second: "Sekunde |||| Sekunden",
        },
      },
      availability: {
        NOT_CONFIGURED: "Für diesen Account ist kein Abrechnungskonto zugeordnet.",
        INTEGRATION_NOT_CONFIGURED:
          "Die Billwerk-Integration ist nicht eingerichtet. Bitte wenden Sie sich an die Administration.",
        LOADING: "Die Billwerk-Kundenliste wird geladen. Bitte warten Sie oder versuchen Sie es erneut.",
        UNAVAILABLE: "Billwerk ist derzeit nicht verfügbar. Bitte versuchen Sie es erneut.",
        INCOMPLETE: "Die Billwerk-Kundenliste ist unvollständig. Bitte versuchen Sie es erneut.",
        MAPPING_CONFLICT:
          "Das Abrechnungskonto kann nicht eindeutig zugeordnet werden. Bitte prüfen Sie die Zuordnung.",
      },
    },
    record: {
      noBackendLicense: "Keine Lizenz im Backend",
      tabs: {
        feed: "Feed",
        details: "Details",
        portal: "Admin-Portal & Freischaltungen",
        billing: "Abrechnung",
        license: "Lizenz",
        asset: "Asset",
        orders: "Aufträge",
        inventoryHistory: "Inventarhistorie",
        related: "Zugehörig",
      },
      openInSalesforce: "In Salesforce öffnen",
      appOrganization: "In der App: %{name}",
      appOrganizationUnnamed: "Einrichtung in der App",
      notFound: "Dieser Datensatz ist nicht im CRM.",
      deletedInSalesforce:
        "Dieser Datensatz wurde am %{time} in Salesforce gelöscht. Das CRM zeigt ihn weiter an, rechnet aber nicht mehr mit ihm.",
      mergedInto: "Zusammengeführt mit",
      highlights: "Hervorgehoben",
      path: "Status",
      pathCurrent: "Aktueller Status: %{stage}",
      pathComplete: "Abgeschlossen: %{stage}",
      pathUpcoming: "Ausstehend: %{stage}",
      yes: "Ja",
      no: "Nein",
      call: "%{number} anrufen",
      email: "E-Mail an %{address}",
    },
    accountContacts: {
      invitationState: {
        AVAILABLE: "Einladung möglich",
        PENDING: "Einladung offen – erneut einladen",
        REGISTERED: "Bereits Manager dieser Einrichtung",
        LOGIN_CONFLICT: "Bestehendes Login – bitte Support kontaktieren",
        AMBIGUOUS_EMAIL: "Diese E-Mail-Adresse gehört in Salesforce zu mehreren Personen.",
        MISSING_EMAIL: "Keine E-Mail-Adresse hinterlegt",
        INVALID_EMAIL: "Ungültige E-Mail-Adresse",
      },
    },
    accountAmbulant: {
      label: "Ambulante Versorgung",
      saved: "Ambulante Versorgung gespeichert",
      error: "Die ambulante Versorgung konnte nicht gespeichert werden.",
    },
    accountManagers: {
      portal: {
        title: "Portalzugang",
        status: "Status",
        ready: "Eingerichtet",
        notReady: "Noch nicht eingerichtet",
        noAccess: "Dieser Account hat keinen Zugang zum Admin-Portal, weil noch kein Manager registriert ist.",
      },
      invite: "Manager einladen",
      noContacts: "Für diesen Account sind keine Kontakte hinterlegt.",
      loadError: "Portalzugang und Manager konnten nicht geladen werden.",
      setup: {
        action: "Portalzugang einrichten",
        confirm: "Für diesen Account wird eine Einrichtung im Admin-Portal angelegt.",
        success: "Portalzugang eingerichtet",
        error: "Der Portalzugang konnte nicht eingerichtet werden.",
      },
      access: {
        billing: "Rechnungszugriff",
        learning: "E-Learning",
        learningSummary: "Freigeschaltete Kurse: %{courses} · Lernpfade: %{paths}",
        manageLearning: "Freischaltungen verwalten",
        learningDialog: "E-Learning-Freischaltungen für %{organization}",
        close: "Schließen",
      },
      managers: {
        title: "Manager",
        empty: "Noch keine Manager registriert.",
        name: "Name",
        email: "E-Mail",
        registeredAt: "Registriert am",
        lastSignInAt: "Letzte Anmeldung",
        never: "Noch nie",
      },
      invitations: {
        title: "Einladungen",
        empty: "Noch keine Einladungen versendet.",
        email: "E-Mail",
        createdAt: "Gesendet am",
        status: "Status",
      },
      dialog: {
        title: "Manager einladen",
        description: "Die Person erhält eine Einladungs-E-Mail, mit der sie ihr Konto anlegt.",
        contact: "Account-Kontakt",
        joins: "Die Person erhält Managerzugriff auf den Account „%{name}“.",
        createsOrganization: "Mit der Einladung wird der Portalzugang für den Account „%{name}“ eingerichtet.",
        send: "Einladung senden",
        cancel: "Abbrechen",
        success: "Einladung erfolgreich versendet",
        error: "Fehler beim Senden der Einladung",
        notAccountContact: "Diese Person gehört nicht mehr zu diesem Account.",
        invalidOrganization: "Für diesen Account können keine Manager eingeladen werden.",
        loginConflict:
          "Für diese E-Mail-Adresse besteht bereits ein Login. Bitte kontaktieren Sie den Support, um den Zugriff zu klären.",
        ambiguousEmail: "Diese E-Mail-Adresse gehört in Salesforce zu mehreren Personen.",
      },
    },
    timeline: {
      title: "Kommunikation",
      activityTitle: "Aktivität",
      filters: {
        ALL: "Alle",
        EMAIL: "E-Mails",
        CALL: "Anrufe",
        COMMENT: "Kommentare",
        STATUS_CHANGE: "Statusänderungen",
        CASE_OPENED: "Neue Cases",
      },
      filterLabel: "Kommunikation filtern",
      empty: "Keine Kommunikation in den letzten zwei Jahren.",
      loadMore: "Ältere laden",
      expand: "Inhalt anzeigen",
      collapse: "Inhalt ausblenden",
      emailInbound: "E-Mail von %{actor}",
      emailOutbound: "E-Mail an %{counterpart}",
      emailUnknown: "E-Mail",
      emailBodyNotImported: "E-Mail-Inhalt nicht importiert",
      to: "An: %{address}",
      callInbound: "Eingehender Anruf",
      callOutbound: "Ausgehender Anruf",
      callUnknown: "Anruf",
      callAgent: "mit %{agent}",
      callDuration: "Gesprächsdauer %{duration} Min.",
      callNotAnswered: "Nicht angenommen",
      recorded: "Aufgezeichnet",
      providers: {
        NATTERBOX: "Natterbox",
        PLACETEL: "Placetel",
      },
      comment: "Case-Kommentar von %{actor}",
      commentUnknown: "Case-Kommentar",
      statusChange: "%{field} geändert",
      statusChangeBy: "%{field} geändert von %{actor}",
      statusChangeValues: "%{oldValue} → %{newValue}",
      caseOpened: "Case geöffnet",
      caseOpenedBy: "Case geöffnet von %{actor}",
      inCase: "Case %{case}",
      historyFields: { Status: "Status", Priority: "Priorität", Type: "Typ" },
      window: "Kommunikation wird zwei Jahre aufbewahrt.",
    },
    search: {
      label: "CRM durchsuchen",
      placeholder: "Accounts, Kontakte, Cases … durchsuchen",
      shortcut: "Strg K",
      recent: "Zuletzt angesehen",
      noResults: "Keine Treffer",
      tooShort: "Mindestens zwei Zeichen eingeben",
      loading: "Suche läuft …",
    },
    overview: {
      title: "Service-Übersicht",
      overline: "Customer Service",
      openCases: "Offene Cases",
      waitingCases: "Warten auf Rückmeldung",
      escalatedCases: "Eskaliert",
      outsideSlaCases: "Außerhalb SLA",
      createdToday: "Heute neu",
      closedToday: "Heute geschlossen",
      openByType: "Offene Cases nach Typ",
      openByOwner: "Offene Cases nach Inhaber",
      openByStatus: "Offene Cases nach Status",
      callsPerDay: "Anrufe der letzten 14 Tage",
      inbound: "Eingehend",
      outbound: "Ausgehend",
      oldestOpen: "Älteste offene Cases",
      none: "Ohne Angabe",
      noCases: "Keine offenen Cases.",
      quickLinks: "Schnellzugriff",
    },
    calls: {
      overline: "Telefonie",
      back: "Zurück zur Übersicht",
      count: "%{total} Anruf |||| %{total} Anrufe",
      agent: "Mitarbeiter: %{name}",
      unavailable: "Die Anrufliste ist nicht verfügbar.",
      invalid: "Diese Anrufliste gibt es nicht.",
      empty: "Keine Anrufe.",
      loadMore: "Mehr laden",
      none: "–",
      titles: {
        INBOUND: "Eingehende Anrufe",
        ANSWERED: "Angenommene Anrufe",
        MISSED: "Verpasste Anrufe",
        ABANDONED: "In der Warteschlange aufgelegte Anrufe",
        NOT_ROUTED: "Nicht durchgestellte Anrufe",
        OUTBOUND: "Ausgehende Anrufe",
        WITHIN_OPENING_HOURS: "Eingehende Anrufe in den Öffnungszeiten",
      },
      columns: {
        time: "Zeit",
        direction: "Richtung",
        number: "Nummer",
        agent: "Mitarbeiter",
        outcome: "Ergebnis",
        wait: "Wartezeit",
        handle: "Gesprächsdauer",
      },
      directions: {
        inbound: "Eingehend",
        outbound: "Ausgehend",
        internal: "Intern",
      },
      outcomes: {
        answered: "Angenommen",
        abandoned: "In der Warteschlange aufgelegt",
        missed: "Verpasst",
        not_routed: "Nicht durchgestellt",
        not_answered: "Nicht angenommen",
      },
    },
    telephony: {
      title: "Telefonie",
      loading: "Telefoniedaten werden geladen",
      loadError: "Die Telefoniedaten konnten nicht geladen werden.",
      syncError: "Die Anrufliste konnte zuletzt nicht geladen werden.",
      hotlineNotConfigured:
        "Noch keine Hotline-Nummern eingetragen – die eingehenden Anrufe werden erst gezählt, wenn sie auf der Seite Integrationen hinterlegt sind.",
      completeUntil: "Vollständig bis %{time}",
      range: "Zeitraum",
      ranges: {
        TODAY: "Heute",
        LAST_7_DAYS: "7 Tage",
        LAST_30_DAYS: "30 Tage",
      },
      inbound: "Eingehend",
      answered: "Angenommen",
      missed: "Verpasst",
      abandoned: "In der Warteschlange aufgelegt",
      notRouted: "Nicht durchgestellt",
      reachability: "Erreichbarkeit",
      reachabilityHint: "in den Öffnungszeiten",
      averageWait: "Ø Wartezeit",
      maxWait: "Max. Wartezeit",
      averageHandle: "Ø Gesprächsdauer",
      outbound: "Ausgehend",
      agents: "Mitarbeitende",
      agentName: "Name",
      none: "–",
    },
  },
  financeNotifications: {
    section: "Finanzen",
    title: "Benachrichtigungen",
    loading: "Benachrichtigungen werden geladen",
    loadError: "Die Benachrichtigungen konnten nicht geladen werden.",
    loadMore: "Mehr laden",
    count: "%{smart_count} offene Benachrichtigung |||| %{smart_count} offene Benachrichtigungen",
    empty: "Keine offenen Benachrichtigungen.",
    lastSync: "Letzte erfolgreiche Synchronisierung: %{time}",
    noSync: "Noch keine erfolgreiche Synchronisierung",
    syncFailed:
      "Die letzte Synchronisierung mit Salesforce ist fehlgeschlagen. Die Liste ist möglicherweise nicht mehr aktuell.",
    unreadableFields:
      "Auf diese Salesforce-Felder besteht kein Lesezugriff: %{fields}. Regeln, die diese Felder verwenden, ruhen, bis der Zugriff wiederhergestellt ist.",
    filter: "Nach Regel filtern",
    all: "Alle",
    rules: {
      BILLING_START_DUE: "Abrechnung starten",
      BILLING_STOP_NEEDED: "Abrechnung stoppen",
      CONTRACT_CHANGE_DUE: "Vertragswechsel fällig",
      CANCELLATION_WITHDRAWN: "Kündigung zurückgenommen",
      END_DATE_CHANGED: "Enddatum geändert",
    },
    since: "seit %{time}",
    itemMissing: "Vertragsposition nicht mehr vorhanden",
    endsOn: "Endet am %{date}",
    endedOn: "Endete am %{date}",
    noReturn: "Keine abgeschlossene Rücksendung",
    openInSalesforce: "In Salesforce öffnen",
    change: "vorher %{before} → jetzt %{now}",
    yes: "Ja",
    no: "Nein",
    planVariantPriceBook: "Preisbuch: %{name}",
    planVariantPlan: "Plan: %{id}",
    badge: {
      label: "Finanzen: %{smart_count} offene Benachrichtigung |||| Finanzen: %{smart_count} offene Benachrichtigungen",
    },
    dismiss: {
      action: "Verwerfen",
      title: "Benachrichtigung verwerfen",
      reason: "Grund",
      submit: "Verwerfen",
      success: "Die Benachrichtigung wurde verworfen.",
      error: "Die Benachrichtigung konnte nicht verworfen werden.",
    },
    errors: {
      "notification-reason-required": "Bitte geben Sie einen Grund an.",
      "notification-not-open": "Diese Benachrichtigung wurde bereits bearbeitet. Die Liste wurde aktualisiert.",
      "notification-not-found": "Diese Benachrichtigung gibt es nicht mehr.",
    },
    fields: {
      contractNumber: "Vertragsnummer",
      account: "Account",
      product: "Produkt",
      price: "Preis",
      startDate: "Startdatum",
      endDate: "Enddatum",
      billingStartDate: "Abrechnungsstart",
      billingTool: "Abrechnungstool",
      billwerkEffectiveFrom: "Billwerk wirksam ab",
      cancellationType: "Kündigungsart",
      lostReason: "Verlustgrund",
      cancellationDate: "Kündigungsdatum",
      returnOrder: "Rücksendeauftrag",
      returnStatus: "Status der Rücksendung",
      returnCompletedDate: "Rücksendung abgeschlossen am",
      oldItem: "Bisherige Position",
      newItem: "Neue Position",
      status: "Status",
      billingStarted: "Abrechnung gestartet",
      billingStopped: "Abrechnung gestoppt",
      handledEndDate: "Enddatum beim Stopp",
      handledAt: "Stopp bearbeitet am",
      planVariant: "Plan-Variante (Billwerk)",
    },
  },
  billwerkPlanVariants: {
    title: "Plan-Varianten Billwerk",
    intro:
      "Die Billwerk-Plan-Variante jedes Produkts je Preisbuch, aus Salesforce (Preisbucheintrag: Billwerk PlanvariantID). Eine Vertragsposition rechnet mit dem Eintrag ihres Produkts im Preisbuch ihres Vertrags ab. Lücken werden in Salesforce geschlossen; hier wird nichts geändert.",
    loading: "Die Plan-Varianten werden geladen",
    loadError: "Die Plan-Varianten konnten nicht geladen werden.",
    loadedAt: "Billwerk-Plan-Varianten gelesen: %{time} · Anzahl: %{count}",
    lastSync: "Letzte erfolgreiche Salesforce-Synchronisierung: %{time}",
    noSync: "Noch keine erfolgreiche Salesforce-Synchronisierung",
    status: {
      LOADING:
        "Billwerk antwortet langsam. Die Plan-Varianten werden noch gelesen; die Seite aktualisiert sich selbst.",
      UNAVAILABLE: "Billwerk nicht erreichbar. Ob Billwerk die Plan-Varianten kennt, ist nicht geprüft.",
      NOT_CONFIGURED: "Billwerk ist hier nicht eingerichtet. Ob Billwerk die Plan-Varianten kennt, ist nicht geprüft.",
    },
    withheld:
      "Auf diese Salesforce-Daten besteht kein Lesezugriff: %{fields}. Ohne sie wäre jede Angabe falsch, deshalb wird nichts angezeigt.",
    notCopied:
      "Die Preisbücher sind noch nicht aus Salesforce übernommen. Die Plan-Varianten erscheinen nach der nächsten Synchronisierung.",
    unreadable: "Auf diese Salesforce-Daten besteht kein Lesezugriff; sie fehlen in der Liste: %{fields}.",
    viewFilter: "Ansicht",
    viewCount: "%{view} (%{count})",
    views: {
      ENTRIES: "Preisbucheinträge",
      ITEMS: "Vertragspositionen mit Lücke",
    },
    viewHints: {
      ENTRIES:
        "Jeder Preisbucheintrag mit seiner Plan-Variante und den abrechnungsrelevanten Positionen, die ihn nutzen.",
      ITEMS:
        "Abrechnungsrelevante Vertragspositionen (abgerechnet oder mit offener Finanz-Benachrichtigung), deren Plan-Variante sich nicht ermitteln lässt.",
    },
    stateFilter: "Nach Zustand filtern",
    allStates: "Alle",
    search: "Suchen",
    searchHint: "Preisbuch, Produkt, Position, Account, Vertragsnummer oder Billwerk-Id",
    columns: {
      priceBook: "Preisbuch",
      product: "Produkt",
      currency: "Währung",
      plan: "Plan (Billwerk)",
      planVariant: "Plan-Variante (Billwerk)",
      billingItems: "Abrechnungsrelevante Positionen",
      item: "Vertragsposition",
      account: "Account",
      contract: "Vertrag",
    },
    standard: "Standardpreisbuch",
    priceBookInactive: "Preisbuch inaktiv",
    inactive: "Eintrag inaktiv",
    billed: "abgerechnet",
    openNotification: "offene Benachrichtigung",
    contract: "Vertrag",
    empty: {
      ENTRIES: "Keine Preisbucheinträge.",
      ITEMS: "Keine Vertragsposition mit Lücke.",
    },
    hidden: "in Billwerk ausgeblendet",
    states: {
      KNOWN: "In Billwerk vorhanden",
      UNCHECKED: "in Billwerk nicht geprüft",
      NOT_IN_BILLWERK: "In Billwerk unbekannt",
      MISSING: "Keine Plan-Variante im Preisbucheintrag",
      AMBIGUOUS: "Mehrdeutig: Die Preisbucheinträge des Produkts nennen nicht dieselbe Plan-Variante",
      NOT_IN_PRICE_BOOK: "Produkt nicht im Preisbuch des Vertrags",
      NO_PRICE_BOOK: "Vertrag ohne Preisbuch",
      NO_PRODUCT: "Vertragsposition ohne Produkt",
      NO_CONTRACT: "Vertragsposition ohne Vertrag",
      WITHHELD: "noch nicht verfügbar, Salesforce-Daten fehlen",
    },
  },
  financeOverview: {
    title: "Finanz-Übersicht",
    intro:
      "Was in Billwerk zu tun ist, wo Salesforce und Billwerk nicht übereinstimmen und was in Salesforce oder Billwerk Aufmerksamkeit braucht. Nur Anzeige: geändert wird in Salesforce und Billwerk.",
    loading: "Die Übersicht wird geladen",
    loadError: "Die Übersicht konnte nicht geladen werden.",
    billwerkLoadedAt: "Billwerk gelesen: %{time} · %{customers} Kunden · %{contracts} Verträge",
    lastSync: "Letzte erfolgreiche Salesforce-Synchronisierung: %{time}",
    noSync: "Noch keine erfolgreiche Salesforce-Synchronisierung",
    billwerkLoading:
      "Die Billwerk-Kunden und -Verträge werden nach einem Neustart einmal geladen (etwa 1–2 Minuten). Die Seite aktualisiert sich selbst.",
    billwerkUnavailable: "Billwerk ist gerade nicht erreichbar. Abgleich und Billwerk-Listen fehlen.",
    billwerkNotConfigured: "Billwerk ist nicht angebunden. Abgleich und Billwerk-Listen fehlen.",
    withheld: "Der Abgleich ruht: Auf diese Salesforce-Felder besteht kein Lesezugriff: %{fields}.",
    notCopied: "Der Abgleich ruht, bis eine Salesforce-Synchronisierung Preisbücher und Abrechnungsfelder kopiert hat.",
    perMonth: "%{value} / Monat",
    kpis: {
      billed: "Abgerechnet laut Salesforce",
      billedHint: "%{count} Abo-Positionen mit gestarteter Abrechnung",
      billwerkActive: "Aktive Billwerk-Verträge",
      billwerkActiveHint: "%{customers} Kunden",
      dunning: "Offen in Mahnung",
      dunningHint: "%{count} Verträge",
      inSync: "Übereinstimmende Kunden",
      inSyncHint: "%{count} von %{total} abgeglichenen Kunden",
    },
    toDo: {
      title: "In Billwerk zu tun",
      hint: "Offene Finanz-Benachrichtigungen aus Salesforce. Jede Karte öffnet die Benachrichtigungen dieser Regel.",
      legacy: "%{count} älter als ein Jahr",
      upcoming: "%{count} mit Datum in der Zukunft",
      none: "Nichts offen",
    },
    lists: {
      RECONCILIATION: "Abgleich Salesforce ↔ Billwerk",
      SALESFORCE: "In Salesforce prüfen",
      BILLWERK: "In Billwerk prüfen",
    },
    listCount: "%{list} (%{count})",
    listHints: {
      RECONCILIATION:
        "Je Billwerk-Kunde: die abgerechneten Salesforce-Abopositionen seiner Accounts gegen seine aktiven Billwerk-Verträge, je Plan-Variante und Menge. Die Zuordnung kommt aus dem Kundenabgleich.",
      SALESFORCE: "Abopositionen, deren Abrechnungsangaben in Salesforce nicht zusammenpassen.",
      BILLWERK: "Billwerk-Verträge, die Aufmerksamkeit brauchen.",
    },
    filter: "Nach Befund filtern",
    all: "Alle",
    statuses: {
      SALESFORCE_ONLY: "Nur in Salesforce abgerechnet",
      BILLWERK_ONLY: "Nur in Billwerk aktiv",
      VARIANTS_DIFFER: "Plan-Varianten oder Mengen abweichend",
      NO_BILLWERK_CUSTOMER: "Kein Billwerk-Kunde",
      NO_SALESFORCE_ACCOUNT: "Kein Salesforce-Account",
      UNCLEAR: "Zuordnung unklar",
      IN_SYNC: "Stimmt überein",
    },
    statusHints: {
      SALESFORCE_ONLY:
        "Salesforce rechnet ab, der Billwerk-Kunde hat aber keinen aktiven Vertrag: in Billwerk starten oder in Salesforce stoppen.",
      BILLWERK_ONLY:
        "Billwerk rechnet ab, in Salesforce ist für den Kunden aber nichts abgerechnet: in Billwerk beenden oder in Salesforce nachtragen.",
      VARIANTS_DIFFER: "Beide Seiten rechnen ab, aber nicht dieselben Plan-Varianten oder Mengen.",
      NO_BILLWERK_CUSTOMER:
        "Salesforce rechnet ab, für den Rechnungsempfänger gibt es aber keinen Billwerk-Kunden (Debitoren-Id leer oder unbekannt).",
      NO_SALESFORCE_ACCOUNT:
        "Billwerk-Kunde mit aktivem Vertrag, aber kein Salesforce-Account mit seiner Debitoren-Id.",
      UNCLEAR: "Der Kundenabgleich hat hier einen Konflikt. Erst im Kundenabgleich klären.",
      IN_SYNC: "Beide Seiten rechnen dieselben Plan-Varianten und Mengen ab.",
    },
    checks: {
      ACTIVE_STOPPED_WITHOUT_END: "Aktiv, Abrechnung gestoppt, ohne Enddatum",
      BILLED_NOT_ACTIVE: "Abgerechnet, aber Entwurf, ausstehend oder beendet",
      ZERO_PRICE: "Aktiv und abgerechnet mit Preis 0",
      BILLOMAT: "Noch über Billomat abgerechnet",
      DUNNING: "In Mahnung",
      BILLING_SUSPENDED: "Abrechnung ausgesetzt",
      ENDING_SOON: "Endet in den nächsten 30 Tagen",
    },
    checkHints: {
      ACTIVE_STOPPED_WITHOUT_END:
        "Die Position ist aktiv, die Abrechnung aber gestoppt, und es gibt kein Enddatum. Läuft sie weiter oder ist sie beendet?",
      BILLED_NOT_ACTIVE:
        "Abrechnung gestartet und nicht gestoppt, aber die Position ist Entwurf, ausstehend oder beendet (ohne offene Benachrichtigung).",
      ZERO_PRICE: "Aktive Positionen mit gestarteter Abrechnung zum Preis 0.",
      BILLOMAT: "Aktive Positionen, die laut Salesforce noch über Billomat abgerechnet werden.",
      DUNNING: "Billwerk-Verträge mit offener Mahnung und dem noch offenen Betrag.",
      BILLING_SUSPENDED: "Aktive Billwerk-Verträge, deren Abrechnung ausgesetzt ist.",
      ENDING_SOON: "Aktive Billwerk-Verträge mit Enddatum in den nächsten 30 Tagen. Passt das Ende zu Salesforce?",
    },
    planVariantGaps: "%{count} abgerechnete Positionen ohne ermittelbare Plan-Variante (%{value} / Monat)",
    planVariantGapsLink: "Zu den Plan-Varianten",
    customerMatchLink: "Im Kundenabgleich ansehen",
    search: "Suchen",
    searchHint: "Namen, Debitoren-Id, Salesforce- oder Billwerk-Id",
    sort: "Sortierung",
    sorts: {
      FINDING: "Nach Befund",
      NEWEST: "Neueste zuerst",
    },
    recentOnly: "Nur neue (letzte %{days} Tage)",
    recentHint:
      "Neu: in Salesforce angelegt oder in Billwerk begonnen (Mahnungen: gemahnt) in den letzten %{days} Tagen. Die Zahlen in den Filtern zählen nur diese.",
    createdOn: "angelegt %{date}",
    salesforceCreatedOn: "Salesforce: angelegt %{date}",
    billwerkStartedOn: "Billwerk: Beginn %{date}",
    startedOn: "Beginn %{date}",
    columns: {
      changed: "Zuletzt geändert",
      customer: "Billwerk-Kunde",
      accounts: "Salesforce-Accounts",
      variants: "Plan-Variante: Salesforce ↔ Billwerk",
      value: "Salesforce / Monat",
      item: "Vertragsposition",
      account: "Account",
      contract: "Vertrag",
      product: "Produkt",
      price: "Preis",
      dates: "Laufzeit",
      billingTool: "Abrechnungstool",
      planVariant: "Plan-Variante",
      status: "Status",
      dunning: "Mahnung",
      end: "Ende",
    },
    variantCounts: "%{salesforce} ↔ %{billwerk}",
    variantHint: {
      column:
        "Je Plan-Variante: links die abgerechneten Salesforce-Positionen der Accounts dieses Kunden, deren Preisbucheintrag die Variante nennt; rechts die Menge der aktiven Billwerk-Verträge des Kunden auf dieser Variante. Orange: die Zahlen weichen ab. Billwerk-Komponenten werden nicht gezählt.",
      salesforce: "Salesforce: %{count} abgerechnete Positionen (%{value} / Monat)",
      billwerk: "Billwerk: Menge %{quantity} in %{contracts} aktiven Verträgen",
      unknown: "Billwerk kennt diese Plan-Variante nicht.",
      equal: "Beide Seiten rechnen gleich viel ab.",
      noVariant:
        "Der Preisbucheintrag dieser Positionen nennt keine Plan-Variante: in Salesforce nachtragen (siehe Plan-Varianten).",
      salesforceOnly:
        "Billwerk rechnet diese Plan-Variante nicht ab: in Billwerk starten oder in Salesforce prüfen, ob die Positionen noch laufen.",
      billwerkOnly:
        "Salesforce rechnet diese Plan-Variante nicht ab: in Billwerk beenden oder in Salesforce nachtragen.",
      billwerkLess: "Billwerk rechnet weniger ab als Salesforce.",
      billwerkMore: "Billwerk rechnet mehr ab als Salesforce.",
    },
    noVariant: "ohne Plan-Variante",
    unknownVariant: "in Billwerk unbekannt",
    noCustomer: "kein Billwerk-Kunde",
    noAccounts: "kein Salesforce-Account",
    moreAccounts: "+ %{count} weitere",
    dunningLevel: "Stufe %{level}",
    dunningSince: "seit %{date}",
    suspended: "Abrechnung ausgesetzt",
    from: "ab %{date}",
    until: "bis %{date}",
    quantity: "Menge %{quantity}",
    empty: "Keine Einträge für diesen Filter.",
  },
  billwerkCustomerMatch: {
    title: "Kundenabgleich Billwerk",
    intro:
      "Salesforce-Accounts und Billwerk-Kunden, abgeglichen über die Debitoren-Id (Salesforce: Abrechnung Kundennummer neu). Eine Einrichtungszuordnung geht vor.",
    loading: "Der Abgleich wird geladen",
    loadError: "Der Abgleich konnte nicht geladen werden.",
    loadedAt: "Billwerk-Liste geladen: %{time} · %{count} Kunden",
    reload: "Neu laden",
    lastSync: "Letzte erfolgreiche Salesforce-Synchronisierung: %{time}",
    noSync: "Noch keine erfolgreiche Salesforce-Synchronisierung",
    status: {
      LOADING:
        "Die Billwerk-Kundenliste wird geladen. Das kann etwa eine Minute dauern; die Seite aktualisiert sich selbst.",
      UNAVAILABLE: "Billwerk nicht erreichbar. Angezeigt wird nur die Salesforce-Seite.",
      NOT_CONFIGURED: "Billwerk ist hier nicht eingerichtet. Angezeigt wird nur die Salesforce-Seite.",
    },
    contracts: {
      LOADING: "Die Billwerk-Verträge werden noch geladen; ob ein Vertrag aktiv ist, folgt gleich.",
      UNAVAILABLE: "Die Billwerk-Verträge konnten nicht geladen werden; ob ein Vertrag aktiv ist, ist unbekannt.",
    },
    withheld:
      "Auf diese Salesforce-Felder besteht kein Lesezugriff: %{fields}. Ohne sie wäre der Abgleich falsch, deshalb zeigt die Seite ihn erst, wenn der Zugriff besteht.",
    unreadable: "Auf diese Salesforce-Felder besteht kein Lesezugriff: %{fields}.",
    notCopied:
      "Die Salesforce-Synchronisierung hat die Abrechnungsfelder der Accounts noch nicht übernommen. Der Abgleich erscheint nach der nächsten erfolgreichen Synchronisierung.",
    groupFilter: "Gruppe",
    groups: {
      MATCHED: "Zugeordnet",
      ONLY_IN_SALESFORCE: "Nur in Salesforce",
      ONLY_IN_BILLWERK: "Nur in Billwerk",
      CONFLICT: "Konflikte",
    },
    groupCount: "%{group} (%{count})",
    reasonFilter: "Nach Grund filtern",
    allReasons: "Alle",
    reasons: {
      FACILITY_MAPPING: "Über die Einrichtungszuordnung",
      DEBITOR_ID: "Über die Debitoren-Id",
      VIA_PAYER: "Über den Rechnungsempfänger (Abrechnung via)",
      VIA_PARENT: "Über den übergeordneten Account (Bill to parent)",
      DEBITOR_ID_EMPTY: "Debitoren-Id in Salesforce leer",
      DEBITOR_ID_UNKNOWN: "Kein Billwerk-Kunde hat diese Debitoren-Id",
      NO_SALESFORCE_ACCOUNT: "Kein Salesforce-Account hat diese Debitoren-Id",
      DEBITOR_ID_ON_FACILITY:
        "Nur eine Einrichtung hat diese Debitoren-Id, sie wird über einen anderen Account abgerechnet",
      DUPLICATE_SALESFORCE: "Debitoren-Id an mehreren Salesforce-Accounts",
      DUPLICATE_BILLWERK: "Debitoren-Id an mehreren Billwerk-Kunden",
      MAPPING_DISAGREES: "Einrichtungszuordnung weicht von der Debitoren-Id ab",
      MAPPING_CUSTOMER_MISSING: "Zugeordneter Billwerk-Kunde existiert nicht",
      PAYER_LOOP: "Kette der Rechnungsempfänger ist zirkulär",
      PAYER_NOT_FOUND: "Rechnungsempfänger nicht gefunden",
      PAYER_WITHOUT_DEBITOR_ID: "Rechnungsempfänger ohne Debitoren-Id",
    },
    search: "Suchen",
    searchHint: "Name, Salesforce- oder Billwerk-Id, Debitoren-Id",
    salesforceSide: "Salesforce-Rechnungsempfänger",
    columns: {
      salesforce: "Salesforce",
      debitorAccount: "Debitoren-Id",
      billwerk: "Billwerk",
      reason: "Grund",
    },
    empty: "Keine Einträge.",
    noName: "Ohne Namen",
    b2c: "B2C",
    billed: "abgerechnet",
    paidBy: "Abgerechnet über: %{name}",
    chainEndsAt: "Kette endet bei: %{name}",
    oldNumber: "Kundennummer alt: %{number}",
    externalId: "ExternalCustomerId: %{id}",
    mapped: "Einrichtungszuordnung: %{ids}",
    billedFacilities: "%{smart_count} abgerechnete Einrichtung |||| %{smart_count} abgerechnete Einrichtungen",
    activeContract: "Vertrag aktiv",
    noActiveContract: "Kein aktiver Vertrag",
    contractUnknown: "Vertragsstatus unbekannt",
  },
  learningAssignments: {
    caregivers: "Pflegekräfte",
    caregiverSearchLabel: "Pflegekräfte durchsuchen",
    caregiverSearchPlaceholder: "Nach Name suchen",
    caregiverAssignments: "%{smart_count} Zuweisung |||| %{smart_count} Zuweisungen",
    noCaregiverMatch: "Keine passende Pflegekraft gefunden.",
    summaryLabel: "Zugewiesen an",
    searchLabel: "Lerninhalte durchsuchen",
    searchPlaceholder: "Nach Titel oder Thema suchen",
    loading: "Zuweisungen werden geladen",
    loadError: "Die Zuweisungen konnten nicht geladen werden.",
    noCaregiversTitle: "Keine aktiven Pflegekräfte",
    noCaregiversDescription: "Aktive Pflegekräfte Ihrer Einrichtung erscheinen automatisch in dieser Auswahl.",
    noCatalog: "Für Ihre Einrichtung sind noch keine Lerninhalte freigeschaltet.",
    noContent: "Keine Lerninhalte in dieser Kategorie.",
    noSearchResults: "Keine passenden Lerninhalte gefunden.",
    empty: "%{caregiver} wurden noch keine Lerninhalte zugewiesen.",
    assigned: "Zugewiesen",
    selfAssigned: "Selbst gewählt",
    assignedAt: "seit %{date}",
    expired: "Nicht mehr verfügbar",
    expiredCourse: "Nicht mehr verfügbarer Kurs",
    expiredPath: "Nicht mehr verfügbarer Lernpfad",
    expiredMetric: "Archivierter Lerninhalt",
    viaPath: "Im Lernpfad enthalten",
    viaPathHint:
      "Dieser Kurs ist für Ihre Einrichtung nicht einzeln freigeschaltet. Weisen Sie stattdessen den Lernpfad zu, der ihn enthält.",
    tabs: {
      label: "Art des Lerninhalts",
      courses: "Kurse",
      paths: "Lernpfade",
    },
    values: {
      lessons: "%{smart_count} Lektion |||| %{smart_count} Lektionen",
      courses: "%{smart_count} Kurs |||| %{smart_count} Kurse",
      duration: "%{minutes} Min.",
    },
    actions: {
      assign: "Zuweisen",
      unassign: "Entfernen",
      retry: "Erneut versuchen",
      assignLabel: "%{title} an %{caregiver} zuweisen",
      unassignLabel: "Zuweisung von %{title} für %{caregiver} entfernen",
    },
    dialog: {
      assignTitle: "Lerninhalt zuweisen?",
      unassignTitle: "Zuweisung entfernen?",
      assignContent: "Möchten Sie „%{title}“ %{caregiver} zuweisen?",
      unassignContent:
        "Möchten Sie die Zuweisung von „%{title}“ für %{caregiver} entfernen? Bereits erzielte Lernfortschritte bleiben erhalten.",
      expiredUnassignContent:
        "„%{title}“ ist nicht mehr verfügbar. Möchten Sie die verbliebene Zuweisung für %{caregiver} entfernen? Lernfortschritte bleiben erhalten.",
    },
    notifications: {
      assigned: "„%{title}“ wurde %{caregiver} zugewiesen.",
      unassigned: "Die Zuweisung von „%{title}“ für %{caregiver} wurde entfernt.",
      conflict: "Diese Zuweisung wird bereits aktualisiert.",
      notGranted: "Dieser Kurs ist nicht einzeln freigeschaltet. Weisen Sie stattdessen den zugehörigen Lernpfad zu.",
      error: "Die Zuweisung konnte nicht aktualisiert werden.",
    },
  },
  learningProgress: {
    title: "E-Learning-Fortschritt",
    description: "Behalten Sie Pflichtschulungen, Abschlüsse und Quiz-Ergebnisse Ihrer Pflegekräfte im Blick.",
    loading: "Lernfortschritt wird geladen",
    loadError: "Der Lernfortschritt konnte nicht geladen werden.",
    empty: "Für die aktuelle Auswahl liegen noch keine Lernfortschritte vor.",
    tableLabel: "Lernfortschritt",
    selectCourse: "Kurs",
    selectCaregiver: "Pflegekraft",
    unavailableCourse: "Nicht mehr verfügbarer Kurs",
    unavailablePath: "Nicht mehr verfügbarer Lernpfad",
    unknownCaregiver: "Unbekannte Pflegekraft",
    otherCourses: "Weitere Kurse",
    practitionerTitle: "E-Learning-Fortschritt",
    practitionerEmpty: "Für diese Pflegekraft liegen noch keine Lernfortschritte vor.",
    pathCompleted: "%{completed} von %{total} Kursen abgeschlossen",
    attemptPassed: "bestanden",
    attemptFailed: "nicht bestanden",
    attemptLabel: "Quiz-Ergebnis %{score} am %{date}: %{result}",
    pivots: {
      label: "Berichtsansicht",
      byCourse: "Nach Kurs",
      byCaregiver: "Nach Mitarbeiter",
    },
    summary: {
      assigned: "Zugewiesen gesamt",
      completed: "Abgeschlossen",
      averageScore: "Ø Quiz-Ergebnis",
    },
    columns: {
      caregiver: "Pflegekraft",
      course: "Lerninhalt",
      location: "Wohnbereich",
      status: "Status",
      score: "Quiz-Ergebnis und Verlauf",
      completedAt: "Abgeschlossen am",
    },
    status: {
      not_started: "Zugewiesen",
      in_progress: "In Bearbeitung",
      completed: "Abgeschlossen",
    },
    actions: {
      refresh: "Aktualisieren",
      retry: "Erneut versuchen",
      openReport: "Vollständigen Bericht öffnen",
    },
  },
  forgotPassword: {
    title: "Passwort zurücksetzen",
    description:
      "Geben Sie Ihre E-Mail-Adresse ein. Sie erhalten dann eine E-Mail mit einem Code. Verwenden Sie diesen Code anstelle Ihres Passworts bei der Anmeldung.",
    email: "E-Mail",
    emailRequired: "E-Mail ist erforderlich",
    emailInvalid: "Ungültige E-Mail-Adresse",
    submit: "Code anfordern",
    sending: "Wird gesendet...",
    success:
      "Code erfolgreich gesendet. Bitte prüfen Sie Ihre E-Mails und melden Sie sich mit dem Code als Passwort an.",
    error: "Fehler beim Senden des Codes",
    requestFailed: "Anfrage zum Zurücksetzen des Passworts fehlgeschlagen",
    backToLogin: "Zurück zur Anmeldung",
  },
  resetPassword: {
    title: "Neues Passwort festlegen",
    description: "Wählen Sie ein neues Passwort für Ihr Konto.",
    password: "Neues Passwort",
    passwordRequired: "Passwort ist erforderlich",
    passwordMinLength: "Passwort muss mindestens %{minLength} Zeichen lang sein",
    confirmPassword: "Passwort bestätigen",
    confirmPasswordRequired: "Bitte bestätigen Sie Ihr Passwort",
    passwordsDoNotMatch: "Passwörter stimmen nicht überein",
    submit: "Passwort zurücksetzen",
    resetting: "Wird zurückgesetzt...",
    success: "Passwort erfolgreich zurückgesetzt",
    error: "Fehler beim Zurücksetzen des Passworts",
    backToLogin: "Zurück zur Anmeldung",
    signInRequired: "Ihr Passwort wurde gespeichert. Bitte melden Sie sich mit Ihrem neuen Passwort an.",
  },
  mfa: {
    title: "Zwei-Faktor-Authentifizierung",
    setupDescription: "Scannen Sie den QR-Code mit Ihrer Authenticator-App und geben Sie anschließend den Code ein.",
    replacementSetupDescription:
      "Richten Sie jetzt einen neuen Authenticator ein. Der bisherige Authenticator bleibt bis zur Bestätigung gültig.",
    verificationDescription: "Geben Sie den sechsstelligen Code aus Ihrer Authenticator-App ein.",
    restartDescription: "Starten Sie die Anmeldung erneut, um einen neuen Bestätigungsvorgang zu beginnen.",
    qrCode: "QR-Code für die Zwei-Faktor-Authentifizierung",
    manualKey: "Manueller Schlüssel",
    code: "Authenticator-Code",
    recoveryCode: "Wiederherstellungscode",
    useRecoveryCode: "Wiederherstellungscode verwenden",
    useAuthenticatorCode: "Authenticator-Code verwenden",
    submit: "Bestätigen",
    verifying: "Wird bestätigt...",
    invalidCode: "Der eingegebene Code ist ungültig. Bitte versuchen Sie es erneut.",
    expired: "Der Bestätigungsvorgang ist abgelaufen.",
    locked: "Zu viele fehlgeschlagene Versuche. Bitte versuchen Sie es in 15 Minuten erneut.",
    lockedWithRetry: "Zu viele fehlgeschlagene Versuche. Bitte versuchen Sie es in %{seconds} Sekunden erneut.",
    restart: "Zurück zur Anmeldung",
    back: "Abbrechen",
    error: "Die Zwei-Faktor-Authentifizierung konnte nicht abgeschlossen werden.",
    recoveryCodesTitle: "Wiederherstellungscodes speichern",
    recoveryCodesWarning: "Bewahren Sie diese Codes sicher auf. Jeder Code kann nur einmal verwendet werden.",
    codesSaved: "Codes sicher gespeichert",
    settingsTitle: "Zwei-Faktor-Authentifizierung",
    loading: "Einstellungen werden geladen...",
    settingsError:
      "Die Einstellungen für die Zwei-Faktor-Authentifizierung konnten nicht geladen oder gespeichert werden.",
    retry: "Erneut versuchen",
    disabledDescription: "Die Zwei-Faktor-Authentifizierung ist derzeit deaktiviert.",
    enabledDescription: "Die Zwei-Faktor-Authentifizierung ist aktiviert.",
    enable: "Zwei-Faktor-Authentifizierung aktivieren",
    disable: "Zwei-Faktor-Authentifizierung deaktivieren",
    disabled: "Die Zwei-Faktor-Authentifizierung wurde deaktiviert.",
    currentPassword: "Aktuelles Passwort",
    currentPasswordRequired: "Das aktuelle Passwort ist erforderlich.",
  },
  registration: {
    title: "Kontoeinrichtung abschließen",
    description: "Bitte geben Sie Ihre Daten ein, um Ihr Konto einzurichten.",
    name: "Name",
    password: "Passwort",
    confirmPassword: "Passwort bestätigen",
    organizationName: "Account",
    prefilledFromInvite: "Aus Ihren Account-Kontaktdaten übernommen",
    completeRegistration: "Registrierung abschließen",
    creatingAccount: "Konto wird erstellt...",
    nameRequired: "Name ist erforderlich",
    passwordRequired: "Passwort ist erforderlich",
    passwordMinLength: "Passwort muss mindestens %{minLength} Zeichen lang sein",
    confirmPasswordRequired: "Bitte bestätigen Sie Ihr Passwort",
    passwordsDoNotMatch: "Passwörter stimmen nicht überein",
    organizationNameRequired: "Organisationsname ist erforderlich",
    existingLoginConflict:
      "Für diese E-Mail-Adresse besteht bereits ein Login. Bitte kontaktieren Sie den Support, um den Zugriff zu klären.",
    signInRequired: "Ihr Konto wurde erstellt. Bitte melden Sie sich mit Ihrem neuen Passwort an.",
    staffDescription:
      "Sie wurden in das media4care Admin Portal eingeladen. Bitte geben Sie Ihren Namen ein und legen Sie ein Passwort fest.",
    invitedRoles: "Ihre Rollen: %{roles}",
  },
  team: {
    title: "Team",
    heading: "Team",
    description:
      "Interne Mitarbeitende und ihre Rollen. Eine geänderte Rolle gilt ab der nächsten Anfrage der Person; ihr Menü ändert sich bei der nächsten Anmeldung.",
    loading: "Team wird geladen",
    loadError: "Das Team konnte nicht geladen werden.",
    columns: { name: "Name", email: "E-Mail", roles: "Rollen" },
    noRoles: "Keine Rolle – kein Zugriff auf interne Funktionen",
    addRole: "Rolle für %{name} hinzufügen",
    removeRole: "Rolle %{role} von %{name} entfernen",
    removeRoleTitle: "Rolle entfernen",
    removeRoleConfirm: "Soll %{name} die Rolle %{role} verlieren?",
    roleAdded: "%{name} hat jetzt die Rolle %{role}.",
    roleRemoved: "%{name} hat die Rolle %{role} nicht mehr.",
    roleChangeError: "Die Rolle konnte nicht geändert werden.",
    invite: {
      open: "Mitarbeitende einladen",
      title: "Mitarbeitende einladen",
      email: "E-Mail",
      roles: "Rollen",
      rolesHelp: "Die Person erhält genau die gewählten Rollen. Wählen Sie mindestens eine.",
      submit: "Einladung senden",
      cancel: "Abbrechen",
      sent: "Einladung an %{email} versendet.",
      error: "Die Einladung konnte nicht versendet werden.",
    },
    invitations: {
      title: "Offene Einladungen",
      loading: "Einladungen werden geladen",
      loadError: "Die Einladungen konnten nicht geladen werden.",
      empty: "Keine offenen Einladungen.",
      columns: {
        email: "E-Mail",
        roles: "Rollen",
        status: "Status",
        invitedBy: "Eingeladen von",
        createdAt: "Eingeladen am",
      },
      status: { SENDING: "Wird versendet", SENT: "Versendet", FAILED: "Versand fehlgeschlagen" },
      cancel: "Zurückziehen",
      cancelFor: "Einladung an %{email} zurückziehen",
      cancelTitle: "Einladung zurückziehen",
      cancelConfirm:
        "Soll die Einladung an %{email} zurückgezogen werden? Der Code aus der E-Mail gilt danach nicht mehr.",
      cancelled: "Die Einladung an %{email} wurde zurückgezogen.",
      cancelError: "Die Einladung konnte nicht zurückgezogen werden.",
    },
    errors: {
      "last-admin": "Die letzte Person mit der Rolle Admin kann diese Rolle nicht verlieren.",
      "staff-member-not-found": "Diese Person gehört nicht mehr zum Team.",
      "staff-email-registered": "Für diese E-Mail-Adresse gibt es bereits ein Konto.",
      "staff-email-company-plus-address":
        "Mit einer Firmenadresse mit Zusatz (+) ist keine Anmeldung möglich. Laden Sie die Hauptadresse ein.",
      "staff-invitation-pending": "Für diese E-Mail-Adresse gibt es bereits eine offene Einladung.",
      "staff-roles-required": "Wählen Sie mindestens eine Rolle.",
      "invalid-email": "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
      "staff-invitation-not-found": "Diese Einladung ist nicht mehr offen.",
    },
  },
  marketing: {
    title: "Marketing",
    loadError: "Die Marketingdaten konnten nicht geladen werden.",
    overview: {
      title: "Übersicht",
      newLeadsThisMonth: "Neue Leads diesen Monat",
      newLeads: "Neue Leads (12 Monate)",
      conversions: "Konvertiert (12 Monate)",
      medianDays: "Median bis zur Konvertierung",
      days: "%{days} Tage",
      openLeads: "Offene Leads",
      newLeadsChart: "Neue Leads pro Monat nach Leadquelle",
      openByStatus: "Offene Leads nach Status",
      bySource: "Neue Leads nach Leadquelle",
      byTarget: "Konvertierungen nach Ziel",
      source: "Leadquelle",
      target: "Konvertieren zu",
      total: "Gesamt",
      none: "(ohne)",
      others: "Weitere",
      medianRow: "Median Tage bis zur Konvertierung",
      showDetails: "Leadquelle Detail von %{source} einblenden",
      hideDetails: "Leadquelle Detail von %{source} ausblenden",
      noLeads: "Keine neuen Leads in diesen zwölf Monaten.",
      noConversions: "Keine Konvertierungen in diesen zwölf Monaten.",
      noOpenLeads: "Keine offenen Leads.",
    },
    webOrders: {
      title: "Web-Bestellungen",
      stuckRule: "Hängt fest, wenn %{minutes} Minuten nach dem Lead ein Schritt fehlt",
      total: "Web-Bestellungen (12 Wochen)",
      stuck: "Hängen fest",
      thisWeek: "Diese Woche",
      perWeek: "Web-Bestellungen pro Woche",
      orders: "Bestellungen",
      list: "Bestellungen der letzten 12 Wochen",
      onlyStuck: "Nur festhängende",
      created: "Erstellt",
      customer: "Kunde",
      products: "Produkte",
      empty: "Keine Web-Bestellungen.",
      emptyStuck: "Keine festhängenden Web-Bestellungen.",
      missing: "fehlt",
      pending: "ausstehend",
      afterMinutes: "nach %{minutes} Min.",
      afterHours: "nach %{hours} Std.",
      openInSalesforce: "In Salesforce öffnen",
      openOpportunityInSalesforce: "Opportunity in Salesforce öffnen",
      confirmationNotTracked:
        "Die Auftragsbestätigung wird noch nicht übernommen: Eine Bestellung ohne Bestätigung erscheint hier vollständig.",
      planVariantIdsUnknown:
        "Salesforce gibt die Plan-Varianten-IDs der Leads noch nicht frei: Konvertierte Web-Bestellungen fehlen in dieser Liste.",
      planVariants: "%{smart_count} Plan-Varianten-ID |||| %{smart_count} Plan-Varianten-IDs",
      steps: {
        LEAD_PRODUCTS: "Lead-Produkte",
        CONVERSION: "Konvertiert",
        CONTRACT: "Vertrag",
        ORDER: "Auftrag",
      },
      markers: {
        STUCK: "Hängt fest",
        PRODUCT_WITHOUT_PLAN_VARIANT: "Produkt-ID ohne Plan-Variante",
        CONVERTED_WITHOUT_CONTRACT: "Konvertiert ohne Vertrag",
      },
    },
  },
  staffRoles: {
    ADMIN: "Admin",
    MANAGEMENT: "Management",
    CUSTOMER_SERVICE: "Customer Service",
    CUSTOMER_SUCCESS: "Customer Success",
    OPERATIONS: "Operations",
    FINANCE: "Finance",
    MARKETING: "Marketing",
  },
  errors: {
    loginFailed: "Anmeldung fehlgeschlagen",
    registrationFailed: "Registrierung fehlgeschlagen",
  },
  resources: {
    Organization: "Einrichtungen",
    Practitioner: "Mitarbeiter",
    Patient: "Klienten",
    Location: "Wohnbereiche",
    LocationSites: "Standorte",
    Device: "Apps",
    Invitation: "Manager-Einladungen",
    Procedure: "Maßnahmen",
    Analytics: "Analytics Dashboard",
    LearningGrant: "E-Learning-Freigaben",
    LearningAssignment: "E-Learning-Zuweisungen",
    LearningProgress: "E-Learning-Fortschritt",
    SalesforceDashboard: "Salesforce-Dashboard",
    "salesforce-dashboard": "Salesforce-Dashboard",
    "salesforce-records": "Datensätze",
    Crm: "CRM",
    integrations: "Integrationen",
    crm: "CRM",
    analytics: "Analytics Dashboard",
    account: "Konto",
    "change-password": "Passwort ändern",
    "integration-settings": "Integrations-Einstellungen",
    "salesforce-integration": "Integrationen",
    "marketing-delivery": "Marketing-Versand",
    team: "Team",
    onboarding: "Einrichtungsassistent",
  },
  dhlSettings: {
    checkConnection: "Verbindung testen",
    checkingConnection: "Verbindung wird getestet…",
    checkStoredSettings: "Prüft die gespeicherten DHL-Zugangsdaten und lädt österreichische Retourenempfänger.",
    saveBeforeCheck: "Änderungen vor dem Verbindungstest speichern. Es werden nur gespeicherte Zugangsdaten geprüft.",
    connectionSuccess: "Mit DHL verbunden.",
    connectionError: "Die DHL-Verbindung konnte nicht geprüft werden. Bitte erneut versuchen.",
    unlistedReceiverOption: "%{receiverId} (gespeichert, nicht in der DHL-Liste)",
    unlistedReceiver:
      "Der gespeicherte Retourenempfänger fehlt in der DHL-Liste. Einen gelisteten österreichischen Empfänger auswählen und speichern.",
    noReceivers:
      "DHL hat keine österreichischen Retourenempfänger geliefert. Einen österreichischen Retourenempfänger bei DHL einrichten und erneut prüfen.",
    connectionFailures: {
      NOT_CONFIGURED:
        "Gespeicherte DHL-Zugangsdaten fehlen oder sind nicht verfügbar. Fehlende Zugangsdaten eingeben, speichern und erneut prüfen.",
      UNAUTHORIZED:
        "DHL hat die gespeicherten Zugangsdaten abgelehnt. Client-ID, Client-Secret, Benutzername und Passwort prüfen, speichern und erneut versuchen.",
      UNREACHABLE: "DHL ist nicht erreichbar. Verbindung prüfen und später erneut versuchen.",
      RATE_LIMITED: "DHL erhält zu viele Anfragen. Kurz warten und erneut versuchen.",
      PROVIDER_ERROR: "DHL konnte die Prüfung nicht abschließen. Bitte später erneut versuchen.",
      INVALID_RESPONSE:
        "Die DHL-Antwort konnte nicht gelesen werden. Später erneut versuchen; bei anhaltendem Problem den Support kontaktieren.",
    },
    accountTitle: "DHL-Zugang",
    accountDescription:
      "Gespeicherte DHL-Zugangsdaten, Abrechnungsnummern und Retourenempfänger in Österreich konfigurieren.",
    gateway: "DHL-Umgebung",
    gateways: { SANDBOX: "Testumgebung", PRODUCTION: "Produktivumgebung" },
    secretStored: "Gespeichert. Leer lassen, um den vorhandenen Wert beizubehalten.",
    secretRequired: "Für die erste Speicherung erforderlich. Bitte einen Wert eingeben.",
    secretRequiredAgain: "Nach einer Änderung der zugehörigen Client-ID oder des Benutzernamens erneut eingeben.",
    title: "DHL-Einstellungen",
    shippingTitle: "Versandeinstellungen",
    shippingDescription: "Absender, Retourenadresse und Druckformate für DHL-Versandlabels konfigurieren.",
    shipper: "Absender",
    returnAddress: "Retourenadresse (optional)",
    returnHint: "Alle vier Felder ausfüllen oder alle leer lassen. Ohne Retourenadresse verwendet DHL den Absender.",
    missingSettings: "Für Versandlabels fehlen noch folgende Einstellungen:",
    loading: "DHL-Einstellungen werden geladen",
    loadError: "Die DHL-Einstellungen konnten nicht geladen werden.",
    saved: "Die DHL-Einstellungen wurden gespeichert.",
    saveError: "Die DHL-Einstellungen konnten nicht gespeichert werden.",
    invalid: "Bitte die markierten Felder prüfen.",
    fieldInvalid: "Bitte einen gültigen Wert eingeben.",
    save: "Speichern",
    saving: "Wird gespeichert…",
    settings: {
      CLIENT_ID: "Client-ID",
      CLIENT_SECRET: "Client-Secret",
      USERNAME: "Benutzername",
      PASSWORD: "Passwort",
      BILLING_NUMBER_PAKET: "Abrechnungsnummer Paket (Deutschland)",
      BILLING_NUMBER_PAKET_INTERNATIONAL: "Abrechnungsnummer Paket (international)",
      BILLING_NUMBER_RETOURE: "Abrechnungsnummer Retoure",
      RETURN_RECEIVER_ID_AT: "Retourenempfänger-ID Österreich",
      SHIPPER_NAME: "Absendername",
      SHIPPER_STREET: "Absenderstraße und Hausnummer",
      SHIPPER_POSTAL_CODE: "Absender-Postleitzahl",
      SHIPPER_CITY: "Absenderort",
      RETURN_NAME: "Retourenname",
      RETURN_STREET: "Retourenstraße und Hausnummer",
      RETURN_POSTAL_CODE: "Retouren-Postleitzahl",
      RETURN_CITY: "Retourenort",
      LABEL_PRINT_FORMAT: "Druckformat Versandlabel",
      RETURN_LABEL_PRINT_FORMAT: "Druckformat Retourenlabel Österreich",
    },
  },
  integrations: {
    title: "Integrationen",
    loading: "Integrationen werden geladen",
    loadError: "Die Integrationen konnten nicht geladen werden.",
    saveError: "Die Placetel-Einstellungen konnten nicht gespeichert werden.",
    saved: "Die Placetel-Einstellungen wurden gespeichert.",
    placetel: {
      title: "Placetel (Webex)",
      description: "Konfiguration der Placetel Webex Service App.",
      credentialsHint:
        "Bei der ersten Speicherung sind Client-Secret, Refresh-Token und Webhook-Secret erforderlich. Bei einer Änderung der Webex-Organisations-ID oder Client-ID sind Client-Secret und Refresh-Token erneut erforderlich.",
      enabled: "Placetel-Integration aktivieren",
      organizationId: "Webex-Organisations-ID",
      clientId: "Client-ID",
      clientSecret: "Client-Secret",
      refreshToken: "Refresh-Token",
      webhookSecret: "Webhook-Secret",
      phoneTitle: "Telefon im Portal",
      phoneDescription:
        "Webex-Integration, mit der sich Mitarbeitende einmalig für das Telefon im Portal anmelden. Die Service App oben kann das nicht.",
      phoneRedirectUri: "Weiterleitungs-URL für die Webex-Integration: %{redirectUri}",
      phoneClientId: "Client-ID der Integration",
      phoneClientSecret: "Client-Secret der Integration",
      phoneClientIdHelp:
        "Leer lassen, wenn das Telefon im Portal nicht genutzt wird. Eine Änderung trennt das Telefon aller Mitarbeitenden.",
      phoneSecretRequiredAgain: "Nach einer Änderung der Client-ID der Integration erneut erforderlich.",
      secretStored: "Gespeichert. Leer lassen, um den vorhandenen Wert beizubehalten.",
      secretRequired: "Für die erste Speicherung erforderlich.",
      secretRequiredAgain: "Nach einer Änderung der Organisations-ID oder Client-ID erneut erforderlich.",
      errors: {
        "placetel-organization-id-invalid": "Die Webex-Organisations-ID ist ungültig.",
        "placetel-client-id-invalid": "Die Client-ID ist ungültig.",
        "placetel-client-secret-invalid": "Das Client-Secret ist ungültig.",
        "placetel-client-secret-required": "Bitte das Client-Secret eingeben.",
        "placetel-refresh-token-invalid": "Der Refresh-Token ist ungültig.",
        "placetel-refresh-token-required": "Bitte den Refresh-Token eingeben.",
        "placetel-webhook-secret-invalid": "Das Webhook-Secret ist ungültig.",
        "placetel-webhook-secret-required": "Für die erste Speicherung ist ein Webhook-Secret erforderlich.",
        "placetel-phone-client-id-invalid": "Die Client-ID der Integration ist ungültig.",
        "placetel-phone-client-secret-invalid": "Das Client-Secret der Integration ist ungültig.",
        "placetel-phone-client-secret-required": "Bitte das Client-Secret der Integration eingeben.",
      },
      save: "Speichern",
      saving: "Wird gespeichert…",
      checkConnection: "Verbindung testen",
      checkingConnection: "Verbindung wird getestet…",
      connectionUsesSavedValues: "Der Test verwendet die gespeicherten Einstellungen.",
      connectionSaveFirst: "Bitte speichern Sie die Einstellungen zuerst.",
      connectionSuccess: "Verbunden mit %{accountName}.",
      connectionError: "Die Verbindung konnte nicht getestet werden. Bitte versuchen Sie es erneut.",
      connectionErrors: {
        NOT_CONFIGURED: "Speichern Sie die Einstellungen zuerst.",
        CREDENTIALS_UNAVAILABLE:
          "Geben Sie Client-Secret und Refresh-Token erneut ein und speichern Sie die Einstellungen.",
        AUTHENTICATION_FAILED: "Prüfen Sie die Zugangsdaten.",
        INSUFFICIENT_SCOPE: "Die Service App benötigt den Berechtigungsumfang zum Lesen von Organisationen.",
        ORGANIZATION_NOT_FOUND: "Prüfen Sie die Webex-Organisations-ID.",
        ORGANIZATION_MISMATCH: "Das gefundene Konto stimmt nicht mit der Webex-Organisations-ID überein.",
        INVALID_RESPONSE: "Webex hat eine unerwartete Antwort gesendet. Versuchen Sie es erneut.",
        TIMEOUT: "Die Anfrage hat zu lange gedauert. Versuchen Sie es erneut.",
        RATE_LIMITED: "Webex begrenzt Anfragen derzeit. Warten Sie kurz und versuchen Sie es erneut.",
        PROVIDER_ERROR: "Webex ist derzeit nicht verfügbar. Versuchen Sie es erneut.",
        NETWORK_ERROR: "Webex ist derzeit nicht erreichbar. Versuchen Sie es erneut.",
      },
      callHistory: {
        OK: "Anrufliste: freigegeben",
        FORBIDDEN:
          "Anrufliste: nicht freigegeben. Die Service App braucht den Scope spark-admin:calling_cdr_read und eine Admin-Rolle mit „Webex Calling Detailed Call History API access“.",
        RATE_LIMITED: "Anrufliste: gerade ausgelastet, bitte in einer Minute erneut prüfen.",
        FAILED: "Anrufliste: konnte nicht geprüft werden.",
      },
    },
    hotlineNumbers: {
      title: "Hotline-Nummern",
      description:
        "Nur Anrufe an diese Nummern zählen in der Service-Übersicht als eingehende Anrufe der Hotline. Mit Ländervorwahl eintragen, zum Beispiel +4930123456. Anrufe an andere Nummern werden nicht aufbewahrt, sondern 12 Stunden nach dem Anruf gelöscht. Die Service-Übersicht folgt den aktuellen Nummern und den aktuellen Telefon-Verknüpfungen der Mitarbeitenden.",
      loading: "Hotline-Nummern werden geladen",
      loadError: "Die Hotline-Nummern konnten nicht geladen werden.",
      empty: "Noch keine Hotline-Nummern.",
      number: "Rufnummer",
      remove: "Nummer entfernen",
      add: "Nummer hinzufügen",
      save: "Speichern",
      saving: "Wird gespeichert…",
      saved: "Hotline-Nummern gespeichert",
      invalid:
        "Mindestens eine Nummer ist ungültig oder doppelt. Bitte jede Nummer einmal und mit Ländervorwahl eintragen.",
      saveError: "Die Hotline-Nummern konnten nicht gespeichert werden.",
    },
    openingHours: {
      title: "Öffnungszeiten",
      description:
        "Zählen für die Erreichbarkeit in der Service-Übersicht. Deutsche Zeit, Feiertage werden nicht berücksichtigt.",
      loading: "Öffnungszeiten werden geladen",
      loadError: "Die Öffnungszeiten konnten nicht geladen werden.",
      days: {
        "1": "Montag",
        "2": "Dienstag",
        "3": "Mittwoch",
        "4": "Donnerstag",
        "5": "Freitag",
        "6": "Samstag",
        "7": "Sonntag",
      },
      open: "Geöffnet",
      opens: "Von",
      closes: "Bis",
      blank: "Bitte ausfüllen",
      beforeCloses: "Muss vor „Bis“ liegen",
      save: "Speichern",
      saving: "Wird gespeichert…",
      saved: "Öffnungszeiten gespeichert",
      saveError: "Die Öffnungszeiten konnten nicht gespeichert werden.",
    },
  },
  telephony: {
    activate: "Telefon aktivieren",
    panel: {
      title: "Telefon",
      menu: "Menü",
    },
    call: {
      dial: "Anrufen",
      hangUp: "Auflegen",
      dialing: "Wird gewählt…",
      connecting: "Wird verbunden…",
      mute: "Stummschalten",
      unmute: "Stummschaltung aufheben",
      numberLabel: "Nummer",
      invalidNumber: "Diese Nummer kann nicht gewählt werden.",
      microphoneBlocked: "Das Mikrofon ist nicht freigegeben. Bitte im Browser erlauben.",
      failed: "Der Anruf konnte nicht gestartet werden.",
      ended: "Anruf beendet",
    },
    note: {
      label: "Notiz zum Anruf",
      save: "Notiz speichern",
      discard: "Schließen",
      saved: "Notiz gespeichert",
      failed: "Die Notiz konnte nicht gespeichert werden.",
      unlinked: "Diese Notiz erscheint bei keinem Datensatz.",
    },
    link: {
      openRecord: "Mit geöffnetem Datensatz verknüpfen",
      linked: "Mit Datensatz verknüpft",
    },
    incoming: {
      title: "Eingehender Anruf",
      unknownNumber: "Unbekannte Nummer",
      answer: "Annehmen",
      decline: "Ablehnen",
      titlePrefix: "Anruf · ",
      notificationTitle: "Eingehender Anruf",
    },
    callerMatch: {
      title: "Wer ruft an?",
      none: "Kein Eintrag zu dieser Nummer",
      search: "In Kontakten suchen",
      error: "Der Anrufer konnte nicht gesucht werden.",
      retry: "Erneut suchen",
    },
    connectedAs: "Verbunden als %{email}",
    disconnect: "Telefon trennen",
    retry: "Erneut verbinden",
    status: {
      starting: "Telefon wird verbunden…",
      ready: "Telefon ist bereit",
      error: "Telefon ist nicht erreichbar",
      unavailable: "Das Telefon ist derzeit nicht eingerichtet.",
    },
    activated: "Das Telefon ist aktiviert.",
    disconnected: "Das Telefon wurde getrennt.",
    activateError: "Das Telefon konnte nicht aktiviert werden. Bitte versuchen Sie es erneut.",
    disconnectError: "Das Telefon konnte nicht getrennt werden. Bitte versuchen Sie es erneut.",
    signInErrors: {
      REQUEST_EXPIRED: "Die Anmeldung ist abgelaufen. Bitte erneut „Telefon aktivieren“ wählen.",
      CANCELLED: "Die Anmeldung wurde abgebrochen.",
      UNAVAILABLE: "Das Telefon ist derzeit nicht eingerichtet.",
      WRONG_ORGANIZATION:
        "Dieses Konto gehört nicht zur Telefonanlage von media4care. Bitte mit dem Firmenkonto anmelden.",
      ACCOUNT_IN_USE: "Dieses Telefonkonto ist bereits mit einem anderen Benutzer verbunden.",
      AUTHENTICATION_FAILED: "Die Anmeldung ist fehlgeschlagen. Bitte erneut versuchen.",
      INSUFFICIENT_SCOPE: "Die Anmeldung hat nicht alle nötigen Berechtigungen erteilt.",
      INVALID_RESPONSE: "Die Telefonanlage ist gerade nicht erreichbar. Bitte später erneut versuchen.",
      TIMEOUT: "Die Telefonanlage ist gerade nicht erreichbar. Bitte später erneut versuchen.",
      RATE_LIMITED: "Die Telefonanlage ist gerade nicht erreichbar. Bitte später erneut versuchen.",
      PROVIDER_ERROR: "Die Telefonanlage ist gerade nicht erreichbar. Bitte später erneut versuchen.",
      NETWORK_ERROR: "Die Telefonanlage ist gerade nicht erreichbar. Bitte später erneut versuchen.",
    },
  },
  account: {
    general: "Allgemein",
    organization: "Einrichtung",
    email: "E-Mail-Adresse",
    role: "Rolle",
    password: "Passwort",
    changePassword: "Passwort ändern",
    signIn: "Anmeldung",
    companySignIn: "Mit Firmenkonto (Google)",
    notAvailable: "Nicht verfügbar",
    loadError: "Die Kontodaten konnten nicht geladen werden.",
    roles: {
      ANALYTICS: "Analytics",
      CUSTOMER_SERVICE: "Customer Success",
      MANAGER: "Manager",
    },
  },
  billing: {
    title: "Abrechnung",
    description: "Rechnungen und Gutschriften für %{organization}",
    documents: "Rechnungen und Gutschriften",
    number: "Belegnummer",
    date: "Datum",
    amount: "Gesamtbetrag",
    document: "Dokument",
    loading: "Rechnungen werden geladen",
    empty: "Es liegen noch keine Rechnungen oder Gutschriften vor.",
    accessDisabled:
      "Der Zugriff auf Abrechnungsdaten ist für diese Einrichtung deaktiviert. Bitte wenden Sie sich an unseren Kundenservice.",
    notConfigured:
      "Ihre Abrechnungsunterlagen sind hier noch nicht verfügbar. Bitte wenden Sie sich an unseren Kundenservice.",
    loadError: "Die Abrechnungsunterlagen konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
    retry: "Erneut versuchen",
    download: "PDF",
    downloadLabel: "%{number} als PDF herunterladen",
    downloading: "Wird geladen …",
    downloadError: "Das Dokument konnte nicht geöffnet werden. Bitte versuchen Sie den Download erneut.",
    popupBlocked: "Ihr Dokument ist bereit. Falls kein neuer Tab geöffnet wurde:",
    openDocument: "PDF öffnen",
    refresh: "Aktualisieren",
  },
  billingAccess: {
    label: "Abrechnungszugriff",
    loading: "Abrechnungszugriff wird geladen.",
    checkboxLabel: "Abrechnungszugriff für %{organization}",
    accountScopeHint: "Der Zugriff umfasst alle Vertrags- und Rechnungsdaten des zugeordneten Abrechnungskontos.",
    notAvailable: "Nicht verfügbar – kein Frisbii-Konto zugeordnet.",
    link: "Abrechnungskonto verknüpfen",
    linkedAccount: "Abrechnungskonto",
    linkTitle: "Abrechnungskonto für %{organization}",
    salesforceAccount: "Salesforce-Konto",
    frisbiiCustomerId: "Frisbii-Kunden-ID",
    checkCustomer: "Konto prüfen",
    customerNotFound: "Kein Frisbii-Konto gefunden.",
    customerError: "Das Frisbii-Konto konnte nicht geprüft werden. Bitte erneut versuchen.",
    searchError: "Die Salesforce-Konten konnten nicht geladen werden. Bitte erneut versuchen.",
    confirmEntitlement:
      "Ich bestätige, dass die Einrichtung auf alle Verträge und Rechnungen dieses Zahlungskontos zugreifen darf.",
    accessOffAfterSave:
      "Der Abrechnungszugriff bleibt nach dem Speichern deaktiviert und muss anschließend separat aktiviert werden.",
    detach: "Frisbii-Verknüpfung entfernen",
    loadError: "Die Abrechnungszugriffe konnten nicht geladen werden.",
    saveError: "Die Änderung konnte nicht gespeichert werden. Bitte erneut versuchen.",
    linkSaveError:
      "Die Verknüpfung konnte nicht gespeichert werden. Bitte erneut versuchen oder die aktuelle Zuordnung neu laden.",
    reloadMapping: "Zuordnung neu laden",
    retry: "Erneut versuchen",
  },
  contracts: {
    title: "Vertragspositionen",
    description: "Vertragspositionen für %{organization}",
    snapshot: "Angezeigt werden die zuletzt übermittelten Vertragsdaten.",
    loading: "Vertragsdaten werden geladen",
    empty: "Es sind noch keine zugeordneten Vertragspositionen verfügbar.",
    notConfigured: "Ihre Vertragsdaten sind hier noch nicht verfügbar. Bitte wenden Sie sich an unseren Kundenservice.",
    loadError: "Die Vertragsdaten konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
    name: "Vertragsposition",
    product: "Produkt",
    status: "Status",
    dates: "Laufzeit",
    startDate: "Beginn: %{date}",
    endDate: "Ende: %{date}",
    noEndDate: "Kein Enddatum hinterlegt",
    family: "Produktfamilie: %{value}",
    plan: "Tarif: %{value}",
    flavour: "Variante: %{value}",
    sponsor: "Kostenträger: %{value}",
    statuses: { Active: "Aktiv", Inactive: "Inaktiv", Cancelled: "Gekündigt" },
    plans: { basic: "Basis", standard: "Standard", comfort: "Komfort", games: "Spiele" },
  },
  changePassword: {
    title: "Passwort ändern",
    description: "Bestätigen Sie Ihr aktuelles Passwort und wählen Sie anschließend ein neues Passwort.",
    oldPassword: "Aktuelles Passwort",
    newPassword: "Neues Passwort",
    confirmPassword: "Neues Passwort bestätigen",
    passwordRequirements:
      "Das Passwort muss mindestens 16 Zeichen lang sein und einen Großbuchstaben, einen Kleinbuchstaben, eine Zahl und ein Sonderzeichen (@$!%*?&) enthalten.",
    passwordsDoNotMatch: "Die Passwörter stimmen nicht überein.",
    oldPasswordIncorrect: "Das aktuelle Passwort ist nicht korrekt.",
    submit: "Passwort ändern",
    submitting: "Passwort wird geändert ...",
    success: "Das Passwort wurde erfolgreich geändert.",
    error: "Das Passwort konnte nicht geändert werden.",
  },
  logisticsShippingLabel: {
    title: "Versandetiketten",
    loading: "Etikett wird geladen…",
    noOrder: "Kein lokaler Logistikauftrag verfügbar.",
    disabled: "Etikettenaktionen sind für Ihren aktuellen Zugriff nicht freigeschaltet.",
    loadError: "Der aktuelle Etikettenstatus konnte nicht geladen werden. Aktualisieren Sie ihn vor dem Fortfahren.",
    create: "Etikett erstellen",
    cancel: "Etikett stornieren",
    cancelling: "Etikett wird storniert…",
    retryTracking: "Sendungsnummern erneut aktualisieren",
    cancelMarker:
      "Eine vorhandene Salesforce-Exportmarkierung bleibt bei der Stornierung erhalten. Diese Markierung verhindert ein neues Pilot-Etikett.",
    creating: "Etikett wird erstellt…",
    retry: "Übertragung des Etiketts erneut versuchen",
    retryCreate: "Etikett erneut erstellen",
    continue: "Dieselbe Anfrage fortsetzen",
    returnLabel: "Optionales Retourenetikett anfordern",
    refresh: "Etikettenstatus aktualisieren",
    transportLost:
      "Die Antwort ist verloren gegangen. Prüfen Sie den Status oder setzen Sie dieselbe Anfrage fort; legen Sie keine zweite Sendung an.",
    statusRefreshError:
      "Das Etikettenergebnis ist gespeichert, aber der Aktualisierungsstatus des Auftrags konnte nicht geladen werden.",
    unknown: "Das Ergebnis ist unklar. Lassen Sie die Sendung vor einer weiteren Aktion prüfen.",
    anotherPending: "Ein anderer Etikettenbefehl wird noch verarbeitet.",
    cancelledHistory:
      "Storniertes Etikett — die PDFs bleiben als Nachweis erhalten und dürfen nicht für den Versand verwendet werden.",
    outboundTracking: "Sendungsverfolgung: %{number}",
    returnTracking: "Retourenverfolgung: %{number}",
    openOutbound: "Versand-PDF öffnen / drucken",
    downloadOutbound: "Versand-PDF herunterladen",
    openReturn: "Retouren-PDF öffnen / drucken",
    downloadReturn: "Retouren-PDF herunterladen",
    pdfError: "Dieses PDF konnte nicht geöffnet werden. Aktualisieren Sie den Etikettenstatus.",
    pilotStatus: "Befehlsstatus:",
    salesforceStatus: "Salesforce-Status:",
    refusalFallback: "Der Befehl wurde abgelehnt. Laden und prüfen Sie den Auftrag vor einem erneuten Versuch.",
    outcomes: {
      CREATED: "DHL-Etikett erstellt und gespeichert.",
      EXISTING: "Das gespeicherte DHL-Etikett wird verwendet.",
      CANCELLED: "Die DHL-Stornierung ist gespeichert.",
      REFUSED: "DHL wurde für diesen Befehl nicht aufgerufen.",
      REJECTED: "DHL hat den Befehl abgelehnt.",
      FAILED: "DHL hat keine verwertbare Antwort geliefert.",
      UNKNOWN: "Das Etikettenergebnis ist noch nicht bestätigt.",
    },
    phases: {
      IN_PROGRESS: "Wird verarbeitet…",
      SUCCEEDED: "Abgeschlossen.",
      REFUSED: "Nicht ausgeführt.",
      REJECTED: "Abgelehnt.",
      UNKNOWN: "Unklar; vor dem Fortfahren prüfen.",
    },
    address: {
      RECIPIENT: "Empfänger vervollständigen.",
      STREET: "Straße vervollständigen.",
      POSTAL_CODE: "Postleitzahl vervollständigen.",
      CITY: "Ort vervollständigen.",
      HOUSE_NUMBER: "Hausnummer vervollständigen.",
    },
    failures: {
      UNREACHABLE: "DHL konnte nicht erreicht werden.",
      UNAUTHORIZED: "DHL hat die eingerichteten Zugangsdaten abgelehnt.",
      RATE_LIMITED: "DHL verlangt weniger Anfragen.",
      PROVIDER_ERROR: "DHL hat einen Anbieterfehler gemeldet.",
      INVALID_RESPONSE: "DHL hat eine nicht lesbare Antwort geliefert.",
    },
    refusals: {
      NOT_ENABLED: "Etiketten sind nicht freigeschaltet.",
      NOT_CONFIGURED: "Die DHL-Einstellungen sind unvollständig.",
      DHL_NOT_CONFIGURED: "Die DHL-Einstellungen sind unvollständig.",
      SALESFORCE_NOT_CONFIGURED: "Die Salesforce-Verbindung ist nicht eingerichtet.",
      ORDER_NOT_FOUND: "Der Auftrag ist nicht mehr vorhanden.",
      NOT_READY_FOR_SHIPPING: "Der Auftrag muss versandbereit sein.",
      NO_LABEL_FOR_RECORD_TYPE: "Dieser Auftragstyp erhält kein Versandetikett.",
      COUNTRY_NOT_SUPPORTED: "Dieses Versandland wird nicht unterstützt.",
      ADDRESS_INCOMPLETE: "Vervollständigen Sie die Versandadresse am Auftrag.",
      SALESFORCE_LABEL_REQUESTED: "Salesforce hat bereits ein Etikett angefordert.",
      SALESFORCE_ALREADY_EXPORTED: "Am Auftrag ist bereits eine Salesforce-Exportmarkierung gesetzt.",
      SALESFORCE_FIELDS_UNAVAILABLE: "Erforderliche Salesforce-Felder konnten nicht gelesen werden.",
      SHIPPING_PLAN_CHANGED:
        "Versandadresse oder Etikettenplanung haben sich geändert. Prüfen Sie das vorhandene Etikett.",
      LABEL_NOT_PILOT: "Dieses Etikett gehört nicht zum eingerichteten Pilot.",
      TRACKING_CHANGED:
        "Salesforce enthält andere Sendungsnummern. Laden und prüfen Sie den Auftrag vor dem Fortfahren.",
      LABEL_CHANGED: "Das aktive Etikett hat sich geändert. Laden Sie es vor dem Stornieren erneut.",
      LABEL_NOT_FOUND: "Das gewählte Etikett ist nicht mehr vorhanden.",
    },
  },
  logisticsCommandStatus: {
    loadError: "Der Aktualisierungsstatus des Auftrags konnte nicht geladen werden.",
    refusalFallback: "Prüfen Sie den Auftrag vor einem erneuten Versuch.",
    states: {
      UPDATING: "Der Auftrag wird aus Salesforce aktualisiert…",
      SYNCED: "Der Auftrag wurde aus Salesforce aktualisiert.",
      REJECTED: "Salesforce hat die Änderung abgelehnt.",
      REFUSED: "Die Änderung wurde nicht ausgeführt.",
      UNKNOWN: "Das Ergebnis der Änderung ist unklar. Lassen Sie es vor einem erneuten Versuch prüfen.",
    },
    refusals: {
      PRECONDITION_CHANGED:
        "Der Auftrag hat sich in Salesforce geändert. Laden und prüfen Sie ihn vor einem erneuten Versuch erneut.",
      PILOT_DISABLED: "Der Logistikpilot ist ausgeschaltet.",
      PILOT_NOT_ALLOWED: "Sie nehmen nicht am Logistikpilot teil.",
      PERMISSION_DENIED: "Sie haben keine Berechtigung für diese Änderung.",
      NOT_PILOT: "Diese Änderung ist über den Logistikpilot nicht verfügbar.",
      NOT_CONFIGURED: "Die Salesforce-Verbindung ist nicht eingerichtet.",
      CONFIGURATION_CHANGED: "Die Salesforce-Verbindung hat sich geändert. Laden Sie den Auftrag erneut.",
      COMMAND_IN_PROGRESS:
        "Eine andere Änderung an diesem Auftrag oder seinen Datensätzen wird noch verarbeitet oder geprüft.",
      IDEMPOTENCY_CONFLICT:
        "Diese Anfrage wurde bereits für eine andere Änderung verwendet. Laden Sie den Auftrag erneut.",
      SALESFORCE_UNAVAILABLE:
        "Salesforce konnte nicht erreicht werden. Prüfen Sie den Auftrag vor einem erneuten Versuch.",
      INVALID_INPUT:
        "Die Änderung konnte nicht übermittelt werden. Laden Sie den Auftrag erneut und prüfen Sie Ihre Eingaben.",
    },
  },
  logistics: {
    section: "Logistik",
    overview: {
      title: "Übersicht",
      pageTitle: "Logistik",
      description: "Versandbereite Aufträge, Inventar und Rücksendungen einsehen.",
      shipping: {
        title: "Versandbereite Aufträge",
        description: "Aufträge und Lieferadressen für den Versand einsehen.",
        open: "Versandbereite Aufträge öffnen",
      },
      inventory: {
        title: "Inventar und Qualitätsprüfung",
        description: "Geräte finden und vorhandene Qualitätsprüfungen in den Inventardetails einsehen.",
        search: "IMEI oder Seriennummer",
        submit: "Inventar suchen",
        open: "Gesamtes Inventar öffnen",
      },
      returns: {
        title: "Rücksendung suchen",
        description:
          "Mit einem Kriterium suchen: Sendungsnummer, Absender-/Empfängername oder Accountname, Postleitzahl, IMEI oder Seriennummer.",
        search: "Suchkriterium für die Rücksendung",
        submit: "Auftrag suchen",
      },
    },
    workspaceOne: {
      title: "Workspace ONE",
      overview: {
        table: "Workspace-ONE-Geräte",
        loading: "Workspace-ONE-Geräte werden geladen",
        loadError: "Die Workspace-ONE-Geräte konnten nicht geladen werden.",
        empty: "Workspace ONE meldet keine Geräte.",
        total: "Workspace-ONE-Geräte insgesamt",
        unresolvedTitle: "Workspace ONE: Geräte ohne eindeutige Inventarzuordnung",
        unresolvedCount:
          "Provider-Datensätze ohne eindeutige Zuordnung: %{count} (gesamter Workspace-ONE-Bestand, unabhängig von den Inventarfiltern)",
        appPopulation: "App-gemeldete Geräte: installiert oder zugewiesen. Jedes Gerät zählt je App einmal.",
        syncedAt: "Zuletzt von Workspace ONE abgerufen: %{time}",
        imei: "IMEI",
        serialNumber: "Workspace-ONE-Seriennummer",
        organizationGroupName: "Organisationsgruppe",
        hardwareSerialNumber: "Inventar-Hardware-Seriennummer",
        noCustomer: "Kein eindeutig zugeordneter aktueller Kunde",
        noContradictions: "Keine Abweichung festgestellt",
        columns: {
          device: "Workspace-ONE-Gerät",
          facts: "Geräte- und App-Daten",
          inventory: "Inventareinheit",
          customer: "Aktueller Kunde",
          contradictions: "Abweichungen",
          console: "Konsole",
        },
        states: {
          NOT_CONFIGURED: "Die Workspace-ONE-Anbindung ist nicht konfiguriert.",
          UNAVAILABLE: "Workspace-ONE-Daten sind derzeit nicht verfügbar.",
        },
        matchStates: {
          UNLINKED: "Keine passende Inventareinheit gefunden",
          AMBIGUOUS: "Keine eindeutige Inventarzuordnung",
          NOT_CONFIGURED: "Anbindung nicht konfiguriert",
          UNAVAILABLE: "Zuordnung derzeit nicht verfügbar",
        },
        contradictions: {
          NO_INVENTORY: "Keine passende Inventareinheit",
          AMBIGUOUS: "Mehrdeutige IMEI-Zuordnung",
          CLOSED_PLACEMENT_ENROLLED:
            "Rücknahme oder Lagereingang im Verlauf erfasst, weiterhin in Workspace ONE registriert",
          MDM_REMOVED_ENROLLED: "Im Inventar als MDM entfernt markiert, weiterhin in Workspace ONE registriert",
        },
      },
      open: "In Workspace ONE öffnen",
      enrollment: "Workspace-ONE-Registrierung",
      lastSeenAt: "Letzte Meldung an Workspace ONE",
      compliance: "Compliance-Status",
      model: "Gerätemodell",
      operatingSystem: "Betriebssystem",
      syncedAt: "Zuletzt von Workspace ONE abgerufen",
      installedVersion: "Installierte Version",
      assignedVersion: "Zugewiesene Version",
      installedStatus: "Installationsstatus",
      assignmentStatus: "Zuweisungsstatus",
      lastReportedAt: "Letzte App-Meldung",
      noSupportedApps: "Keine Media4Care-App von Workspace ONE gemeldet.",
      unknown: "Unbekannt",
      enrolled: "Registriert",
      disenrolled: "Abgemeldet",
      apps: { senior: "Media4Care Senioren-App", caregiver: "Media4Care Betreuer-App", unknown: "Weitere App" },
      stale: "Die Workspace-ONE-Daten sind veraltet. Die letzte erfolgreiche Abfrage wird angezeigt.",
      states: {
        UNLINKED: "Kein Tablet mit dieser IMEI in Workspace ONE gefunden.",
        AMBIGUOUS:
          "Die IMEI passt zu mehreren Inventareinheiten oder Workspace-ONE-Geräten. Keine eindeutige Zuordnung möglich.",
        NOT_CONFIGURED: "Die Workspace-ONE-Anbindung ist nicht konfiguriert.",
        UNAVAILABLE: "Workspace-ONE-Daten sind derzeit nicht verfügbar.",
      },
    },
    hexnode: {
      title: "Hexnode",
      open: "In Hexnode öffnen",
      enrollment: "Hexnode-Registrierung",
      activity: "Hexnode-Aktivität",
      lastSeenAt: "Letzte Meldung an Hexnode",
      syncedAt: "Zuletzt von Hexnode abgerufen",
      unknown: "Unbekannt",
      enrolled: "Registriert",
      disenrolled: "Abgemeldet",
      active: "Aktiv",
      inactive: "Inaktiv",
      stale: "Die Hexnode-Daten sind veraltet. Die letzte erfolgreiche Abfrage wird angezeigt.",
      states: {
        UNLINKED: "Keine TV-Box mit dieser Seriennummer in Hexnode gefunden.",
        MISSING_SERIAL: "Ohne Seriennummer ist keine Zuordnung zu Hexnode möglich.",
        AMBIGUOUS: "Mehrere Hexnode-Geräte passen zur Seriennummer. Keine eindeutige Zuordnung möglich.",
        NOT_CONFIGURED: "Die Hexnode-Anbindung ist nicht konfiguriert.",
        UNAVAILABLE: "Hexnode-Daten sind derzeit nicht verfügbar.",
      },
    },
    inventory: {
      title: "Inventar",
      deviceFilters: {
        label: "Gerätefilter",
        days: "Ohne Kontakt seit",
        dayCount: "%{days} Tagen",
        options: {
          WORKSPACE_ONE: "MDM-Tablets",
          UNKNOWN_LAST_SEEN_MANAGED: "Letzter Kontakt unbekannt",
        },
        mdmHelp: "Eindeutig mit Workspace ONE verknüpfte Tablets.",
        activityHelp:
          "Registrierte Tablets/TV-Boxen und aktivierte SIMs ohne aktuelle Datensitzung. Unbekannter letzter Kontakt ist ein eigener Filter und gilt nicht als lange abwesend. SIM-Angaben stammen aus dem Cache.",
        providers: { WORKSPACE_ONE: "Workspace ONE", HEXNODE: "Hexnode", WHEREVERSIM: "WhereverSIM" },
        sourceStates: {
          NOT_CONFIGURED: "nicht konfiguriert",
          UNAVAILABLE: "nicht verfügbar",
          NOT_SCANNED: "noch nicht eingelesen",
        },
        incomplete: "%{provider}: %{state}. Die Filterergebnisse sind unvollständig.",
        stale:
          "%{provider}: veraltete Daten aus der letzten erfolgreichen Abfrage (%{time}). Die Filterergebnisse können unvollständig sein.",
        cachedSim:
          "WhereverSIM: Filterung anhand gespeicherter SIM-Daten. Letzter vollständiger Scan: %{time}. Dies ist keine Live-Abfrage.",
      },
      loading: "Das Inventar wird geladen",
      loadError: "Das Inventar konnte nicht geladen werden.",
      count: "%{total} Einheit |||| %{total} Einheiten",
      syncedAt: "Aus Salesforce kopiert: %{time}",
      notSynced: "Noch nicht aus Salesforce kopiert",
      searchLabel: "Inventar durchsuchen",
      searchPlaceholder: "Name, IMEI, Seriennummer, ICCID",
      type: "Typ",
      status: "Status",
      all: "Alle",
      noType: "Ohne Typ",
      noStatus: "Ohne Status",
      countsLabel: "Einheiten nach Typ und Status",
      sections: { stock: "Lagerbestand", status: "Nach Status" },
      showType: "%{type}: %{count} Einheit anzeigen |||| %{type}: alle %{count} Einheiten anzeigen",
      showStatus: "%{type}, %{status}: %{count} Einheit anzeigen |||| %{type}, %{status}: %{count} Einheiten anzeigen",
      stock: {
        free: "Frei",
        readyToShip: "versandbereit",
        needsStaging: "Staging nötig",
        inStockAtClient: "Im Lager, laut Verlauf beim Kunden",
        showFree: "%{type}, frei: %{count} Einheit anzeigen |||| %{type}, frei: %{count} Einheiten anzeigen",
        showReadyToShip:
          "%{type}, versandbereit: %{count} Einheit anzeigen |||| %{type}, versandbereit: %{count} Einheiten anzeigen",
        showNeedsStaging:
          "%{type}, Staging nötig: %{count} Einheit anzeigen |||| %{type}, Staging nötig: %{count} Einheiten anzeigen",
        showInStockAtClient:
          "%{type}, im Lager, laut Verlauf beim Kunden: %{count} Einheit anzeigen |||| %{type}, im Lager, laut Verlauf beim Kunden: %{count} Einheiten anzeigen",
      },
      clearFilters: "Filter entfernen",
      empty: "Keine Einheit passt zu Filter und Suche.",
      columns: {
        name: "Name",
        type: "Typ",
        status: "Status",
        identifier: "IMEI / Seriennummer / ICCID",
        providerStatus: "WhereverSIM-Status",
        lastOnline: "Zuletzt online",
        appVersion: "App-Version",
        qualityCheckDoneAt: "QC erledigt",
        lastInStockAt: "Zuletzt im Lager",
        hexnode: "Hexnode",
        workspaceOne: "Workspace ONE",
      },
      unnamed: "Ohne Namen",
    },
    item: {
      loading: "Die Einheit wird geladen",
      loadError: "Die Einheit konnte nicht geladen werden.",
      notFound: "Diese Einheit gibt es im Inventar nicht.",
      backToList: "Zum Inventar",
      openInSalesforce: "In Salesforce öffnen",
      modifiedAt: "Zuletzt in Salesforce geändert: %{time}",
      deletedInSalesforce:
        "Diese Einheit wurde am %{time} in Salesforce gelöscht. Das Inventar zeigt sie mit ihrem Verlauf weiter an, zählt sie aber nicht mehr zum Bestand.",
      yes: "Ja",
      no: "Nein",
      sections: {
        location: "Wo ist es jetzt?",
        unit: "Einheit",
        qualityCheck: "Staging-Qualitätscheck",
        history: "Verlauf",
        whereverSim: "WhereverSIM",
        whereverSimLive: "WhereverSIM live",
      },
      fields: {
        type: "Typ",
        status: "Status",
        identifier: "IMEI / Seriennummer / ICCID",
        inactiveReason: "Grund für Inaktiv",
        inactiveDate: "Inaktiv seit",
        imei: "IMEI",
        serialNumber: "Seriennummer",
        hardwareSerialNumber: "Hardware-Seriennummer",
        simIccid: "ICCID",
        newDevice: "Neugerät",
        lastInStockAt: "Zuletzt im Lager",
        lastInTransferAt: "Zuletzt im Transfer",
        createdAt: "Angelegt",
        appVersion: "App-Version",
        appFlavour: "App-Flavour",
        contentVersion: "Content-Version",
      },
      qualityCheck: {
        doneAt: "Erledigt am",
        doneBy: "Erledigt von",
        sticker: "Aufkleber",
        mdmRemoved: "MDM entfernt",
        knoxRemoved: "Knox entfernt",
        noOpenAndroidUpdates: "Keine offenen Android-Updates",
        unknownSourcesAllowed: "Download über unbekannte Quellen zugelassen",
        accessPointConfigured: "Zugangspunkt konfiguriert",
        roamingActive: "Roaming aktiv",
        screenTimeout30Min: "Bildschirm-Timeout 30 Minuten",
        appAsStartApp: "App als Start-App",
        cameraInAppAllowed: "Kamera in der App zugelassen",
      },
      location: {
        notAssigned: "Im Lager / nicht zugeordnet",
        notAssignedHint: "Laut Verlauf ist die Einheit bei keinem Kunden.",
        account: "Account",
        contract: "Vertrag",
        contractItem: "Vertragsposition",
        atClientDate: "Beim Kunden seit",
        asset: "Asset",
        noAsset: "Kein Asset dieses Accounts nennt die Einheit.",
        slot: {
          TABLET: "als Tablet",
          SIM: "als SIM",
          HARDWARE: "als Hardware",
        },
        unnamedAsset: "Asset ohne Namen",
        order: "Letzter Auftrag",
        noOrder: "Kein Auftrag nennt dieses Asset.",
        recordType: "Auftragstyp",
        orderStatus: "Auftragsstatus",
        shippingDate: "Versand",
        completedDate: "Abgeschlossen",
      },
      history: {
        empty: "Kein Verlauf.",
        columns: {
          account: "Account",
          contract: "Vertrag",
          contractItem: "Vertragsposition",
          shippingDate: "Versand",
          atClientDate: "Beim Kunden",
          removedFromClientDate: "Vom Kunden entfernt",
          inStockDate: "Wieder im Lager",
          endUserChange: "Endnutzerwechsel",
        },
      },
    },
    sim: {
      notListed: "Nicht bei WhereverSIM",
      notScanned: "Noch nicht von WhereverSIM gelesen",
      notChecked: "Noch nicht geprüft",
      onlineNow: "Jetzt online",
      lastOnlineUnknown: "Unbekannt",
      fields: {
        status: "Status",
        connectivity: "Verbindung",
        lastOnline: "Zuletzt online",
        scannedAt: "SIM-Liste gelesen",
        checkedAt: "Verbindung geprüft",
      },
      live: {
        loading: "WhereverSIM wird abgefragt",
        loadError: "Konnte nicht geladen werden (%{code})",
        notConfigured: "WhereverSIM ist nicht verbunden.",
        sim: "SIM",
        endpoint: "Gerät",
        connectivity: "Verbindung",
        noDevice: "Kein Gerät zugeordnet",
      },
    },
  },
  salutation: {
    missus: "Frau",
    mister: "Herr",
    others: "Sonstige",
  },
  practitionerStatus: {
    ACTIVE: "Aktiv",
    INACTIVE: "Inaktiv",
  },
  practitionerRole: "Rolle",
  practitionerRoles: {
    regular: "Mitarbeiter",
    pdl: "Pflegedienstleitung (PDL)",
    wbl: "Wohnbereichsleitung (WBL)",
    pflegefachkraft: "Pflegefachkraft",
    pflegehilfskraft: "Pflegehilfskraft",
    betreuungskraft: "Betreuungskraft",
    auszubildende: "Auszubildende",
    verwaltung: "Verwaltung",
    hauswirtschaft: "Hauswirtschaft",
    haustechnik: "Haustechnik",
    other: "Sonstige",
    admin: "Administrator",
  },
  accessStatus: {
    ACTIVE: "Aktiv",
    BLOCKED: "Gesperrt",
    OTP_PENDING: "Einmal-Passwort ausstehend",
    NO_ACCESS: "Kein Zugang",
    DEACTIVATED: "Deaktiviert",
    filterLabel: "Zugangsstatus",
  },
  deviceStatus: {
    ALL: "Alle",
    ACTIVE: "Aktiv",
    INACTIVE: "Inaktiv",
  },
  facilities: "Haus",
  residents: "Mitbewohner",
  devices: "Geräte",
  start: "Start",
  breadcrumb: "Navigationspfad",
  breadcrumbExpand: "Gesamten Navigationspfad anzeigen",
  standort: "Standort",
  standortAll: "Alle",
  standortCreate: "Standort anlegen",
  integration: {
    title: "Integrations-Einstellungen",
    description:
      "Die Verbindung zum Dokumentationssystem gilt für die ausgewählte Organisation und wird von ihren Managern gemeinsam verwaltet.",
    loading: "Lade Integrations-Einstellungen...",
    form: {
      provider: "Integrations-Anbieter",
      secretSaved: "Zugangsdaten gespeichert",
      keepSecret: "Leer lassen, um das gespeicherte Geheimnis beizubehalten. Nur zum Ändern neu eingeben.",
      senso: {
        url: "Senso API URL",
        urlHelper: "Die Basis-URL für Ihre Senso API-Instanz",
        urlPlaceholder: "https://api.senso.example.com",
        clientId: "Client-ID",
        clientIdHelper: "Ihre Senso API Client-Kennung",
        clientSecret: "Client-Secret",
        clientSecretHelper: "Ihr Senso API Client-Secret (wird verschlüsselt)",
      },
      vivendi: {
        url: "Vivendi API URL",
        urlHelper: "Die Basis-URL für Ihre Vivendi API-Instanz",
        urlPlaceholder: "https://vivendi.example.com",
        clientId: "Client-ID",
        clientIdHelper: "Ihre Vivendi API Client-Kennung",
        clientSecret: "Client-Secret",
        clientSecretHelper: "Ihr Vivendi API Client-Secret (wird verschlüsselt)",
      },
      medifoxDan: {
        url: "MedifoxDan Orbit API URL",
        urlHelper: "Die Basis-URL der MedifoxDan Orbit API",
        urlPlaceholder: "https://prd.orbit.medifoxdan.de",
        clientId: "Tenant-ID",
        clientIdHelper: "Ihre MedifoxDan Tenant-ID",
        clientSecret: "Tenant-Key",
        clientSecretHelper: "Ihr MedifoxDan Tenant-Key (wird verschlüsselt)",
      },
    },
    validation: {
      invalidStructure: "Ungültige Anmeldedatenstruktur für %{provider}",
      allFieldsRequired: "Alle Felder sind erforderlich",
      invalidUrl: "Bitte geben Sie eine gültige URL ein",
    },
    status: {
      pending: "Ausstehend",
      running: "Läuft",
      completed: "Abgeschlossen",
      failed: "Fehlgeschlagen",
      cancelled: "Abgebrochen",
    },
    result: {
      success: "Erfolgreich",
      warning: "Warnung",
      error: "Fehler",
    },
    success: {
      saved: "Integrations-Einstellungen erfolgreich gespeichert",
      connectionTest: "Verbindungstest erfolgreich",
      synced: "Synchronisierung erfolgreich gestartet",
      syncStarted: "Synchronisierung erfolgreich gestartet",
      completed: "Synchronisierung abgeschlossen%{details}",
      cancelled: "Synchronisierung abgebrochen",
      statusRefreshed: "Status aktualisiert: %{status}",
    },
    error: {
      saving: "Fehler beim Speichern der Integrations-Einstellungen",
      connectionTest: "Verbindungstest fehlgeschlagen",
      invalidStructure: "Ungültige Anmeldedatenstruktur",
      loading: "Fehler beim Laden der Integrations-Einstellungen",
      syncing: "Fehler beim Synchronisieren der Daten",
      failed: "Synchronisierung fehlgeschlagen",
      noOrganizationSelected: "Bitte wählen Sie eine Organisation aus",
      pollingFailed: "Fehler beim Abrufen des Synchronisations-Status",
      refreshFailed: "Fehler beim Aktualisieren des Status",
    },
    button: {
      saving: "Speichern...",
      save: "%{provider}-Einstellungen speichern",
      testing: "Testen...",
      test: "%{provider}-Verbindung testen",
      syncing: "Synchronisiert...",
      sync: "Synchronisierung starten",
      queued: "In der Warteschlange",
      starting: "Startet...",
      notResponding: "Antwortet nicht",
      refresh: "Status aktualisieren",
    },
    connectionTest: {
      saveFirst: "Speichern Sie die Änderungen, um die Verbindung zu testen.",
      success:
        "Verbindung erfolgreich: %{smart_count} Haus gelesen (%{seconds} s). |||| Verbindung erfolgreich: %{smart_count} Häuser gelesen (%{seconds} s).",
      failed: "Verbindung fehlgeschlagen %{stage}: %{reason}",
      stage: {
        token: "bei der Anmeldung",
        read: "beim Lesen der Daten",
      },
      reason: {
        not_configured: "Es sind keine vollständigen Zugangsdaten gespeichert.",
        unsupported: "Für diesen Anbieter gibt es noch keinen Verbindungstest.",
        timeout: "Der Server hat nicht rechtzeitig geantwortet. Häufig blockiert eine Firewall unsere IP-Adresse.",
        unreachable: "Der Server ist nicht erreichbar (Adresse unbekannt oder Verbindung abgelehnt).",
        tls: "Das TLS-Zertifikat des Servers ist ungültig oder passt nicht zur Adresse.",
        credentials: "Die Zugangsdaten wurden abgelehnt (HTTP %{status}).",
        http_error: "Der Server hat mit HTTP %{status} geantwortet.",
        invalid_response: "Der Server hat eine unerwartete Antwort geliefert.",
        unknown: "Unbekannter Fehler.",
      },
    },
    preview: {
      title: "Import-Vorschau",
      description:
        "Zeigt, was der nächste Import aus SENSO anlegen oder ändern würde. Dabei werden keine Daten geschrieben.",
      saveFirst: "Speichern Sie die Änderungen, um eine Vorschau zu erstellen.",
      loading: "Lade Vorschau...",
      empty: "Noch keine Vorschau vorhanden. Erstellen Sie eine Vorschau, um die Änderungen vor dem Import zu prüfen.",
      running: "Die Vorschau wird erstellt. Das kann einen Moment dauern.",
      createdAt: "Erstellt am %{date}",
      expiresAt: "gültig bis %{date}",
      procedureCount: "%{smart_count} Maßnahme gelesen |||| %{smart_count} Maßnahmen gelesen",
      importNotice: "Der Import liest SENSO erneut; das Ergebnis kann von dieser Vorschau abweichen.",
      warnings: "Warnungen",
      failures: "Fehler",
      issueReference: "%{entity} %{reference}",
      button: {
        create: "Vorschau erstellen",
        creating: "Vorschau wird erstellt...",
        import: "Jetzt importieren",
      },
      error: {
        loading: "Die Vorschau konnte nicht geladen werden",
        request: "Die Vorschau konnte nicht erstellt werden",
        failed: "Die Vorschau konnte nicht erstellt werden. Bitte versuchen Sie es erneut.",
        cancelled: "Die Vorschau wurde abgebrochen. Bitte erstellen Sie sie erneut.",
        reason: "Grund: %{reason}",
      },
      requests: {
        title: "Abrufe bei SENSO",
        unknownPath: "(Pfad unbekannt)",
        http: "HTTP %{status}",
        httpWithCodes: "HTTP %{status} (%{codes})",
        records: "%{smart_count} Datensatz |||| %{smart_count} Datensätze",
        duration: "%{seconds} s",
        timeout: "Zeitüberschreitung",
        networkError: "Netzwerkfehler (%{code})",
        failed: "Anfrage fehlgeschlagen",
      },
      rawData: {
        button: "Rohdaten",
        title: "Rohdaten von SENSO: %{endpoint}",
        description:
          "Ruft die Antwort von SENSO jetzt live ab und zeigt sie unverändert. Die Daten werden nicht gespeichert und verschwinden beim Schließen.",
        haus: "Haus",
        bewohner: "Bewohner",
        noHaus: "Ohne Haus",
        noOptions:
          "Die gespeicherte Vorschau enthält keine passenden Einträge. Erstellen Sie zuerst eine Vorschau, um die Parameter auszuwählen.",
        load: "Laden",
        loading: "Rohdaten werden geladen...",
        failed: "Die Rohdaten konnten nicht geladen werden.",
        request: "Anfrage",
        query: "Parameter",
        headers: "Header",
        response: "Antwort",
        status: "HTTP %{status}",
        noBody: "Die Antwort enthält keinen Inhalt.",
        bodyBase64: "Kein gültiger Text im angegebenen Zeichensatz; als Base64 angezeigt.",
        truncated: "Gekürzt, insgesamt %{bytes} Byte",
        error: {
          not_configured: "Es sind keine vollständigen Zugangsdaten gespeichert.",
          unsupported: "Für diesen Anbieter gibt es keine Rohdaten.",
          credentials: "Die Zugangsdaten wurden abgelehnt.",
          timeout: "Der Server hat nicht rechtzeitig geantwortet.",
          unreachable: "Der Server ist nicht erreichbar (Adresse unbekannt oder Verbindung abgelehnt).",
          tls: "Das TLS-Zertifikat des Servers ist ungültig oder passt nicht zur Adresse.",
          http_error: "Der Server hat mit einem Fehler geantwortet.",
          invalid_response: "Der Server hat eine unerwartete Antwort geliefert.",
          too_large: "Die Antwort ist zu groß, um sie anzuzeigen.",
          unknown: "Unbekannter Fehler.",
        },
      },
      totals: {
        title: "Übersicht",
        locations: "Häuser/Standorte",
        patients: "Bewohner",
        practitioners: "Mitarbeiter",
      },
      change: {
        new: "Neu",
        changed: "Geändert",
        unchanged: "Unverändert",
        failed: "Fehlgeschlagen",
      },
      tree: {
        title: "Struktur",
        empty: "Keine Standorte in der Vorschau.",
        residents: "%{smart_count} Bewohner",
        unassigned: "Ohne Zimmerzuordnung: %{smart_count} Bewohner",
        unassignedHint: "Neue Bewohner kommen in die Einrichtung; bestehende behalten ihren bisherigen Platz.",
      },
      locationType: {
        ORGANIZATION: "Einrichtung",
        SITE: "Haus",
        DEPARTMENT: "Bereich",
        WARD: "Wohnbereich",
        ROOM: "Zimmer",
        BED: "Bett",
      },
      entity: {
        location: "Standort",
        patient: "Bewohner",
        practitioner: "Mitarbeiter",
        procedure: "Maßnahme",
      },
      reason: {
        missingPatientName: "Der Name des Bewohners fehlt.",
        invalidBirthDate: "Das Geburtsdatum ist ungültig.",
        noRootLocation: "Die Einrichtung hat keinen obersten Standort.",
      },
    },
    execution: {
      title: "Synchronisierungs-Vorgänge",
      loading: "Lädt...",
      empty: "Keine Synchronisierungs-Vorgänge gefunden",
      active: "Aktiv",
      notResponding: "Antwortet nicht",
      table: {
        status: "Status",
        result: "Ergebnis",
        provider: "Anbieter",
        started: "Gestartet",
        duration: "Dauer",
        actions: "Aktionen",
      },
      details: {
        title: "Synchronisierungs-Details",
        id: "Ausführungs-ID",
        provider: "Anbieter",
        started: "Gestartet",
        completed: "Abgeschlossen",
        duration: "Dauer",
        jobId: "Job-ID",
        summary: "Zusammenfassung",
        error: "Fehlerdetails",
        processed: "Erfolgreich verarbeitet",
        warnings: "Warnungen",
        failed: "Fehlgeschlagene Entitäten",
        noEntitiesProcessed: "Keine Entitäten wurden verarbeitet",
        systemErrors: "Systemfehler",
        failedEntities: "Fehlgeschlagene Entitäten",
      },
      entityTypes: {
        patients: "Patienten",
        practitioners: "Mitarbeiter",
        locations: "Standorte",
        procedures: "Maßnahmen",
        massnahmen: "Maßnahmen",
      },
    },
  },
  salutationLabel: "Anrede",
  firstName: "Vorname",
  lastName: "Nachname",
  genderLabel: "Geschlecht",
  birthDate: "Geburtsdatum",
  patientId: "Bewohner-ID",
  email: "E-Mail-Adresse",
  organization: "Einrichtung",
  location: "Wohnbereich",
  patient: {
    locationNotAssigned: "Keinem Wohnbereich zugewiesen",
  },
  practitionerLocationScope: {
    label: "Standortzugriff",
    all: "Alle Wohnbereiche",
    selected: "Ausgewählte Wohnbereiche",
    required: "Bitte wählen Sie einen Standortzugriff aus.",
    selectedRequired: "Bitte wählen Sie mindestens einen Wohnbereich aus.",
  },
  noLocations: "Keine Standorte",
  telephone: "Telefonnummer",
  status: "Status",
  avatar: "Avatar",
  tabletName: "Tablet-Name",
  deviceName: "Gerätename",
  deviceId: "Geräte-ID",
  manufacturer: "Hersteller",
  model: "Modell",
  manufacturerModel: "Hersteller / Modell",
  osVersion: "OS-Version",
  appVersion: "Software-Version",
  contentVersion: "Inhalts-Version",
  locationName: "Wohnbereichsname",
  wardLabel: "Wohnbereich",
  roomLabel: "Zimmer",
  bedLabel: "Bett",
  type: "Typ",
  mode: "Modus",
  externalId: "External ID",
  internalId: "Internal ID",
  organizationName: "Einrichtungsname",
  street: "Straße",
  postalCode: "PLZ",
  city: "Ort",
  additionalInfo: "Zusatzinfos",
  featureActivityKind: {
    VIDEOCHAT: "Videoanruf",
    CHAT: "Chat",
    CONVERSATION_GUIDE: "Gesprächsleitfaden",
    ASSESSMENT: "Einschätzung",
    QUESTIONNAIRE: "Biografiebogen",
    PHOTO_ALBUM: "Fotoalbum",
    ANNUAL_HISTORY: "Tägliche Schatzkiste",
    HOROSCOPE: "Horoskop",
    ENDLESS_QUIZ: "Endlos-Quiz",
  },
  subActivities: {
    quiz: "Wissensquiz",
    language: "Sprache & Wörter",
    "numbers-and-counting": "Zahlen & Rechnen",
    "music-and-sounds": "Musik & Klänge",
    "memory-games": "Merkspiele",
    "handicraft-and-creativity": "Basteln & Kreativität",
    walk: "Spaziergang",
    "staircase-training": "Treppentraining",
    "seated-gymnastics": "(Sitz)gymnastik",
    "hand-gymnastics": "Handgymnastik",
    "fall-prevention": "Sturzprophylaxe",
    "movement-games": "Bewegungsspiele",
    "telephone-call": "Telefonat",
    visit: "Besuch",
    "group-participation": "Gruppenteilnahme",
    "event-visit": "Eventbesuch",
    "roommate-meeting": "Mitbewohnertreffen",
    chat: "Chat",
    videochat: "Videoanruf",
    "relaxation-exercise": "Entspannungsübung",
    snoezelen: "Snoezelen",
    "relieving-talk": "Entlastendes Gespräch",
    hobby: "Hobby & Kreativität",
    "basal-stimulation": "Basale Stimulation",
    wellness: "Wellness & Beauty",
    conversation_guide: "Gesprächsleitfaden",
    photo_album: "Fotoalbum",
    annual_history: "Tägliche Schatzkiste",
    horoscope: "Horoskop",
    endless_quiz: "Endlos-Quiz",
    assessment: "Einschätzung",
    questionnaire: "Biografiebogen",
    OTHER: "Andere",
  },
  activityList: {
    title: "Aktivitätenverlauf",
    noDataAvailable: "Keine Daten verfügbar",
    noActivitiesPatient: "Der Klient hat noch keine Aktivitäten durchgeführt",
    noActivitiesPractitioner: "Der Praktiker hat keine Aktivitäten",
    participants: "Teilnehmer",
    content: "Inhalt",
    type: "Art",
    duration: "Dauer (Min.)",
    dateTime: "Datum & Zeit",
    note: "Notiz",
    documentation: "Dokumentation",
  },
  sessionDocumentation: {
    title: "Dokumentation zur Aktivität",
    open: "Dokumentation öffnen",
    documented: "Dokumentiert",
    notDocumented: "Noch nicht dokumentiert",
    aiSummary: "KI-Zusammenfassung",
    note: "Notiz",
    aiNote: "Verhaltensabweichung",
    generating: "KI-Zusammenfassung wird erstellt …",
    failed: "Die KI-Zusammenfassung konnte nicht erstellt werden.",
    emptyAiSummary: "Noch keine KI-Zusammenfassung erstellt.",
    emptyNote: "Keine Notiz geschrieben.",
    emptyAiNote: "Keine Verhaltensabweichung dokumentiert.",
    preview: "Vorschau",
    empty: "Für diese Aktivität wurde noch nichts dokumentiert.",
    copy: "Kopieren",
    copyAll: "Alles kopieren",
    copySuccess: "In die Zwischenablage kopiert",
    syncTitle: "Übertragung an die Pflegedokumentation",
  },
  documentationSync: {
    status: {
      sent: "Übertragen",
      pending: "Ausstehend",
      failed: "Fehlgeschlagen",
      skipped: "Nicht übertragen",
    },
    pendingDetail: "Wird an die Pflegedokumentation übertragen",
    failedDetail: "%{error} (%{date}, ein Versuch) |||| %{error} (%{date}, %{smart_count} Versuche)",
    unknownError: "Unbekannter Fehler",
    error: {
      credentialsNotConfigured:
        "Für diese Organisation ist keine passende Anbindung an die Pflegedokumentation eingerichtet. Bitte die Integrations-Einstellungen prüfen.",
      requiredDataNotFound:
        "Für die Übertragung benötigte Daten oder Einstellungen wurden nicht gefunden. Bitte den Support kontaktieren.",
    },
    skipReason: {
      notIntegrated: "Bewohner ist mit keiner Pflegedokumentation verbunden",
      missingResidentExternalId: "Bewohner hat keine Kennung in der Pflegedokumentation",
      missingAuthorExternalId: "Verfasser hat keine Kennung in der Pflegedokumentation",
      noContent: "Keine Dokumentation vorhanden",
    },
  },
  activityGoals: {
    editButton: "Ziele bearbeiten",
    editTitle: "Aktivitätsziele bearbeiten",
    error: "Fehler beim Speichern der Aktivitätsziele",
    loadError: "Aktivitätsziele konnten nicht geladen werden",
    loading: "Aktivitätsziele werden geladen...",
    minutes: "%{minutes} Min",
    minutesPerWeek: "Minuten pro Woche",
    noDataAvailable: "Keine Daten verfügbar",
    saving: "Speichern...",
    success: "Aktivitätsziele erfolgreich gespeichert",
    title: "Aktivitätsziele",
    decreaseGoal: "Ziel für %{kind} verringern",
    increaseGoal: "Ziel für %{kind} erhöhen",
    kind: {
      COGNITIVE: "Kognitiv",
      PHYSICAL: "Körperlich",
      SOCIAL_AND_COMMUNICATIVE: "Sozial & kommunikativ",
      MENTAL_WELLBEING: "Mentales Wohlbefinden",
    },
    subtitle: "Wochenziele pro Kategorie · aktueller Fortschritt",
    progress: {
      outOf: "/ %{target} Min",
      perWeek: "%{done}/%{target} Min/Woche",
      percent: "%{percent}%",
      ariaLabel: "%{kind}: %{done} von %{target} Minuten",
    },
    recommendations: {
      title: "Empfohlene Aktivitäten",
      subtitle: "Vorschläge pro Kategorie – akzeptieren & als Maßnahme einplanen.",
      loading: "Vorschläge werden geladen...",
      empty: "Keine Vorschläge verfügbar",
      emptyHint: "Für diese Kategorie liegen aktuell keine Empfehlungen vor.",
      loadError: "Vorschläge konnten nicht geladen werden",
      regenerate: "Neue Vorschläge",
      plan: "Planen",
      details: "Details",
      duration: "%{minutes} Min",
      planned: "Geplant",
    },
    plan: {
      title: "Aktivität planen",
      existingProcedure: "Zu bestehender Maßnahme hinzufügen",
      newProcedure: "Neue Maßnahme anlegen",
      procedureLabel: "Maßnahme",
      noProcedures: "Keine bestehenden Maßnahmen",
      proceduresLoadError:
        "Bestehende Maßnahmen konnten nicht geladen werden. Sie können weiterhin eine neue Maßnahme anlegen.",
      untitledProcedure: "Maßnahme ohne Titel",
      newTitleLabel: "Titel der Maßnahme",
      plannedStartLabel: "Datum und Uhrzeit",
      save: "Planen",
      cancel: "Abbrechen",
      saving: "Wird geplant...",
      success: "Aktivität erfolgreich geplant",
      error: "Aktivität konnte nicht geplant werden",
    },
  },
  notesList: {
    title: "Notizen",
    noDataAvailable: "Keine Daten verfügbar",
    noNotes: "Der Praktiker hat keine Notizen",
    date: "Datum",
    time: "Zeit",
    note: "Notiz",
  },
  noteModal: {
    title: "Notiz von %{author}, %{date}, %{time}",
    close: "Schließen",
  },
  documentationModal: {
    title: "Dokumentation",
  },
  workerNumber: "Mitarbeiternummer",
  motherTongue: "Muttersprache",
  locations: "Wohnbereiche",
  patientNumber: "Bewohner-ID",
  parentLocation: "Übergeordneter Standort",
  enterExternalId: "Externe ID eingeben",
  sitesCannotHaveParent: "Standorte können keinen übergeordneten Standort haben",
  canOnlyBelongToTypes: "Kann nur zu folgenden Standorttypen gehören:",
  locationTypeImmutable: "Typ kann nach Erstellung nicht geändert werden",
  tabs: {
    information: "Informationen",
    procedures: "Maßnahmen",
    activityGoals: "Aktivitätsziele",
    activityHistory: "Aktivitätenverlauf",
    passwordManagement: "Passwort verwalten",
    residents: "Klienten",
    employees: "Mitarbeiter",
    devices: "Geräte",
    locations: "Wohnbereiche",
    notes: "Notizen",
    learningProgress: "E-Learning-Fortschritt",
  },
  passwordManagement: {
    titleCreate: "Passwort erstellen",
    titleReset: "Passwort zurücksetzen",
    titleBlocked: "PIN gesperrt",
    descriptionCreate:
      '%{name} hat derzeit keinen gültigen Zugang zum System. Ein bisheriges Passwort oder ein abgelaufenes Einmal-Passwort kann nicht verwendet werden. Senden Sie ein neues Einmal-Passwort, damit %{name} ein neues Passwort festlegen kann. Wählen Sie unten, an wen das Einmal-Passwort per E-Mail gesendet werden soll, und klicken Sie auf "Einmal-Passwort senden".',
    descriptionReset:
      'Hier können Sie das Passwort von %{name} zurücksetzen. Sobald das Einmal-Passwort erfolgreich gesendet wurde, ist das bisherige Passwort sofort ungültig. %{name} meldet sich mit dem Einmal-Passwort an und legt dabei ein neues Passwort fest. Wählen Sie unten, an wen das Einmal-Passwort gesendet werden soll, und klicken Sie auf "Einmal-Passwort senden".',
    descriptionBlocked:
      "Die PIN von %{name} wurde nach mehreren fehlgeschlagenen Eingaben gesperrt. Wenn Sie ein Einmal-Passwort senden, ist die zuvor gesperrte PIN nicht mehr verwendbar. %{name} kann damit eine neue PIN festlegen und den Zugang wiederherstellen.",
    titleOtpPending: "Einmal-Passwort ausstehend",
    descriptionOtpPending:
      "%{name} hat derzeit keinen gültigen Zugang. Ein Einmal-Passwort wurde bereits generiert und ist gültig bis %{date}. Ein bisheriges Passwort ist nicht mehr gültig. Mit dem bestehenden Einmal-Passwort kann %{name} eine neue PIN festlegen.",
    sendButton: "Einmal-Passwort senden",
    admin: "Admin (ich)",
    passwordLabel: "Passwort:",
    maskedOtp: "••••••",
    otpLabel: "Einmal-Passwort",
    revealButton: "Einmal-Passwort anzeigen",
    hideButton: "Einmal-Passwort verbergen",
    copyButton: "Einmal-Passwort kopieren",
    revealDialogTitle: "Einmal-Passwort anzeigen",
    revealPasswordLabel: "Eigenes Passwort",
    revealConfirmButton: "Einmal-Passwort anzeigen",
    revealError: "Einmal-Passwort konnte nicht angezeigt werden",
    copySuccess: "Passwort wurde in die Zwischenablage kopiert",
    resetSuccess: "Passwort-Zurücksetzung wurde gestartet – das bisherige Passwort ist jetzt ungültig",
    resetError: "Fehler beim Zurücksetzen des Passworts",
    noEmailWarning: "Keine Mitarbeiter-Email-Adresse vorhanden",
    noEmailHint:
      "Für %{name} ist keine E-Mail-Adresse hinterlegt. Das Einmal-Passwort kann nur an Sie gesendet werden – geben Sie es anschließend persönlich weiter.",
    statusLabel: "Zugangsstatus",
    otpValidUntil: "Einmal-Passwort gültig bis %{date}",
    resetPendingHint: "Eine Passwort-Zurücksetzung ist ausstehend – das Einmal-Passwort ist gültig bis %{date}.",
    deactivatedHint:
      "Das Profil ist deaktiviert und hat keinen Zugang zum System. Aktivieren Sie das Profil, um den Zugang wieder zu verwalten.",
  },
  bulkOtp: {
    button: "Einmal-Passwörter generieren",
    confirmTitle: "Einmal-Passwörter generieren",
    confirmContent:
      "Für %{smart_count} ausgewählten Mitarbeiter wird ein neues Einmal-Passwort generiert. Der bestehende Passwort- oder PIN-Zugang wird sofort ungültig; der Mitarbeiter muss das neue Einmal-Passwort verwenden, um ein neues Passwort oder eine neue PIN festzulegen. Ein eventuell bestehendes Einmal-Passwort wird dabei ersetzt. Mitarbeiter mit hinterlegter E-Mail-Adresse erhalten es zusätzlich per E-Mail. Ohne E-Mail-Adresse kann es im Profil nach Bestätigung Ihres eigenen Passworts angezeigt und persönlich weitergegeben werden. |||| Für %{smart_count} ausgewählte Mitarbeiter wird je ein neues Einmal-Passwort generiert. Die bestehenden Passwort- oder PIN-Zugänge werden sofort ungültig; die Mitarbeiter müssen jeweils das neue Einmal-Passwort verwenden, um ein neues Passwort oder eine neue PIN festzulegen. Eventuell bestehende Einmal-Passwörter werden dabei ersetzt. Mitarbeiter mit hinterlegter E-Mail-Adresse erhalten es zusätzlich per E-Mail. Ohne E-Mail-Adresse kann es im Profil nach Bestätigung Ihres eigenen Passworts angezeigt und persönlich weitergegeben werden.",
    skippedDeactivated: "Profil deaktiviert – übersprungen",
    progress: "Einmal-Passwörter werden generiert… (%{done}/%{total})",
    resultsTitle: "Einmal-Passwörter generiert",
    resultsHint:
      "Einmal-Passwörter werden aus Sicherheitsgründen nicht direkt angezeigt. Öffnen Sie das Profil eines Mitarbeiters und bestätigen Sie unter Passwort verwalten Ihr eigenes Passwort, um das Einmal-Passwort anzuzeigen.",
    colName: "Mitarbeiter",
    colNote: "Hinweis",
    emailed: "Per E-Mail versendet",
    noEmail: "Keine E-Mail – im Profil nach Passwortbestätigung anzeigen",
    failed: "Fehler bei der Generierung",
    close: "Schließen",
  },
  procedureList: {
    title: "Maßnahmen",
    noDataAvailable: "Keine Daten verfügbar",
    noProcedures: "Keine Maßnahmen gefunden",
  },
  create: {
    practitioner: {
      title: "Pfleger hinzufügen",
      success: "Mitarbeiter erfolgreich erstellt",
      noEmailWarning:
        "Für diesen Mitarbeiter ist keine E-Mail-Adresse hinterlegt. Das Einmal-Passwort muss persönlich übergeben werden und ist unter Passwort verwalten verfügbar.",
      error: "Fehler beim Erstellen des Mitarbeiters",
    },
    patient: {
      title: "Bewohner hinzufügen",
      success: "Bewohner erfolgreich erstellt",
      error: "Fehler beim Erstellen des Bewohners",
    },
    location: {
      title: "Wohnbereich hinzufügen",
      success: "Wohnbereich erfolgreich erstellt",
      error: "Fehler beim Erstellen des Wohnbereichs",
    },
    organization: {
      title: "Einrichtung hinzufügen",
      success: "Einrichtung erfolgreich erstellt",
      error: "Fehler beim Erstellen der Einrichtung",
    },
    noOrganizationSelected: "Keine Einrichtung ausgewählt. Bitte wählen Sie eine Einrichtung aus.",
  },
  edit: {
    practitioner: {
      title: "Pfleger bearbeiten",
      success: "Mitarbeiter erfolgreich bearbeitet",
      error: "Fehler beim Bearbeiten des Mitarbeiters",
    },
    patient: {
      title: "Bewohner bearbeiten",
      success: "Bewohner erfolgreich bearbeitet",
      error: "Fehler beim Bearbeiten des Bewohners",
    },
    location: {
      title: "Wohnbereich bearbeiten",
      success: "Wohnbereich erfolgreich bearbeitet",
      error: "Fehler beim Bearbeiten des Wohnbereichs",
    },
  },
  emptyList: {
    device: {
      description: "Es sind noch keine Geräte registriert.",
    },
    location: {
      description: "Sie haben noch keine Wohnbereiche hinzugefügt.",
      createButton: "Wohnbereich hinzufügen",
    },
    locationSites: {
      description: "Sie haben noch keine Standorte hinzugefügt.",
      createButton: "Standort hinzufügen",
    },
    patient: {
      description: "Sie haben noch keine Bewohner hinzugefügt.",
      createButton: "Bewohner hinzufügen",
    },
    practitioner: {
      description: "Sie haben noch keine Mitarbeiter hinzugefügt.",
      createButton: "Mitarbeiter hinzufügen",
    },
    procedure: {
      description: "Sie haben noch keine Maßnahmen hinzugefügt.",
      createButton: "Maßnahme hinzufügen",
    },
  },
  testAccount: {
    title: "Testkunden anlegen",
    hint: "Legt auf dieser Umgebung einen B2B-Testaccount mit dieser Person als Lizenzmanager an. Auf seiner Seite laden Sie sie dann ein.",
    email: "E-Mail-Adresse des Lizenzmanagers",
    organizationName: "Name der Einrichtung",
    managerName: "Name des Lizenzmanagers",
    create: "Anlegen",
    cancel: "Abbrechen",
    success: "Testkunde angelegt",
    alreadyExists: "Diese E-Mail-Adresse gehört bereits zu einem Lizenzmanager.",
    error: "Der Testkunde konnte nicht angelegt werden.",
  },
  Invitation: {
    list: {
      title: "Manager-Einladungen",
      hint: "Manager laden Sie auf der Seite ihres B2B-Accounts im CRM ein.",
    },
    fields: {
      email: "E-Mail",
      account: "Salesforce-Account",
      status: "Status",
      createdAt: "Erstellt am",
    },
  },
  Procedure: {
    name: "Maßnahme",
    title: "Maßnahme",
    organization: "Organisation",
    fields: {
      externalId: "Externe ID",
      fhirId: "FHIR ID",
      status: {
        PREPARATION: "Vorbereitung",
        IN_PROGRESS: "In Bearbeitung",
        COMPLETED: "Abgeschlossen",
        NOT_DONE: "Nicht durchgeführt",
        ON_HOLD: "Pausiert",
        STOPPED: "Gestoppt",
        ENTERED_IN_ERROR: "Fehlerhaft",
        UNKNOWN: "Unbekannt",
      },
      sourceSystem: {
        senso: "Senso",
        vivendi: "Vivendi",
        manual: "Manuell",
        system: "System",
        m4c: "M4C",
        medifox_dan: "Medifox Dan",
        mynerva: "Mynerva",
      },
      codeDisplay: "Maßnahme",
      description: "Beschreibung",
      patient: "Patient",
      patients: "Patienten",
      otherPatients: "Weitere Patienten",
      noPatients: "Keine Patienten",
      performer: "Durchführender",
      recorder: "Aufzeichnender",
      plannedStart: "Geplant Start",
      plannedEnd: "Geplant Ende",
      performedStart: "Durchgeführt Start",
      performedEnd: "Durchgeführt Ende",
      acknowledged: "Quittiert",
      acknowledgedAt: "Quittiert am",
      documentationSync: "Übertragung",
      documentationPending: "Dokumentation ausstehend",
      documentationPublished: "Finalisiert",
      medicationName: "Medikament",
      plannedDose: "Geplante Dosis",
      executedDose: "Verabreichte Dosis",
      doseUnit: "Einheit",
      vitalSignType: "Vitalzeichen",
      vitalSignValue: "Wert",
      vitalSignUnit: "Einheit",
      notes: "Notizen",
      documentation: "Dokumentation",
      manualNote: "Notiz (manuell)",
      aiNote: "Notiz (KI)",
      aiSummary: "Zusammenfassung (KI)",
      activityDocumentation: "Finale Aktivitätsdokumentation",
      organization: "Organisation",
      createdAt: "Erstellt am",
      updatedAt: "Aktualisiert am",
      activitySessions: "Aktivitätssitzungen",
      sessionCount: "eine Sitzung |||| %{smart_count} Sitzungen",
      sessionStart: "Sitzungsstart",
      sessionEnd: "Sitzungsende",
      caregiver: "Betreuer",
      participants: "Teilnehmer",
      duration: "Dauer",
      unknownActivity: "Unbekannte Aktivität",
    },
    titles: {
      details: "Details",
      medication: "Medikament",
      vitalSigns: "Vitalzeichen",
      timing: "Zeitplanung",
      participants: "Beteiligte",
      notes: "Notizen",
      metadata: "Metadaten",
      activitySessions: "Aktivitätssitzungen",
    },
    session: {
      subtitle: "Einzelne App-Sitzungen, die im Rahmen dieser Maßnahme durchgeführt werden.",
      order: "Sitzung %{number}",
      notStarted: "Noch nicht gestartet",
      notAssigned: "Nicht zugewiesen",
      removeAction: "Sitzung entfernen",
      removeTitle: "Sitzung entfernen?",
      removeContent:
        'Möchten Sie "%{title}" aus dieser Maßnahme entfernen? Diese Aktion kann nicht rückgängig gemacht werden.',
      removeSuccess: "Sitzung wurde entfernt",
      removeError: "Sitzung konnte nicht entfernt werden",
      emptyTitle: "Keine Sitzungen",
      emptySubtitle: "Dieser Maßnahme sind derzeit keine Aktivitätssitzungen zugeordnet.",
      status: {
        pending: "Ausstehend",
        running: "Läuft",
        done: "Erledigt",
      },
    },
  },
  Patient: {
    name: "Klient",
    title: "Klient",
    countLabel: "Anzahl Klienten",
    fields: {
      sourceSystem: {
        senso: "Senso",
        vivendi: "Vivendi",
        m4c: "M4C",
        medifox_dan: "Medifox Dan",
        mynerva: "Mynerva",
      },
    },
  },
  Device: {
    title: "App",
  },
  Practitioner: {
    name: "Mitarbeiter",
    title: "Mitarbeiter",
    fields: {
      sourceSystem: {
        senso: "Senso",
        vivendi: "Vivendi",
        m4c: "M4C",
        medifox_dan: "Medifox Dan",
        mynerva: "Mynerva",
      },
    },
  },
  Location: {
    name: "Standort",
    title: "Standort",
    fields: {
      sourceSystem: {
        senso: "Senso",
        vivendi: "Vivendi",
        m4c: "M4C",
        medifox_dan: "Medifox Dan",
        mynerva: "Mynerva",
      },
    },
  },
};
